import * as e from "react";
import t, { useCallback as n, useEffect as r, useRef as i, useState as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var s = Object.create, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, d = Object.getPrototypeOf, f = Object.prototype.hasOwnProperty, p = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, m = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), h = (e, t) => {
	let n = {};
	for (var r in e) c(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || c(n, Symbol.toStringTag, { value: "Module" }), n;
}, g = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = u(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !f.call(e, s) && s !== n && c(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = l(t, s)) || r.enumerable
	});
	return e;
}, _ = (e, t, n) => (n = e == null ? {} : s(d(e)), g(t || !e || !e.__esModule || !f.call(e, "default") ? c(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), v = (e) => f.call(e, "module.exports") ? e["module.exports"] : g(c({}, "__esModule", { value: !0 }), e), y = /* @__PURE__ */ m(((e, t) => {
	var n = Object.defineProperty, r = Object.defineProperties, i = Object.getOwnPropertyDescriptor, a = Object.getOwnPropertyDescriptors, o = Object.getOwnPropertyNames, s = Object.getOwnPropertySymbols, c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable, u = (e, t, r) => t in e ? n(e, t, {
		enumerable: !0,
		configurable: !0,
		writable: !0,
		value: r
	}) : e[t] = r, d = (e, t) => {
		for (var n in t ||= {}) c.call(t, n) && u(e, n, t[n]);
		if (s) for (var n of s(t)) l.call(t, n) && u(e, n, t[n]);
		return e;
	}, f = (e, t) => r(e, a(t)), p = (e, t) => {
		for (var r in t) n(e, r, {
			get: t[r],
			enumerable: !0
		});
	}, m = (e, t, r, a) => {
		if (t && typeof t == "object" || typeof t == "function") for (let s of o(t)) !c.call(e, s) && s !== r && n(e, s, {
			get: () => t[s],
			enumerable: !(a = i(t, s)) || a.enumerable
		});
		return e;
	}, h = (e) => m(n({}, "__esModule", { value: !0 }), e), g = (e, t, n) => new Promise((r, i) => {
		var a = (e) => {
			try {
				s(n.next(e));
			} catch (e) {
				i(e);
			}
		}, o = (e) => {
			try {
				s(n.throw(e));
			} catch (e) {
				i(e);
			}
		}, s = (e) => e.done ? r(e.value) : Promise.resolve(e.value).then(a, o);
		s((n = n.apply(e, t)).next());
	}), _ = {};
	p(_, {
		AggregateError: () => k,
		AllProviderEvents: () => N,
		AllProviderStatus: () => re,
		BaseComparisonStrategy: () => ce,
		BaseEvaluationStrategy: () => j,
		BaseFirstMatchStrategy: () => M,
		BaseFirstSuccessfulStrategy: () => se,
		ClientProviderEvents: () => N,
		ClientProviderStatus: () => re,
		DefaultLogger: () => I,
		ErrorCode: () => b,
		ErrorWithCode: () => ie,
		FlagNotFoundError: () => S,
		GeneralError: () => C,
		GenericEventEmitter: () => de,
		InvalidContextError: () => w,
		LOG_LEVELS: () => L,
		MapHookData: () => v,
		OpenFeatureCommonAPI: () => V,
		OpenFeatureError: () => x,
		ParseError: () => ee,
		ProviderFatalError: () => T,
		ProviderNotReadyError: () => E,
		ProviderWrapper: () => B,
		SafeLogger: () => ue,
		ServerProviderEvents: () => le,
		ServerProviderStatus: () => ne,
		StandardResolutionReasons: () => y,
		StatusTracker: () => oe,
		TargetingKeyMissingError: () => D,
		TelemetryAttribute: () => R,
		TelemetryFlagMetadata: () => fe,
		TypeMismatchError: () => te,
		constructAggregateError: () => A,
		createEvaluationEvent: () => me,
		instantiateErrorByErrorCode: () => O,
		isObject: () => _e,
		isString: () => he,
		objectOrUndefined: () => z,
		statusMatchesEvent: () => F,
		stringOrUndefined: () => ge,
		throwAggregateErrorFromPromiseResults: () => ae
	}), t.exports = h(_);
	var v = class {
		constructor() {
			this.data = /* @__PURE__ */ new Map();
		}
		set(e, t) {
			this.data.set(e, t);
		}
		get(e) {
			return this.data.get(e);
		}
		has(e) {
			return this.data.has(e);
		}
		delete(e) {
			return this.data.delete(e);
		}
		clear() {
			this.data.clear();
		}
	}, y = {
		STATIC: "STATIC",
		DEFAULT: "DEFAULT",
		TARGETING_MATCH: "TARGETING_MATCH",
		SPLIT: "SPLIT",
		CACHED: "CACHED",
		DISABLED: "DISABLED",
		UNKNOWN: "UNKNOWN",
		STALE: "STALE",
		ERROR: "ERROR"
	}, b = /* @__PURE__ */ ((e) => (e.PROVIDER_NOT_READY = "PROVIDER_NOT_READY", e.PROVIDER_FATAL = "PROVIDER_FATAL", e.FLAG_NOT_FOUND = "FLAG_NOT_FOUND", e.PARSE_ERROR = "PARSE_ERROR", e.TYPE_MISMATCH = "TYPE_MISMATCH", e.TARGETING_KEY_MISSING = "TARGETING_KEY_MISSING", e.INVALID_CONTEXT = "INVALID_CONTEXT", e.GENERAL = "GENERAL", e))(b || {}), x = class e extends Error {
		constructor(t, n) {
			super(t), Object.setPrototypeOf(this, e.prototype), this.name = "OpenFeatureError", this.cause = n?.cause;
		}
	}, S = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "FlagNotFoundError", this.code = "FLAG_NOT_FOUND";
		}
	}, C = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "GeneralError", this.code = "GENERAL";
		}
	}, w = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "InvalidContextError", this.code = "INVALID_CONTEXT";
		}
	}, ee = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ParseError", this.code = "PARSE_ERROR";
		}
	}, T = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ProviderFatalError", this.code = "PROVIDER_FATAL";
		}
	}, E = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ProviderNotReadyError", this.code = "PROVIDER_NOT_READY";
		}
	}, D = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "TargetingKeyMissingError", this.code = "TARGETING_KEY_MISSING";
		}
	}, te = class e extends x {
		constructor(t, n) {
			super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "TypeMismatchError", this.code = "TYPE_MISMATCH";
		}
	}, O = (e, t) => {
		switch (e) {
			case "FLAG_NOT_FOUND": return new S(t);
			case "PARSE_ERROR": return new ee(t);
			case "TYPE_MISMATCH": return new te(t);
			case "TARGETING_KEY_MISSING": return new D(t);
			case "INVALID_CONTEXT": return new w(t);
			case "PROVIDER_NOT_READY": return new E(t);
			case "PROVIDER_FATAL": return new T(t);
			default: return new C(t);
		}
	}, ne = /* @__PURE__ */ ((e) => (e.NOT_READY = "NOT_READY", e.READY = "READY", e.ERROR = "ERROR", e.STALE = "STALE", e.FATAL = "FATAL", e))(ne || {}), re = /* @__PURE__ */ ((e) => (e.NOT_READY = "NOT_READY", e.READY = "READY", e.ERROR = "ERROR", e.STALE = "STALE", e.FATAL = "FATAL", e.RECONCILING = "RECONCILING", e))(re || {}), ie = class extends x {
		constructor(e, t) {
			super(t), this.code = e;
		}
	}, k = class e extends C {
		constructor(t, n) {
			super(t), this.originalErrors = n, Object.setPrototypeOf(this, e.prototype), this.name = "AggregateError";
		}
	}, A = (e) => {
		let t = e.map(({ providerName: e, error: t }) => ({
			source: e,
			error: t
		})).flat(), n = t[0];
		return new k(n ? `Provider errors occurred: ${n.source}: ${n.error}` : "Provider errors occurred", t);
	}, ae = (e, t) => {
		let n = e.map((e, n) => e.status === "rejected" ? {
			error: e.reason,
			providerName: t[n].name
		} : null).filter((e) => !!e);
		if (n.length) throw A(n);
	}, oe = class {
		constructor(e, t, n) {
			this.events = e, this.statusEnum = t, this.eventEnum = n, this.providerStatuses = {};
		}
		wrapEventHandler(e) {
			var t, n, r, i, a;
			let o = e.provider;
			(t = o.events) == null || t.addHandler(this.eventEnum.Error, (t) => {
				this.changeProviderStatus(e.name, this.statusEnum.ERROR, t);
			}), (n = o.events) == null || n.addHandler(this.eventEnum.Stale, (t) => {
				this.changeProviderStatus(e.name, this.statusEnum.STALE, t);
			}), (r = o.events) == null || r.addHandler(this.eventEnum.ConfigurationChanged, (e) => {
				this.events.emit(this.eventEnum.ConfigurationChanged, e);
			}), (i = o.events) == null || i.addHandler(this.eventEnum.Ready, (t) => {
				this.changeProviderStatus(e.name, this.statusEnum.READY, t);
			});
			let s = this.eventEnum.Reconciling, c = this.statusEnum.RECONCILING;
			s && c && ((a = o.events) == null || a.addHandler(s, (t) => {
				this.changeProviderStatus(e.name, c, t);
			}));
		}
		providerStatus(e) {
			return this.providerStatuses[e];
		}
		getStatusFromProviderStatuses() {
			let e = Object.values(this.providerStatuses);
			return e.includes(this.statusEnum.FATAL) ? this.statusEnum.FATAL : e.includes(this.statusEnum.NOT_READY) ? this.statusEnum.NOT_READY : e.includes(this.statusEnum.ERROR) ? this.statusEnum.ERROR : e.includes(this.statusEnum.STALE) ? this.statusEnum.STALE : this.statusEnum.RECONCILING && e.includes(this.statusEnum.RECONCILING) ? this.statusEnum.RECONCILING : this.statusEnum.READY;
		}
		changeProviderStatus(e, t, n) {
			let r = this.getStatusFromProviderStatuses();
			this.providerStatuses[e] = t;
			let i = this.getStatusFromProviderStatuses();
			if (r !== i) {
				if (i === this.statusEnum.FATAL || i === this.statusEnum.ERROR) this.events.emit(this.eventEnum.Error, n);
				else if (i === this.statusEnum.STALE) this.events.emit(this.eventEnum.Stale, n);
				else if (i === this.statusEnum.READY) this.events.emit(this.eventEnum.Ready, n);
				else {
					let e = this.eventEnum.Reconciling;
					e && this.statusEnum.RECONCILING && i === this.statusEnum.RECONCILING && this.events.emit(e, n);
				}
			}
		}
	}, j = class {
		constructor(e) {
			this.statusEnum = e, this.runMode = "sequential";
		}
		shouldEvaluateThisProvider(e, t) {
			return e.providerStatus !== this.statusEnum.NOT_READY && e.providerStatus !== this.statusEnum.FATAL;
		}
		shouldEvaluateNextProvider(e, t, n) {
			return !0;
		}
		shouldTrackWithThisProvider(e, t, n, r) {
			return e.providerStatus !== this.statusEnum.NOT_READY && e.providerStatus !== this.statusEnum.FATAL;
		}
		hasError(e) {
			return "thrownError" in e || !!e.details.errorCode;
		}
		hasErrorWithCode(e, t) {
			return "thrownError" in e ? e.thrownError?.code === t : e.details.errorCode === t;
		}
		collectProviderErrors(e) {
			let t = [];
			for (let n of e) "thrownError" in n ? t.push({
				providerName: n.providerName,
				error: n.thrownError
			}) : n.details.errorCode && t.push({
				providerName: n.providerName,
				error: new ie(n.details.errorCode, n.details.errorMessage ?? "unknown error")
			});
			return { errors: t };
		}
		resolutionToFinalResult(e) {
			return {
				details: e.details,
				provider: e.provider,
				providerName: e.providerName
			};
		}
	}, M = class extends j {
		shouldEvaluateNextProvider(e, t, n) {
			return this.hasErrorWithCode(n, "FLAG_NOT_FOUND") ? !0 : (this.hasError(n), !1);
		}
		determineFinalResult(e, t, n) {
			let r = n[n.length - 1];
			return this.hasError(r) ? this.collectProviderErrors(n) : this.resolutionToFinalResult(r);
		}
	}, se = class extends j {
		shouldEvaluateNextProvider(e, t, n) {
			return this.hasError(n);
		}
		determineFinalResult(e, t, n) {
			let r = n[n.length - 1];
			return this.hasError(r) ? this.collectProviderErrors(n) : this.resolutionToFinalResult(r);
		}
	}, ce = class extends j {
		constructor(e, t, n) {
			super(e), this.fallbackProvider = t, this.onMismatch = n, this.runMode = "parallel";
		}
		determineFinalResult(e, t, n) {
			var r;
			let i, a, o, s = !1;
			for (let [e, t] of n.entries()) {
				if (this.hasError(t)) return this.collectProviderErrors(n);
				t.provider === this.fallbackProvider && (a = t), e === 0 && (o = t), i !== void 0 && i !== t.details.value ? s = !0 : i = t.details.value;
			}
			if (!a) throw new C("Fallback provider not found in resolution results");
			if (!o) throw new C("Final resolution not found in resolution results");
			return s ? ((r = this.onMismatch) == null || r.call(this, n), {
				details: a.details,
				provider: a.provider
			}) : this.resolutionToFinalResult(o);
		}
	}, le = /* @__PURE__ */ ((e) => (e.Ready = "PROVIDER_READY", e.Error = "PROVIDER_ERROR", e.ConfigurationChanged = "PROVIDER_CONFIGURATION_CHANGED", e.Stale = "PROVIDER_STALE", e))(le || {}), N = /* @__PURE__ */ ((e) => (e.Ready = "PROVIDER_READY", e.Error = "PROVIDER_ERROR", e.ConfigurationChanged = "PROVIDER_CONFIGURATION_CHANGED", e.ContextChanged = "PROVIDER_CONTEXT_CHANGED", e.Reconciling = "PROVIDER_RECONCILING", e.Stale = "PROVIDER_STALE", e))(N || {}), P = {
		READY: "PROVIDER_READY",
		ERROR: "PROVIDER_ERROR",
		FATAL: "PROVIDER_ERROR",
		STALE: "PROVIDER_STALE",
		RECONCILING: "PROVIDER_RECONCILING",
		NOT_READY: void 0
	}, F = (e, t) => !t && e === "PROVIDER_READY" || P[t] === e, I = class {
		error(...e) {
			console.error(...e);
		}
		warn(...e) {
			console.warn(...e);
		}
		info() {}
		debug() {}
	}, L = [
		"error",
		"warn",
		"info",
		"debug"
	], ue = class {
		constructor(e) {
			this.fallbackLogger = new I();
			try {
				for (let t of L) if (!e[t] || typeof e[t] != "function") throw Error(`The provided logger is missing the ${t} method.`);
				this.logger = e;
			} catch (e) {
				console.error(e), console.error("Falling back to the default logger."), this.logger = this.fallbackLogger;
			}
		}
		error(...e) {
			this.log("error", ...e);
		}
		warn(...e) {
			this.log("warn", ...e);
		}
		info(...e) {
			this.log("info", ...e);
		}
		debug(...e) {
			this.log("debug", ...e);
		}
		log(e, ...t) {
			try {
				this.logger[e](...t);
			} catch {
				this.fallbackLogger[e](...t);
			}
		}
	}, de = class {
		constructor(e) {
			this.globalLogger = e, this._handlers = {
				PROVIDER_CONFIGURATION_CHANGED: /* @__PURE__ */ new WeakMap(),
				PROVIDER_CONTEXT_CHANGED: /* @__PURE__ */ new WeakMap(),
				PROVIDER_READY: /* @__PURE__ */ new WeakMap(),
				PROVIDER_ERROR: /* @__PURE__ */ new WeakMap(),
				PROVIDER_STALE: /* @__PURE__ */ new WeakMap(),
				PROVIDER_RECONCILING: /* @__PURE__ */ new WeakMap()
			};
		}
		emit(e, t) {
			this.eventEmitter.emit(e, t);
		}
		addHandler(e, t) {
			let n = (e) => g(this, null, function* () {
				var n;
				try {
					yield t(e);
				} catch (e) {
					(n = this._logger) == null || n.error("Error running event handler:", e);
				}
			}), r = this._handlers[e].get(t);
			this._handlers[e].set(t, [...r || [], n]), this.eventEmitter.on(e, n);
		}
		removeHandler(e, t) {
			let n = this._handlers[e].get(t);
			if (n) {
				let t = n.pop();
				t && this.eventEmitter.removeListener(e, t);
			}
		}
		removeAllHandlers(e) {
			e ? this.eventEmitter.removeAllListeners(e) : this.eventEmitter.removeAllListeners();
		}
		getHandlers(e) {
			return this.eventEmitter.listeners(e);
		}
		setLogger(e) {
			return this._eventLogger = new ue(e), this;
		}
		get _logger() {
			return this._eventLogger ?? this.globalLogger?.call(this);
		}
	}, R = {
		KEY: "feature_flag.key",
		ERROR_CODE: "error.type",
		ERROR_MESSAGE: "error.message",
		VARIANT: "feature_flag.result.variant",
		VALUE: "feature_flag.result.value",
		CONTEXT_ID: "feature_flag.context.id",
		REASON: "feature_flag.result.reason",
		PROVIDER: "feature_flag.provider.name",
		FLAG_SET_ID: "feature_flag.set.id",
		VERSION: "feature_flag.version"
	}, fe = {
		CONTEXT_ID: "contextId",
		FLAG_SET_ID: "flagSetId",
		VERSION: "version"
	}, pe = "feature_flag.evaluation";
	function me(e, t) {
		let n = {
			[R.KEY]: e.flagKey,
			[R.PROVIDER]: e.providerMetadata.name,
			[R.REASON]: (t.reason ?? y.UNKNOWN).toLowerCase()
		};
		if (t.variant && (n[R.VARIANT] = t.variant), t.value !== null) {
			if (typeof t.value != "object") n[R.VALUE] = t.value;
			else try {
				n[R.VALUE] = JSON.stringify(t.value);
			} catch {}
		}
		let r = t.flagMetadata[fe.CONTEXT_ID] ?? e.context.targetingKey;
		r && (n[R.CONTEXT_ID] = r);
		let i = t.flagMetadata[fe.FLAG_SET_ID];
		i && (n[R.FLAG_SET_ID] = i);
		let a = t.flagMetadata[fe.VERSION];
		return a && (n[R.VERSION] = a), t.reason === y.ERROR && (n[R.ERROR_CODE] = (t.errorCode ?? "GENERAL").toLowerCase(), t.errorMessage && (n[R.ERROR_MESSAGE] = t.errorMessage)), {
			name: pe,
			attributes: n
		};
	}
	function he(e) {
		return typeof e == "string";
	}
	function ge(e) {
		return he(e) ? e : void 0;
	}
	function _e(e) {
		return typeof e == "object";
	}
	function z(e) {
		return _e(e) ? e : void 0;
	}
	function ve(e) {
		return e != null;
	}
	var B = class {
		constructor(e, t, n) {
			this._provider = e, this._status = t, this._pendingContextChanges = 0;
			var r, i, a;
			(r = e.events) == null || r.addHandler("PROVIDER_READY", () => {
				this._status = n.READY;
			}), (i = e.events) == null || i.addHandler("PROVIDER_STALE", () => {
				this._status = n.STALE;
			}), (a = e.events) == null || a.addHandler("PROVIDER_ERROR", (e) => {
				this._status = e?.errorCode === "PROVIDER_FATAL" ? n.FATAL : n.ERROR;
			});
		}
		get provider() {
			return this._provider;
		}
		set provider(e) {
			this._provider = e;
		}
		get status() {
			return this._status;
		}
		set status(e) {
			this._status = e;
		}
		get allContextChangesSettled() {
			return this._pendingContextChanges === 0;
		}
		incrementPendingContextChanges() {
			this._pendingContextChanges++;
		}
		decrementPendingContextChanges() {
			this._pendingContextChanges--;
		}
	}, V = class {
		constructor(e) {
			this._hooks = [], this._context = {}, this._logger = new I(), this._clientEventHandlers = /* @__PURE__ */ new Map(), this._domainScopedContext = /* @__PURE__ */ new Map(), this._clientEvents = /* @__PURE__ */ new Map(), this._runsOn = e;
		}
		addHooks(...e) {
			return this._hooks = [...this._hooks, ...e], this;
		}
		getHooks() {
			return this._hooks;
		}
		clearHooks() {
			return this._hooks = [], this;
		}
		setLogger(e) {
			return this._logger = new ue(e), this;
		}
		get providerMetadata() {
			return this.getProviderMetadata();
		}
		getProviderMetadata(e) {
			return this.getProviderForClient(e).metadata;
		}
		addHandler(e, t, n) {
			[.../* @__PURE__ */ new Map([[void 0, this._defaultProvider]]), ...this._domainScopedProviders].forEach((n) => {
				var r;
				let i = n[0], a = n[1].provider, o = n[1].status;
				if (F(e, o)) try {
					t({
						domain: i,
						providerName: a.metadata.name
					});
				} catch (e) {
					(r = this._logger) == null || r.error("Error running event handler:", e);
				}
			}), this._apiEmitter.addHandler(e, t), n?.signal && typeof n.signal.addEventListener == "function" && n.signal.addEventListener("abort", () => {
				this.removeHandler(e, t);
			});
		}
		removeHandler(e, t) {
			this._apiEmitter.removeHandler(e, t);
		}
		clearHandlers() {
			this._apiEmitter.removeAllHandlers();
		}
		getHandlers(e) {
			return this._apiEmitter.getHandlers(e);
		}
		setAwaitableProvider(e, t) {
			var n, r;
			let i = ge(e), a = z(e) ?? z(t);
			if (!a) {
				this._logger.debug("No provider defined, ignoring setProvider call");
				return;
			}
			let o = this.getProviderForClient(i), s = a.metadata.name;
			if (o === a) {
				this._logger.debug("Provider is already set, ignoring setProvider call");
				return;
			}
			if (!a.runsOn) this._logger.debug(`Provider '${a.metadata.name}' has not defined its intended use.`);
			else if (a.runsOn !== this._runsOn) throw new C(`Provider '${a.metadata.name}' is intended for use on the ${a.runsOn}.`);
			let c = this.getAssociatedEventEmitters(i), l, u = new B(a, this._statusEnumType.NOT_READY, this._statusEnumType);
			return typeof a.initialize == "function" && !this.allProviders.includes(a) ? l = ((a.initialize?.call(a, i ? this._domainScopedContext.get(i) ?? this._context : this._context))?.then(() => {
				var e;
				u.status = this._statusEnumType.READY, this.getAssociatedEventEmitters(i).forEach((e) => {
					e?.emit("PROVIDER_READY", {
						clientName: i,
						domain: i,
						providerName: s
					});
				}), (e = this._apiEmitter) == null || e.emit("PROVIDER_READY", {
					clientName: i,
					domain: i,
					providerName: s
				});
			}))?.catch((e) => {
				var t;
				throw e?.code === "PROVIDER_FATAL" ? u.status = this._statusEnumType.FATAL : u.status = this._statusEnumType.ERROR, this.getAssociatedEventEmitters(i).forEach((t) => {
					t?.emit("PROVIDER_ERROR", {
						clientName: i,
						domain: i,
						providerName: s,
						message: e?.message
					});
				}), (t = this._apiEmitter) == null || t.emit("PROVIDER_ERROR", {
					clientName: i,
					domain: i,
					providerName: s,
					message: e?.message
				}), e;
			}) : (u.status = this._statusEnumType.READY, c.forEach((e) => {
				e?.emit("PROVIDER_READY", {
					clientName: i,
					domain: i,
					providerName: s
				});
			}), (n = this._apiEmitter) == null || n.emit("PROVIDER_READY", {
				clientName: i,
				domain: i,
				providerName: s
			})), i ? this._domainScopedProviders.set(i, u) : this._defaultProvider = u, this.transferListeners(o, a, i, c), this.allProviders.includes(o) || (r = (o?.onClose)?.call(o)) == null || r.catch((e) => {
				this._logger.error(`error closing provider: ${e?.message}, ${e?.stack}`);
			}), l;
		}
		getProviderForClient(e) {
			return e ? this._domainScopedProviders.get(e)?.provider ?? this._defaultProvider.provider : this._defaultProvider.provider;
		}
		buildAndCacheEventEmitterForClient(e) {
			let t = this._clientEvents.get(e);
			if (t) return t;
			let n = this._createEventEmitter();
			this._clientEvents.set(e, n);
			let r = this.getProviderForClient(e);
			return Object.values(N).forEach((t) => r.events?.addHandler(t, (i) => g(this, null, function* () {
				n.emit(t, f(d({}, i), {
					clientName: e,
					domain: e,
					providerName: r.metadata.name
				}));
			}))), n;
		}
		getUnboundEmitters() {
			let e = [...this._domainScopedProviders.keys()];
			return [...[...this._clientEvents.keys()].filter(ve).filter((t) => !e.includes(t)).map((e) => this._clientEvents.get(e)), this._clientEvents.get(void 0)].filter(ve);
		}
		getAssociatedEventEmitters(e) {
			return e ? [this.buildAndCacheEventEmitterForClient(e)] : this.getUnboundEmitters();
		}
		transferListeners(e, t, n, r) {
			var i;
			(i = this._clientEventHandlers.get(n)) == null || i.forEach((t) => e.events?.removeHandler(...t));
			let a = Object.values(N).map((e) => [e, (i) => g(this, null, function* () {
				r.forEach((r) => {
					r?.emit(e, f(d({}, i), {
						clientName: n,
						domain: n,
						providerName: t.metadata.name
					}));
				}), this._apiEmitter.emit(e, f(d({}, i), {
					clientName: n,
					domain: n,
					providerName: t.metadata.name
				}));
			})]);
			this._clientEventHandlers.set(n, a), a.forEach((e) => t.events?.addHandler(...e));
		}
		close() {
			return g(this, null, function* () {
				var e;
				try {
					yield ((e = this == null ? void 0 : this._defaultProvider.provider)?.onClose)?.call(e);
				} catch (e) {
					this.handleShutdownError(this._defaultProvider.provider, e);
				}
				let t = Array.from(this._domainScopedProviders);
				yield Promise.all(t.map((e) => g(this, [e], function* ([, e]) {
					var t;
					try {
						yield (e == null ? void 0 : (t = e.provider).onClose)?.call(t);
					} catch (t) {
						this.handleShutdownError(e?.provider, t);
					}
				})));
			});
		}
		clearProvidersAndSetDefault(e) {
			return g(this, null, function* () {
				try {
					yield this.close();
				} catch {
					this._logger.error("Unable to cleanly close providers. Resetting to the default configuration.");
				} finally {
					this._domainScopedProviders.clear(), this._defaultProvider = new B(e, this._statusEnumType.NOT_READY, this._statusEnumType);
				}
			});
		}
		get allProviders() {
			return [...[...this._domainScopedProviders.values()].map((e) => e.provider), this._defaultProvider.provider];
		}
		handleShutdownError(e, t) {
			this._logger.error(`Error during shutdown of provider ${e.metadata.name}: ${t}`), this._logger.error(t?.stack);
		}
	};
})), b = /* @__PURE__ */ m(((e, t) => {
	var n = Object.create, r = Object.defineProperty, i = Object.defineProperties, a = Object.getOwnPropertyDescriptor, o = Object.getOwnPropertyDescriptors, s = Object.getOwnPropertyNames, c = Object.getOwnPropertySymbols, l = Object.getPrototypeOf, u = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable, f = Reflect.get, p = (e, t, n) => t in e ? r(e, t, {
		enumerable: !0,
		configurable: !0,
		writable: !0,
		value: n
	}) : e[t] = n, m = (e, t) => {
		for (var n in t ||= {}) u.call(t, n) && p(e, n, t[n]);
		if (c) for (var n of c(t)) d.call(t, n) && p(e, n, t[n]);
		return e;
	}, h = (e, t) => i(e, o(t)), g = (e, t) => function() {
		return t || (0, e[s(e)[0]])((t = { exports: {} }).exports, t), t.exports;
	}, _ = (e, t) => {
		for (var n in t) r(e, n, {
			get: t[n],
			enumerable: !0
		});
	}, v = (e, t, n, i) => {
		if (t && typeof t == "object" || typeof t == "function") for (let o of s(t)) !u.call(e, o) && o !== n && r(e, o, {
			get: () => t[o],
			enumerable: !(i = a(t, o)) || i.enumerable
		});
		return e;
	}, b = (e, t, n) => (v(e, t, "default"), n && v(n, t, "default")), x = (e, t, i) => (i = e == null ? {} : n(l(e)), v(t || !e || !e.__esModule ? r(i, "default", {
		value: e,
		enumerable: !0
	}) : i, e)), S = (e) => v(r({}, "__esModule", { value: !0 }), e), C = (e, t, n) => f(l(e), n, t), w = (e, t, n) => new Promise((r, i) => {
		var a = (e) => {
			try {
				s(n.next(e));
			} catch (e) {
				i(e);
			}
		}, o = (e) => {
			try {
				s(n.throw(e));
			} catch (e) {
				i(e);
			}
		}, s = (e) => e.done ? r(e.value) : Promise.resolve(e.value).then(a, o);
		s((n = n.apply(e, t)).next());
	}), ee = g({ "../../node_modules/eventemitter3/index.js"(e, t) {
		var n = Object.prototype.hasOwnProperty, r = "~";
		function i() {}
		Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (r = !1));
		function a(e, t, n) {
			this.fn = e, this.context = t, this.once = n || !1;
		}
		function o(e, t, n, i, o) {
			if (typeof n != "function") throw TypeError("The listener must be a function");
			var s = new a(n, i || e, o), c = r ? r + t : t;
			return e._events[c] ? e._events[c].fn ? e._events[c] = [e._events[c], s] : e._events[c].push(s) : (e._events[c] = s, e._eventsCount++), e;
		}
		function s(e, t) {
			--e._eventsCount === 0 ? e._events = new i() : delete e._events[t];
		}
		function c() {
			this._events = new i(), this._eventsCount = 0;
		}
		c.prototype.eventNames = function() {
			var e = [], t, i;
			if (this._eventsCount === 0) return e;
			for (i in t = this._events) n.call(t, i) && e.push(r ? i.slice(1) : i);
			return Object.getOwnPropertySymbols ? e.concat(Object.getOwnPropertySymbols(t)) : e;
		}, c.prototype.listeners = function(e) {
			var t = r ? r + e : e, n = this._events[t];
			if (!n) return [];
			if (n.fn) return [n.fn];
			for (var i = 0, a = n.length, o = Array(a); i < a; i++) o[i] = n[i].fn;
			return o;
		}, c.prototype.listenerCount = function(e) {
			var t = r ? r + e : e, n = this._events[t];
			return n ? n.fn ? 1 : n.length : 0;
		}, c.prototype.emit = function(e, t, n, i, a, o) {
			var s = r ? r + e : e;
			if (!this._events[s]) return !1;
			var c = this._events[s], l = arguments.length, u, d;
			if (c.fn) {
				switch (c.once && this.removeListener(e, c.fn, void 0, !0), l) {
					case 1: return c.fn.call(c.context), !0;
					case 2: return c.fn.call(c.context, t), !0;
					case 3: return c.fn.call(c.context, t, n), !0;
					case 4: return c.fn.call(c.context, t, n, i), !0;
					case 5: return c.fn.call(c.context, t, n, i, a), !0;
					case 6: return c.fn.call(c.context, t, n, i, a, o), !0;
				}
				for (d = 1, u = Array(l - 1); d < l; d++) u[d - 1] = arguments[d];
				c.fn.apply(c.context, u);
			} else {
				var f = c.length, p;
				for (d = 0; d < f; d++) switch (c[d].once && this.removeListener(e, c[d].fn, void 0, !0), l) {
					case 1:
						c[d].fn.call(c[d].context);
						break;
					case 2:
						c[d].fn.call(c[d].context, t);
						break;
					case 3:
						c[d].fn.call(c[d].context, t, n);
						break;
					case 4:
						c[d].fn.call(c[d].context, t, n, i);
						break;
					default:
						if (!u) for (p = 1, u = Array(l - 1); p < l; p++) u[p - 1] = arguments[p];
						c[d].fn.apply(c[d].context, u);
				}
			}
			return !0;
		}, c.prototype.on = function(e, t, n) {
			return o(this, e, t, n, !1);
		}, c.prototype.once = function(e, t, n) {
			return o(this, e, t, n, !0);
		}, c.prototype.removeListener = function(e, t, n, i) {
			var a = r ? r + e : e;
			if (!this._events[a]) return this;
			if (!t) return s(this, a), this;
			var o = this._events[a];
			if (o.fn) o.fn === t && (!i || o.once) && (!n || o.context === n) && s(this, a);
			else {
				for (var c = 0, l = [], u = o.length; c < u; c++) (o[c].fn !== t || i && !o[c].once || n && o[c].context !== n) && l.push(o[c]);
				l.length ? this._events[a] = l.length === 1 ? l[0] : l : s(this, a);
			}
			return this;
		}, c.prototype.removeAllListeners = function(e) {
			var t;
			return e ? (t = r ? r + e : e, this._events[t] && s(this, t)) : (this._events = new i(), this._eventsCount = 0), this;
		}, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, t !== void 0 && (t.exports = c);
	} }), T = {};
	_(T, {
		ComparisonStrategy: () => N,
		FirstMatchStrategy: () => ce,
		FirstSuccessfulStrategy: () => le,
		InMemoryProvider: () => oe,
		MultiProvider: () => F,
		NOOP_PROVIDER: () => te,
		OpenFeature: () => pe,
		OpenFeatureAPI: () => fe,
		OpenFeatureEventEmitter: () => ie,
		ProviderEvents: () => k.ClientProviderEvents,
		ProviderStatus: () => E.ClientProviderStatus,
		TypedInMemoryProvider: () => j
	}), t.exports = S(T);
	var E = y(), D = "No-op", te = new class {
		constructor() {
			this.metadata = { name: "No-op Provider" };
		}
		resolveBooleanEvaluation(e, t) {
			return this.noOp(t);
		}
		resolveStringEvaluation(e, t) {
			return this.noOp(t);
		}
		resolveNumberEvaluation(e, t) {
			return this.noOp(t);
		}
		resolveObjectEvaluation(e, t) {
			return this.noOp(t);
		}
		noOp(e) {
			return {
				value: e,
				reason: D
			};
		}
	}(), O = y(), ne = y(), re = x(ee(), 1), ie = class extends ne.GenericEventEmitter {
		constructor() {
			super(), this.eventEmitter = new re.default();
		}
	}, k = y(), A = y(), ae = class e extends A.OpenFeatureError {
		constructor(t) {
			super(t), Object.setPrototypeOf(this, e.prototype), this.name = "VariantNotFoundError", this.code = A.ErrorCode.GENERAL;
		}
	}, oe = class {
		constructor(e = {}) {
			this.events = new ie(), this.runsOn = "client", this.metadata = { name: "in-memory" }, this._flagConfiguration = m({}, e);
		}
		putConfiguration(e) {
			return w(this, null, function* () {
				try {
					let t = Object.entries(m(m({}, e), this._flagConfiguration)).map(([e]) => e);
					this._flagConfiguration = m({}, e), this.events.emit(k.ClientProviderEvents.ConfigurationChanged, { flagsChanged: t });
				} catch (e) {
					throw this.events.emit(k.ClientProviderEvents.Error), e;
				}
			});
		}
		resolveBooleanEvaluation(e, t, n, r) {
			return this.resolveAndCheckFlag(e, t, n || this._context, r);
		}
		resolveNumberEvaluation(e, t, n, r) {
			return this.resolveAndCheckFlag(e, t, n || this._context, r);
		}
		resolveStringEvaluation(e, t, n, r) {
			return this.resolveAndCheckFlag(e, t, n || this._context, r);
		}
		resolveObjectEvaluation(e, t, n, r) {
			return this.resolveAndCheckFlag(e, t, n || this._context, r);
		}
		resolveAndCheckFlag(e, t, n, r) {
			if (!(e in this._flagConfiguration)) {
				let t = `no flag found with key ${e}`;
				throw r?.debug(t), new O.FlagNotFoundError(t);
			}
			if (this._flagConfiguration[e].disabled) return {
				value: t,
				reason: O.StandardResolutionReasons.DISABLED
			};
			let i = this.resolveFlagWithReason(e, n);
			if (i.value === void 0) {
				let t = `no value associated with variant provided for ${e} found`;
				throw r?.error(t), new ae(t);
			}
			if (typeof i.value != typeof t) throw new O.TypeMismatchError();
			return i;
		}
		resolveFlagWithReason(e, t) {
			try {
				return this.lookupFlagValue(e, t);
			} catch (e) {
				throw e instanceof O.OpenFeatureError ? e : new O.GeneralError(e?.message || "unknown error");
			}
		}
		lookupFlagValue(e, t) {
			let n = this._flagConfiguration[e], r = t && n?.contextEvaluator, i = r ? n.contextEvaluator?.call(n, t) : n.defaultVariant, a = i && n?.variants[i], o = r ? O.StandardResolutionReasons.TARGETING_MATCH : O.StandardResolutionReasons.STATIC;
			return h(m({ value: a }, i && { variant: i }), { reason: o });
		}
	}, j = class e extends oe {
		constructor(e = {}) {
			super(e);
		}
		putConfiguration(t) {
			return w(this, null, function* () {
				yield C(e.prototype, this, "putConfiguration").call(this, t);
			});
		}
	}, M = y(), se = y(), ce = class extends se.BaseFirstMatchStrategy {
		constructor() {
			super(E.ClientProviderStatus);
		}
	}, le = class extends se.BaseFirstSuccessfulStrategy {
		constructor() {
			super(E.ClientProviderStatus);
		}
	}, N = class extends se.BaseComparisonStrategy {
		constructor(e, t) {
			super(E.ClientProviderStatus, e, t);
		}
	}, P = class {
		constructor(e) {
			this.logger = e;
		}
		beforeHooks(e, t, n) {
			var r;
			for (let i of e ?? []) (r = i?.before) == null || r.call(i, t, Object.freeze(n));
		}
		afterHooks(e, t, n, r) {
			var i;
			for (let a of e ?? []) (i = a?.after) == null || i.call(a, t, n, r);
		}
		errorHooks(e, t, n, r) {
			var i;
			for (let a of e ?? []) try {
				(i = a?.error) == null || i.call(a, t, n, r);
			} catch (e) {
				this.logger.error(`Unhandled error during 'error' hook: ${e}`), e instanceof Error && this.logger.error(e.stack);
			}
		}
		finallyHooks(e, t, n, r) {
			var i;
			for (let a of e ?? []) try {
				(i = a?.finally) == null || i.call(a, t, n, r);
			} catch (e) {
				this.logger.error(`Unhandled error during 'finally' hook: ${e}`), e instanceof Error && this.logger.error(e.stack);
			}
		}
	}, F = class e {
		constructor(t, n = new ce(), r = new M.DefaultLogger()) {
			this.constructorProviders = t, this.evaluationStrategy = n, this.logger = r, this.runsOn = "client", this.events = new ie(), this.hookContexts = /* @__PURE__ */ new WeakMap(), this.hookHints = /* @__PURE__ */ new WeakMap(), this.providerEntries = [], this.providerEntriesByName = {}, this.statusTracker = new M.StatusTracker(this.events, E.ClientProviderStatus, k.ClientProviderEvents), this.hookExecutor = new P(this.logger), this.registerProviders(t);
			let i = Object.keys(this.providerEntriesByName).reduce((e, t) => h(m({}, e), { [t]: this.providerEntriesByName[t].provider.metadata }), {});
			this.metadata = h(m({}, i), { name: e.name });
		}
		registerProviders(e) {
			let t = {};
			for (let n of e) {
				let e = n.provider.metadata.name, r = n.name ?? e;
				if (n.name && t[n.name]) throw Error("Provider names must be unique");
				t[r] ?? (t[r] = []), t[r].push(n.provider);
			}
			for (let e of Object.keys(t)) {
				let n = t[e].length > 1;
				for (let r = 0; r < t[e].length; r++) {
					let i = n ? `${e}-${r + 1}` : e;
					this.providerEntriesByName[i] = {
						provider: t[e][r],
						name: i
					}, this.providerEntries.push(this.providerEntriesByName[i]), this.statusTracker.wrapEventHandler(this.providerEntriesByName[i]);
				}
			}
			Object.freeze(this.providerEntries), Object.freeze(this.providerEntriesByName);
		}
		initialize(e) {
			return w(this, null, function* () {
				let t = yield Promise.allSettled(this.providerEntries.map((t) => {
					var n;
					return (n = t.provider).initialize?.call(n, e);
				}));
				(0, M.throwAggregateErrorFromPromiseResults)(t, this.providerEntries);
			});
		}
		onClose() {
			return w(this, null, function* () {
				let e = yield Promise.allSettled(this.providerEntries.map((e) => {
					var t;
					return (t = e.provider).onClose?.call(t);
				}));
				(0, M.throwAggregateErrorFromPromiseResults)(e, this.providerEntries);
			});
		}
		onContextChange(e, t) {
			return w(this, null, function* () {
				var n;
				for (let r of this.providerEntries) yield (n = r.provider).onContextChange?.call(n, e, t);
			});
		}
		resolveBooleanEvaluation(e, t, n) {
			return this.flagResolutionProxy(e, "boolean", t, n);
		}
		resolveStringEvaluation(e, t, n) {
			return this.flagResolutionProxy(e, "string", t, n);
		}
		resolveNumberEvaluation(e, t, n) {
			return this.flagResolutionProxy(e, "number", t, n);
		}
		resolveObjectEvaluation(e, t, n) {
			return this.flagResolutionProxy(e, "object", t, n);
		}
		track(e, t, n) {
			var r, i;
			for (let a of this.providerEntries) {
				if (!a.provider.track) continue;
				let o = {
					provider: a.provider,
					providerName: a.name,
					providerStatus: this.statusTracker.providerStatus(a.name)
				};
				if (this.evaluationStrategy.shouldTrackWithThisProvider(o, t, e, n)) try {
					(i = (r = a.provider).track) == null || i.call(r, e, t, n);
				} catch (t) {
					this.logger.error(`Error tracking event "${e}" with provider "${a.name}":`, t);
				}
			}
		}
		flagResolutionProxy(e, t, n, r) {
			let i = this.hookContexts.get(r), a = this.hookHints.get(r);
			if (!i || !a) throw new M.GeneralError("Hook context not available for evaluation");
			let o = [];
			for (let s of this.providerEntries) {
				let [c, l] = this.evaluateProviderEntry(e, t, n, s, i, a, r);
				if (o.push(l), !c) break;
			}
			let s = o.filter((e) => !!e), c = this.evaluationStrategy.determineFinalResult({
				flagKey: e,
				flagType: t
			}, r, s);
			if (c.errors?.length) throw (0, M.constructAggregateError)(c.errors);
			if (!c.details) throw new M.GeneralError("No result was returned from any provider");
			return c.details;
		}
		evaluateProviderEntry(e, t, n, r, i, a, o) {
			let s, c = r.provider, l = {
				flagKey: e,
				flagType: t,
				provider: c,
				providerName: r.name,
				providerStatus: this.statusTracker.providerStatus(r.name)
			};
			if (!this.evaluationStrategy.shouldEvaluateThisProvider(l, o)) return [!0, null];
			let u;
			try {
				s = this.evaluateProviderAndHooks(e, n, c, i, a), u = {
					details: s,
					provider: c,
					providerName: r.name
				};
			} catch (e) {
				u = {
					thrownError: e,
					provider: c,
					providerName: r.name
				};
			}
			return [this.evaluationStrategy.shouldEvaluateNextProvider(l, o, u), u];
		}
		evaluateProviderAndHooks(e, t, n, r, i) {
			let a;
			try {
				this.hookExecutor.beforeHooks(n.hooks, r, i);
				let o = this.callProviderResolve(n, e, t, r.context);
				a = h(m({}, o), {
					flagMetadata: Object.freeze(o.flagMetadata ?? {}),
					flagKey: e
				}), this.hookExecutor.afterHooks(n.hooks, r, a, i);
			} catch (o) {
				this.hookExecutor.errorHooks(n.hooks, r, o, i), a = this.getErrorEvaluationDetails(e, t, o);
			}
			return this.hookExecutor.finallyHooks(n.hooks, r, a, i), a;
		}
		callProviderResolve(e, t, n, r) {
			switch (typeof n) {
				case "string": return e.resolveStringEvaluation(t, n, r, this.logger);
				case "number": return e.resolveNumberEvaluation(t, n, r, this.logger);
				case "object": return e.resolveObjectEvaluation(t, n, r, this.logger);
				case "boolean": return e.resolveBooleanEvaluation(t, n, r, this.logger);
				default: throw new M.GeneralError("Invalid flag evaluation type");
			}
		}
		get hooks() {
			return [{ before: (e, t) => (this.hookContexts.set(e.context, e), this.hookHints.set(e.context, t ?? {}), e.context) }];
		}
		getErrorEvaluationDetails(e, t, n, r = {}) {
			let i = n?.message;
			return {
				errorCode: n?.code || M.ErrorCode.GENERAL,
				errorMessage: i,
				value: t,
				reason: M.StandardResolutionReasons.ERROR,
				flagMetadata: Object.freeze(r),
				flagKey: e
			};
		}
	}, I = y(), L = y(), ue = class {
		constructor(e, t, n, r, i, a, o) {
			this.providerAccessor = e, this.providerStatusAccessor = t, this.emitterAccessor = n, this.apiContextAccessor = r, this.apiHooksAccessor = i, this.globalLogger = a, this.options = o, this._hooks = [];
		}
		get metadata() {
			return {
				name: this.options.domain ?? this.options.name,
				domain: this.options.domain ?? this.options.name,
				version: this.options.version,
				providerMetadata: this.providerAccessor().metadata
			};
		}
		get providerStatus() {
			return this.providerStatusAccessor();
		}
		addHandler(e, t, n) {
			var r;
			if (this.emitterAccessor().addHandler(e, t), (0, L.statusMatchesEvent)(e, this.providerStatus)) try {
				t({
					clientName: this.metadata.name,
					domain: this.metadata.domain,
					providerName: this._provider.metadata.name
				});
			} catch (e) {
				(r = this._logger) == null || r.error("Error running event handler:", e);
			}
			n?.signal && typeof n.signal.addEventListener == "function" && n.signal.addEventListener("abort", () => {
				this.removeHandler(e, t);
			});
		}
		removeHandler(e, t) {
			this.emitterAccessor().removeHandler(e, t);
		}
		getHandlers(e) {
			return this.emitterAccessor().getHandlers(e);
		}
		setLogger(e) {
			return this._clientLogger = new L.SafeLogger(e), this;
		}
		addHooks(...e) {
			return this._hooks = [...this._hooks, ...e], this;
		}
		getHooks() {
			return this._hooks;
		}
		clearHooks() {
			return this._hooks = [], this;
		}
		getBooleanValue(e, t, n) {
			return this.getBooleanDetails(e, t, n).value;
		}
		getBooleanDetails(e, t, n) {
			return this.evaluate(e, this._provider.resolveBooleanEvaluation, t, "boolean", n);
		}
		getStringValue(e, t, n) {
			return this.getStringDetails(e, t, n).value;
		}
		getStringDetails(e, t, n) {
			return this.evaluate(e, this._provider.resolveStringEvaluation, t, "string", n);
		}
		getNumberValue(e, t, n) {
			return this.getNumberDetails(e, t, n).value;
		}
		getNumberDetails(e, t, n) {
			return this.evaluate(e, this._provider.resolveNumberEvaluation, t, "number", n);
		}
		getObjectValue(e, t, n) {
			return this.getObjectDetails(e, t, n).value;
		}
		getObjectDetails(e, t, n) {
			return this.evaluate(e, this._provider.resolveObjectEvaluation, t, "object", n);
		}
		track(e, t = {}) {
			var n;
			try {
				if (this.shortCircuitIfNotReady(), typeof this._provider.track == "function") {
					let r = Object.freeze(m({}, this.apiContextAccessor((this == null ? void 0 : this.options)?.domain)));
					return (n = this._provider).track?.call(n, e, r, t);
				}
				this._logger.debug("Provider does not support the track function; will no-op.");
			} catch (e) {
				this._logger.debug("Error recording tracking event.", e);
			}
		}
		evaluate(e, t, n, r, i = {}) {
			let a = [
				...this.apiHooksAccessor(),
				...this.getHooks(),
				...i.hooks || [],
				...this._provider.hooks || []
			], o = [...a].reverse(), s = m({}, this.apiContextAccessor((this == null ? void 0 : this.options)?.domain)), c = o.map(() => Object.freeze({
				flagKey: e,
				defaultValue: n,
				flagValueType: r,
				clientMetadata: this.metadata,
				providerMetadata: this._provider.metadata,
				context: s,
				logger: this._logger,
				hookData: new L.MapHookData()
			})), l;
			try {
				this.beforeHooks(a, c, i), this.shortCircuitIfNotReady();
				let r = t.call(this._provider, e, n, s, this._logger), u = h(m({}, r), {
					flagMetadata: Object.freeze(r.flagMetadata ?? {}),
					flagKey: e
				});
				if (u.errorCode) {
					let t = (0, L.instantiateErrorByErrorCode)(u.errorCode, u.errorMessage);
					this.errorHooks(o, c, t, i), l = this.getErrorEvaluationDetails(e, n, t, u.flagMetadata);
				} else this.afterHooks(o, c, u, i), l = u;
			} catch (t) {
				this.errorHooks(o, c, t, i), l = this.getErrorEvaluationDetails(e, n, t);
			}
			return this.finallyHooks(o, c, l, i), l;
		}
		beforeHooks(e, t, n) {
			var r;
			for (let [i, a] of e.entries()) {
				let o = t[e.length - 1 - i];
				Object.freeze(o), Object.freeze(o.context), (r = a?.before) == null || r.call(a, o, Object.freeze(n.hookHints));
			}
		}
		afterHooks(e, t, n, r) {
			var i;
			for (let [a, o] of e.entries()) {
				let e = t[a];
				(i = o?.after) == null || i.call(o, e, n, r.hookHints);
			}
		}
		errorHooks(e, t, n, r) {
			var i;
			for (let [a, o] of e.entries()) try {
				let e = t[a];
				(i = o?.error) == null || i.call(o, e, n, r.hookHints);
			} catch (e) {
				this._logger.error(`Unhandled error during 'error' hook: ${e}`), e instanceof Error && this._logger.error(e.stack), this._logger.error(e?.stack);
			}
		}
		finallyHooks(e, t, n, r) {
			var i;
			for (let [a, o] of e.entries()) try {
				let e = t[a];
				(i = o?.finally) == null || i.call(o, e, n, r.hookHints);
			} catch (e) {
				this._logger.error(`Unhandled error during 'finally' hook: ${e}`), e instanceof Error && this._logger.error(e.stack), this._logger.error(e?.stack);
			}
		}
		get _provider() {
			return this.providerAccessor();
		}
		get _logger() {
			return this._clientLogger || this.globalLogger();
		}
		shortCircuitIfNotReady() {
			if (this.providerStatus === E.ClientProviderStatus.NOT_READY) throw new L.ProviderNotReadyError("provider has not yet initialized");
			if (this.providerStatus === E.ClientProviderStatus.FATAL) throw new L.ProviderFatalError("provider is in an irrecoverable error state");
		}
		getErrorEvaluationDetails(e, t, n, r = {}) {
			let i = n?.message;
			return {
				errorCode: n?.code || L.ErrorCode.GENERAL,
				errorMessage: i,
				value: t,
				reason: L.StandardResolutionReasons.ERROR,
				flagMetadata: Object.freeze(r),
				flagKey: e
			};
		}
	}, de = Symbol.for("@openfeature/web-sdk/api"), R = globalThis, fe = class e extends I.OpenFeatureCommonAPI {
		constructor() {
			super("client"), this._statusEnumType = E.ClientProviderStatus, this._apiEmitter = new ie(), this._defaultProvider = new I.ProviderWrapper(te, E.ClientProviderStatus.NOT_READY, this._statusEnumType), this._domainScopedProviders = /* @__PURE__ */ new Map(), this._createEventEmitter = () => new ie();
		}
		static getInstance() {
			let t = R[de];
			if (t) return t;
			let n = new e();
			return R[de] = n, n;
		}
		getProviderStatus(e) {
			return e ? this._domainScopedProviders.get(e)?.status ?? this._defaultProvider.status : this._defaultProvider.status;
		}
		setProviderAndWait(e, t, n) {
			return w(this, null, function* () {
				let r = (0, I.stringOrUndefined)(e), i = r ? (0, I.objectOrUndefined)(t) : (0, I.objectOrUndefined)(e), a = r ? (0, I.objectOrUndefined)(n) : (0, I.objectOrUndefined)(t);
				a && (r ? this._domainScopedContext.set(r, a) : this._context = a), yield this.setAwaitableProvider(r, i);
			});
		}
		setProvider(e, t, n) {
			let r = (0, I.stringOrUndefined)(e), i = r ? (0, I.objectOrUndefined)(t) : (0, I.objectOrUndefined)(e), a = r ? (0, I.objectOrUndefined)(n) : (0, I.objectOrUndefined)(t);
			a && (r ? this._domainScopedContext.set(r, a) : this._context = a);
			let o = this.setAwaitableProvider(r, i);
			return Promise.resolve(o).catch((e) => {
				this._logger.error("Error during provider initialization:", e);
			}), this;
		}
		getProvider(e) {
			return this.getProviderForClient(e);
		}
		setContext(e, t) {
			return w(this, null, function* () {
				let n = (0, I.stringOrUndefined)(e), r = (0, I.objectOrUndefined)(e) ?? (0, I.objectOrUndefined)(t) ?? {};
				if (n) {
					let e = this._domainScopedProviders.get(n);
					if (e) {
						let t = this.getContext(n);
						this._domainScopedContext.set(n, r), yield this.runProviderContextChangeHandler(n, e, t, r);
					} else this._domainScopedContext.set(n, r);
				} else {
					let e = this._context;
					this._context = r;
					let t = Array.from(this._domainScopedProviders.entries()).filter(([e]) => !this._domainScopedContext.has(e)).reduce((e, [t, n]) => (e.push({
						domain: t,
						wrapper: n
					}), e), []), n = [{
						domain: void 0,
						wrapper: this._defaultProvider
					}, ...t];
					yield Promise.all(n.map((t) => this.runProviderContextChangeHandler(t.domain, t.wrapper, e, r)));
				}
			});
		}
		getContext(e) {
			let t = (0, I.stringOrUndefined)(e);
			if (t) {
				let e = this._domainScopedContext.get(t);
				if (e) return e;
				this._logger.debug(`Unable to find context for '${t}'.`);
			}
			return this._context;
		}
		clearContext(e) {
			return w(this, null, function* () {
				let t = (0, I.stringOrUndefined)(e);
				if (t) {
					let e = this._domainScopedProviders.get(t);
					if (e) {
						let n = this.getContext(t);
						this._domainScopedContext.delete(t);
						let r = this.getContext();
						yield this.runProviderContextChangeHandler(t, e, n, r);
					} else this._domainScopedContext.delete(t);
				} else return this.setContext({});
			});
		}
		clearContexts() {
			return w(this, null, function* () {
				yield this.clearContext(), yield Promise.allSettled(Array.from(this._domainScopedProviders.keys()).map((e) => this.clearContext(e)));
			});
		}
		getClient(e, t) {
			return new ue(() => this.getProviderForClient(e), () => this.getProviderStatus(e), () => this.buildAndCacheEventEmitterForClient(e), (e) => this.getContext(e), () => this.getHooks(), () => this._logger, {
				domain: e,
				version: t
			});
		}
		clearProviders() {
			return w(this, null, function* () {
				yield C(e.prototype, this, "clearProvidersAndSetDefault").call(this, te), this._domainScopedContext.clear();
			});
		}
		runProviderContextChangeHandler(e, t, n, r) {
			return w(this, null, function* () {
				var i, a, o, s;
				let c = t.provider?.metadata?.name || "unnamed-provider";
				try {
					if (typeof t.provider.onContextChange == "function") {
						let a = t.provider.onContextChange(n, r);
						a && typeof a?.then == "function" && (t.incrementPendingContextChanges(), t.status = this._statusEnumType.RECONCILING, this.getAssociatedEventEmitters(e).forEach((t) => {
							t?.emit(k.ClientProviderEvents.Reconciling, {
								domain: e,
								providerName: c
							});
						}), (i = this._apiEmitter) == null || i.emit(k.ClientProviderEvents.Reconciling, {
							domain: e,
							providerName: c
						}), yield a, t.decrementPendingContextChanges());
					}
					t.status = this._statusEnumType.READY, t.allContextChangesSettled && (this.getAssociatedEventEmitters(e).forEach((t) => {
						t?.emit(k.ClientProviderEvents.ContextChanged, {
							clientName: e,
							domain: e,
							providerName: c
						});
					}), (a = this._apiEmitter) == null || a.emit(k.ClientProviderEvents.ContextChanged, {
						clientName: e,
						domain: e,
						providerName: c
					}));
				} catch (n) {
					if (t.decrementPendingContextChanges(), t.status = this._statusEnumType.ERROR, t.allContextChangesSettled) {
						let t = `Error running ${c}'s context change handler: ${n?.message}`;
						(o = this._logger) == null || o.error(`${t}`, n), this.getAssociatedEventEmitters(e).forEach((n) => {
							n?.emit(k.ClientProviderEvents.Error, {
								clientName: e,
								domain: e,
								providerName: c,
								message: t
							});
						}), (s = this._apiEmitter) == null || s.emit(k.ClientProviderEvents.Error, {
							clientName: e,
							domain: e,
							providerName: c,
							message: t
						});
					}
				}
			});
		}
	}, pe = fe.getInstance();
	b(T, y(), t.exports);
})), x = /* @__PURE__ */ m(((e, t) => {
	t.exports = typeof global == "object" && global && global.Object === Object && global;
})), S = /* @__PURE__ */ m(((e, t) => {
	var n = x(), r = typeof self == "object" && self && self.Object === Object && self;
	t.exports = n || r || Function("return this")();
})), C = /* @__PURE__ */ m(((e, t) => {
	t.exports = S().Symbol;
})), w = /* @__PURE__ */ m(((e, t) => {
	var n = C(), r = Object.prototype, i = r.hasOwnProperty, a = r.toString, o = n ? n.toStringTag : void 0;
	function s(e) {
		var t = i.call(e, o), n = e[o];
		try {
			e[o] = void 0;
			var r = !0;
		} catch {}
		var s = a.call(e);
		return r && (t ? e[o] = n : delete e[o]), s;
	}
	t.exports = s;
})), ee = /* @__PURE__ */ m(((e, t) => {
	var n = Object.prototype.toString;
	function r(e) {
		return n.call(e);
	}
	t.exports = r;
})), T = /* @__PURE__ */ m(((e, t) => {
	var n = C(), r = w(), i = ee(), a = "[object Null]", o = "[object Undefined]", s = n ? n.toStringTag : void 0;
	function c(e) {
		return e == null ? e === void 0 ? o : a : s && s in Object(e) ? r(e) : i(e);
	}
	t.exports = c;
})), E = /* @__PURE__ */ m(((e, t) => {
	t.exports = Array.isArray;
})), D = /* @__PURE__ */ m(((e, t) => {
	function n(e) {
		return typeof e == "object" && !!e;
	}
	t.exports = n;
})), te = /* @__PURE__ */ m(((e, t) => {
	var n = T(), r = E(), i = D(), a = "[object String]";
	function o(e) {
		return typeof e == "string" || !r(e) && i(e) && n(e) == a;
	}
	t.exports = o;
})), O, ne = p((() => {
	O = function() {
		function e(e) {
			this.groups = [], this.each = !1, this.context = void 0, this.type = e.type, this.name = e.name, this.target = e.target, this.propertyName = e.propertyName, this.constraints = e?.constraints, this.constraintCls = e.constraintCls, this.validationTypeOptions = e.validationTypeOptions, e.validationOptions && (this.message = e.validationOptions.message, this.groups = e.validationOptions.groups, this.always = e.validationOptions.always, this.each = e.validationOptions.each, this.context = e.validationOptions.context);
		}
		return e;
	}();
})), re, ie = p((() => {
	ne(), re = function() {
		function e() {}
		return e.prototype.transform = function(e) {
			var t = [];
			return Object.keys(e.properties).forEach(function(n) {
				e.properties[n].forEach(function(r) {
					var i = {
						message: r.message,
						groups: r.groups,
						always: r.always,
						each: r.each
					}, a = {
						type: r.type,
						name: r.name,
						target: e.name,
						propertyName: n,
						constraints: r.constraints,
						validationTypeOptions: r.options,
						validationOptions: i
					};
					t.push(new O(a));
				});
			}), t;
		}, e;
	}();
})), k = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/utils/get-global.util.js
function A() {
	if (typeof globalThis < "u") return globalThis;
	if (typeof global < "u") return global;
	if (typeof window < "u") return window;
	if (typeof self < "u") return self;
}
var ae = p((() => {})), oe = p((() => {})), j = p((() => {
	k(), ae(), oe();
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/metadata/MetadataStorage.js
function M() {
	var e = A();
	return e.classValidatorMetadataStorage ||= new N(), e.classValidatorMetadataStorage;
}
var se, ce, le, N, P = p((() => {
	ie(), j(), se = function(e) {
		var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
		if (n) return n.call(e);
		if (e && typeof e.length == "number") return { next: function() {
			return e && r >= e.length && (e = void 0), {
				value: e && e[r++],
				done: !e
			};
		} };
		throw TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}, ce = function(e, t) {
		var n = typeof Symbol == "function" && e[Symbol.iterator];
		if (!n) return e;
		var r = n.call(e), i, a = [], o;
		try {
			for (; (t === void 0 || t-- > 0) && !(i = r.next()).done;) a.push(i.value);
		} catch (e) {
			o = { error: e };
		} finally {
			try {
				i && !i.done && (n = r.return) && n.call(r);
			} finally {
				if (o) throw o.error;
			}
		}
		return a;
	}, le = function(e, t, n) {
		if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
		return e.concat(a || Array.prototype.slice.call(t));
	}, N = function() {
		function e() {
			this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
		}
		return Object.defineProperty(e.prototype, "hasValidationMetaData", {
			get: function() {
				return !!this.validationMetadatas.size;
			},
			enumerable: !1,
			configurable: !0
		}), e.prototype.addValidationSchema = function(e) {
			var t = this;
			new re().transform(e).forEach(function(e) {
				return t.addValidationMetadata(e);
			});
		}, e.prototype.addValidationMetadata = function(e) {
			var t = this.validationMetadatas.get(e.target);
			t ? t.push(e) : this.validationMetadatas.set(e.target, [e]);
		}, e.prototype.addConstraintMetadata = function(e) {
			var t = this.constraintMetadatas.get(e.target);
			t ? t.push(e) : this.constraintMetadatas.set(e.target, [e]);
		}, e.prototype.groupByPropertyName = function(e) {
			var t = {};
			return e.forEach(function(e) {
				t[e.propertyName] || (t[e.propertyName] = []), t[e.propertyName].push(e);
			}), t;
		}, e.prototype.getTargetValidationMetadatas = function(e, t, n, r, i) {
			var a, o, s = function(e) {
				return e.always === void 0 ? e.groups && e.groups.length ? !1 : n : e.always;
			}, c = function(e) {
				return !!(r && (!i || !i.length) && e.groups && e.groups.length);
			}, l = (this.validationMetadatas.get(e) || []).filter(function(n) {
				return n.target !== e && n.target !== t ? !1 : s(n) ? !0 : c(n) ? !1 : i && i.length > 0 ? n.groups && !!n.groups.find(function(e) {
					return i.indexOf(e) !== -1;
				}) : !0;
			}), u = [];
			try {
				for (var d = se(this.validationMetadatas.entries()), f = d.next(); !f.done; f = d.next()) {
					var p = ce(f.value, 2), m = p[0], h = p[1];
					e.prototype instanceof m && u.push.apply(u, le([], ce(h), !1));
				}
			} catch (e) {
				a = { error: e };
			} finally {
				try {
					f && !f.done && (o = d.return) && o.call(d);
				} finally {
					if (a) throw a.error;
				}
			}
			var g = u.filter(function(t) {
				return typeof t.target == "string" || t.target === e || t.target instanceof Function && !(e.prototype instanceof t.target) ? !1 : s(t) ? !0 : c(t) ? !1 : i && i.length > 0 ? t.groups && !!t.groups.find(function(e) {
					return i.indexOf(e) !== -1;
				}) : !0;
			}).filter(function(e) {
				return !l.find(function(t) {
					return t.propertyName === e.propertyName && t.type === e.type;
				});
			});
			return l.concat(g);
		}, e.prototype.getTargetValidatorConstraints = function(e) {
			return this.constraintMetadatas.get(e) || [];
		}, e;
	}();
})), F = p((() => {
	(function() {
		function e() {}
		return e.prototype.toString = function(e, t, n, r) {
			var i = this;
			e === void 0 && (e = !1), t === void 0 && (t = !1), n === void 0 && (n = ""), r === void 0 && (r = !1);
			var a = e ? "\x1B[1m" : "", o = e ? "\x1B[22m" : "", s = function() {
				return (r ? Object.values : Object.keys)(i.constraints ?? {}).join(", ");
			}, c = function(e) {
				return ` - property ${a}${n}${e}${o} has failed the following constraints: ${a}${s()}${o} 
`;
			};
			if (t) {
				var l = Number.isInteger(+this.property) ? `[${this.property}]` : `${n ? "." : ""}${this.property}`;
				return this.constraints ? c(l) : this.children ? this.children.map(function(t) {
					return t.toString(e, !0, `${n}${l}`, r);
				}).join("") : "";
			}
			return `An instance of ${a}${this.target ? this.target.constructor.name : "an object"}${o} has failed the validation:
` + (this.constraints ? c(this.property) : "") + (this.children ? this.children.map(function(t) {
				return t.toString(e, !0, i.property, r);
			}).join("") : "");
		}, e;
	})();
})), I, L = p((() => {
	I = function() {
		function e() {}
		return e.isValid = function(e) {
			var t = this;
			return e !== "isValid" && e !== "getMessage" && Object.keys(this).map(function(e) {
				return t[e];
			}).indexOf(e) !== -1;
		}, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
	}();
})), ue = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/container.js
function de(e) {
	if (fe) try {
		var t = fe.get(e);
		if (t || !pe || !pe.fallback) return t;
	} catch (e) {
		if (!pe || !pe.fallbackOnErrors) throw e;
	}
	return R.get(e);
}
var R, fe, pe, me = p((() => {
	R = new (function() {
		function e() {
			this.instances = [];
		}
		return e.prototype.get = function(e) {
			var t = this.instances.find(function(t) {
				return t.type === e;
			});
			return t || (t = {
				type: e,
				object: new e()
			}, this.instances.push(t)), t.object;
		}, e;
	}())();
})), he = p((() => {})), ge, _e = p((() => {
	me(), ge = function() {
		function e(e, t, n) {
			n === void 0 && (n = !1), this.target = e, this.name = t, this.async = n;
		}
		return Object.defineProperty(e.prototype, "instance", {
			get: function() {
				return de(this.target);
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/register-decorator.js
function z(e) {
	var t;
	if (e.validator instanceof Function) {
		if (t = e.validator, de(N).getTargetValidatorConstraints(e.validator).length > 1) throw `More than one implementation of ValidatorConstraintInterface found for validator on: ${e.target.name}:${e.propertyName}`;
	} else {
		var n = e.validator;
		t = function() {
			function e() {}
			return e.prototype.validate = function(e, t) {
				return n.validate(e, t);
			}, e.prototype.defaultMessage = function(e) {
				return n.defaultMessage ? n.defaultMessage(e) : "";
			}, e;
		}(), M().addConstraintMetadata(new ge(t, e.name, e.async));
	}
	var r = {
		type: e.name && I.isValid(e.name) ? e.name : I.CUSTOM_VALIDATION,
		name: e.name,
		target: e.target,
		propertyName: e.propertyName,
		validationOptions: e.options,
		constraintCls: t,
		constraints: e.constraints
	};
	M().addValidationMetadata(new O(r));
}
var ve = p((() => {
	_e(), ne(), L(), me(), P();
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/common/ValidateBy.js
function B(e, t) {
	return function(n) {
		return e(t && t.each ? "each value in " : "", n);
	};
}
function V(e, t) {
	return function(n, r) {
		z({
			name: e.name,
			target: n.constructor,
			propertyName: r,
			options: t,
			constraints: e.constraints,
			validator: e.validator
		});
	};
}
var ye = p((() => {
	ve();
})), H = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/common/IsOptional.js
function U(e) {
	return function(t, n) {
		var r = {
			type: I.CONDITIONAL_VALIDATION,
			target: t.constructor,
			propertyName: n,
			constraints: [function(e, t) {
				return e[n] !== null && e[n] !== void 0;
			}],
			validationOptions: e
		};
		M().addValidationMetadata(new O(r));
	};
}
var be = p((() => {
	L(), ne(), P();
})), xe = p((() => {})), Se = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/common/ValidateNested.js
function Ce(e) {
	var t = we({}, e), n = t.each ? "each value in " : "";
	return t.message = t.message || n + "nested property $property must be either object or array", function(e, n) {
		var r = {
			type: I.NESTED_VALIDATION,
			target: e.constructor,
			propertyName: n,
			validationOptions: t
		};
		M().addValidationMetadata(new O(r));
	};
}
var we, Te = p((() => {
	L(), ne(), P(), we = function() {
		return we = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}, we.apply(this, arguments);
	};
})), Ee = p((() => {})), De = /* @__PURE__ */ m(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = n;
	function n(e) {
		if (e == null) throw TypeError(`Expected a string but received a ${e}`);
		if (e.constructor.name !== "String") throw TypeError(`Expected a string but received a ${e.constructor.name}`);
	}
	t.exports = e.default, t.exports.default = e.default;
})), Oe = p((() => {})), ke = p((() => {})), Ae = p((() => {})), je = p((() => {})), Me = p((() => {})), Ne = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/common/IsNotEmpty.js
function Pe(e) {
	return e !== "" && e != null;
}
function Fe(e) {
	return V({
		name: Ie,
		validator: {
			validate: function(e, t) {
				return Pe(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property should not be empty";
			}, e)
		}
	}, e);
}
var Ie, Le = p((() => {
	ye(), Ie = "isNotEmpty";
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/common/IsIn.js
function Re(e, t) {
	return Array.isArray(t) && t.some(function(t) {
		return t === e;
	});
}
function ze(e, t) {
	return V({
		name: Be,
		constraints: [e],
		validator: {
			validate: function(e, t) {
				return Re(e, t?.constraints[0]);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be one of the following values: $constraint1";
			}, t)
		}
	}, t);
}
var Be, Ve = p((() => {
	ye(), Be = "isIn";
})), He = p((() => {})), Ue = p((() => {})), We = p((() => {})), Ge = p((() => {})), Ke = p((() => {})), qe = p((() => {})), Je = p((() => {})), Ye = p((() => {})), Xe = p((() => {})), Ze = p((() => {})), Qe = p((() => {})), $e = p((() => {})), et = p((() => {})), tt = p((() => {})), nt = p((() => {})), rt = p((() => {})), it = p((() => {})), at = p((() => {})), ot = p((() => {})), st = p((() => {})), ct = p((() => {})), lt = p((() => {})), ut = p((() => {})), dt = p((() => {})), ft = p((() => {})), pt = p((() => {})), mt = p((() => {})), ht = p((() => {})), gt = p((() => {})), _t = p((() => {})), vt = p((() => {})), yt = p((() => {})), bt = p((() => {})), xt = p((() => {})), St = p((() => {})), Ct = p((() => {})), wt = /* @__PURE__ */ m(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.CountryCodes = void 0, e.default = a;
	var t = n(De());
	function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	var r = /* @__PURE__ */ new Set(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.YE.YT.ZA.ZM.ZW".split(".")), i = /^[a-zA-Z]{2}$/;
	function a(e) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		return (0, t.default)(e), (n.userAssignedCodes || []).reduce(function(e, t) {
			return i.test(t) && e.push(t.toUpperCase()), e;
		}, []).includes(e.toUpperCase()) ? !0 : r.has(e.toUpperCase());
	}
	e.CountryCodes = r;
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/string/IsISO31661Alpha2.js
function Tt(e) {
	return typeof e == "string" && (0, Dt.default)(e);
}
function Et(e) {
	return V({
		name: Ot,
		validator: {
			validate: function(e, t) {
				return Tt(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be a valid ISO31661 Alpha2 code";
			}, e)
		}
	}, e);
}
var Dt, Ot, kt = p((() => {
	ye(), Dt = /* @__PURE__ */ _(wt()), Ot = "isISO31661Alpha2";
})), At = p((() => {})), jt = p((() => {})), Mt = p((() => {})), Nt = p((() => {})), Pt = p((() => {})), Ft = p((() => {})), It = p((() => {})), Lt = p((() => {})), Rt = p((() => {})), zt = p((() => {})), Bt = p((() => {})), Vt = p((() => {})), Ht = p((() => {})), Ut = p((() => {})), Wt = p((() => {})), Gt = p((() => {})), Kt = p((() => {})), qt = p((() => {})), Jt = p((() => {})), Yt = p((() => {})), Xt = p((() => {})), Zt = p((() => {})), Qt = p((() => {})), $t = p((() => {})), en = p((() => {})), tn = p((() => {})), nn = p((() => {})), rn = p((() => {})), an = p((() => {})), on = p((() => {})), sn = p((() => {})), cn = p((() => {})), ln = p((() => {})), un = p((() => {})), dn = p((() => {})), fn = p((() => {})), pn = p((() => {})), mn = p((() => {})), hn = p((() => {})), gn = p((() => {})), _n = p((() => {})), vn = p((() => {})), yn = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/typechecker/IsBoolean.js
function bn(e) {
	return e instanceof Boolean || typeof e == "boolean";
}
function xn(e) {
	return V({
		name: Sn,
		validator: {
			validate: function(e, t) {
				return bn(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be a boolean value";
			}, e)
		}
	}, e);
}
var Sn, Cn = p((() => {
	ye(), Sn = "isBoolean";
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/typechecker/IsDate.js
function wn(e) {
	return e instanceof Date && !isNaN(e.getTime());
}
function Tn(e) {
	return V({
		name: En,
		validator: {
			validate: function(e, t) {
				return wn(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be a Date instance";
			}, e)
		}
	}, e);
}
var En, Dn = p((() => {
	ye(), En = "isDate";
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/typechecker/IsNumber.js
function On(e, t) {
	if (t === void 0 && (t = {}), typeof e != "number") return !1;
	if (e === Infinity || e === -Infinity) return !!t.allowInfinity;
	if (Number.isNaN(e)) return !!t.allowNaN;
	if (t.maxDecimalPlaces !== void 0) {
		var n = 0;
		if (e % 1 != 0 && (n = e.toString().split(".")[1].length), n > t.maxDecimalPlaces) return !1;
	}
	return Number.isFinite(e);
}
function kn(e, t) {
	return e === void 0 && (e = {}), V({
		name: An,
		constraints: [e],
		validator: {
			validate: function(e, t) {
				return On(e, t?.constraints[0]);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be a number conforming to the specified constraints";
			}, t)
		}
	}, t);
}
var An, jn = p((() => {
	ye(), An = "isNumber";
})), Mn = p((() => {})), Nn = p((() => {}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/typechecker/IsString.js
function Pn(e) {
	return e instanceof String || typeof e == "string";
}
function W(e) {
	return V({
		name: Fn,
		validator: {
			validate: function(e, t) {
				return Pn(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be a string";
			}, e)
		}
	}, e);
}
var Fn, In = p((() => {
	ye(), Fn = "isString";
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/typechecker/IsArray.js
function Ln(e) {
	return Array.isArray(e);
}
function Rn(e) {
	return V({
		name: zn,
		validator: {
			validate: function(e, t) {
				return Ln(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be an array";
			}, e)
		}
	}, e);
}
var zn, Bn = p((() => {
	ye(), zn = "isArray";
}));
//#endregion
//#region ../../../node_modules/class-validator/esm5/decorator/typechecker/IsObject.js
function Vn(e) {
	return e != null && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
function Hn(e) {
	return V({
		name: Un,
		validator: {
			validate: function(e, t) {
				return Vn(e);
			},
			defaultMessage: B(function(e) {
				return e + "$property must be an object";
			}, e)
		}
	}, e);
}
var Un, Wn = p((() => {
	ye(), Un = "isObject";
})), Gn = p((() => {})), Kn = p((() => {})), qn = p((() => {})), Jn = p((() => {})), Yn = p((() => {})), Xn = p((() => {})), Zn = p((() => {})), Qn = p((() => {})), $n = p((() => {
	he(), H(), be(), xe(), ye(), Se(), Te(), Ee(), Oe(), ke(), Ae(), je(), Me(), Ne(), Le(), Ve(), He(), Ue(), We(), Ge(), Ke(), qe(), Je(), Ye(), Xe(), Ze(), Qe(), $e(), et(), tt(), nt(), rt(), it(), at(), ot(), st(), ct(), lt(), ut(), dt(), ft(), mt(), ht(), gt(), _t(), vt(), yt(), bt(), xt(), St(), Ct(), kt(), At(), jt(), Mt(), Nt(), Pt(), Ft(), It(), Lt(), Rt(), zt(), Bt(), Vt(), Ht(), Ut(), Wt(), Gt(), Kt(), qt(), Jt(), Yt(), Xt(), Zt(), Qt(), $t(), en(), tn(), nn(), rn(), an(), on(), sn(), cn(), ln(), un(), dn(), fn(), pn(), mn(), hn(), gn(), _n(), vn(), yn(), Cn(), Dn(), jn(), Mn(), Nn(), In(), Bn(), Wn(), Gn(), Kn(), qn(), Jn(), Yn(), Xn(), Zn(), Qn();
})), er = p((() => {})), tr = p((() => {})), nr = p((() => {})), rr = p((() => {})), ir = p((() => {
	me(), $n(), pt(), er(), F(), tr(), nr(), L(), ue(), rr(), ve(), P();
})), ar, or = p((() => {
	(function(e) {
		e[e.PLAIN_TO_CLASS = 0] = "PLAIN_TO_CLASS", e[e.CLASS_TO_PLAIN = 1] = "CLASS_TO_PLAIN", e[e.CLASS_TO_CLASS = 2] = "CLASS_TO_CLASS";
	})(ar ||= {});
})), sr = p((() => {
	or();
})), cr, lr = p((() => {
	sr(), cr = function() {
		function e() {
			this._typeMetadatas = /* @__PURE__ */ new Map(), this._transformMetadatas = /* @__PURE__ */ new Map(), this._exposeMetadatas = /* @__PURE__ */ new Map(), this._excludeMetadatas = /* @__PURE__ */ new Map(), this._ancestorsMap = /* @__PURE__ */ new Map();
		}
		return e.prototype.addTypeMetadata = function(e) {
			this._typeMetadatas.has(e.target) || this._typeMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._typeMetadatas.get(e.target).set(e.propertyName, e);
		}, e.prototype.addTransformMetadata = function(e) {
			this._transformMetadatas.has(e.target) || this._transformMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._transformMetadatas.get(e.target).has(e.propertyName) || this._transformMetadatas.get(e.target).set(e.propertyName, []), this._transformMetadatas.get(e.target).get(e.propertyName).push(e);
		}, e.prototype.addExposeMetadata = function(e) {
			this._exposeMetadatas.has(e.target) || this._exposeMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._exposeMetadatas.get(e.target).set(e.propertyName, e);
		}, e.prototype.addExcludeMetadata = function(e) {
			this._excludeMetadatas.has(e.target) || this._excludeMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._excludeMetadatas.get(e.target).set(e.propertyName, e);
		}, e.prototype.findTransformMetadatas = function(e, t, n) {
			return this.findMetadatas(this._transformMetadatas, e, t).filter(function(e) {
				return !e.options || e.options.toClassOnly === !0 && e.options.toPlainOnly === !0 ? !0 : e.options.toClassOnly === !0 ? n === ar.CLASS_TO_CLASS || n === ar.PLAIN_TO_CLASS : e.options.toPlainOnly !== !0 || n === ar.CLASS_TO_PLAIN;
			});
		}, e.prototype.findExcludeMetadata = function(e, t) {
			return this.findMetadata(this._excludeMetadatas, e, t);
		}, e.prototype.findExposeMetadata = function(e, t) {
			return this.findMetadata(this._exposeMetadatas, e, t);
		}, e.prototype.findExposeMetadataByCustomName = function(e, t) {
			return this.getExposedMetadatas(e).find(function(e) {
				return e.options && e.options.name === t;
			});
		}, e.prototype.findTypeMetadata = function(e, t) {
			return this.findMetadata(this._typeMetadatas, e, t);
		}, e.prototype.getStrategy = function(e) {
			var t = this._excludeMetadatas.get(e), n = t && t.get(void 0), r = this._exposeMetadatas.get(e), i = r && r.get(void 0);
			return n && i || !n && !i ? "none" : n ? "excludeAll" : "exposeAll";
		}, e.prototype.getExposedMetadatas = function(e) {
			return this.getMetadata(this._exposeMetadatas, e);
		}, e.prototype.getExcludedMetadatas = function(e) {
			return this.getMetadata(this._excludeMetadatas, e);
		}, e.prototype.getExposedProperties = function(e, t) {
			return this.getExposedMetadatas(e).filter(function(e) {
				return !e.options || e.options.toClassOnly === !0 && e.options.toPlainOnly === !0 ? !0 : e.options.toClassOnly === !0 ? t === ar.CLASS_TO_CLASS || t === ar.PLAIN_TO_CLASS : e.options.toPlainOnly !== !0 || t === ar.CLASS_TO_PLAIN;
			}).map(function(e) {
				return e.propertyName;
			});
		}, e.prototype.getExcludedProperties = function(e, t) {
			return this.getExcludedMetadatas(e).filter(function(e) {
				return !e.options || e.options.toClassOnly === !0 && e.options.toPlainOnly === !0 ? !0 : e.options.toClassOnly === !0 ? t === ar.CLASS_TO_CLASS || t === ar.PLAIN_TO_CLASS : e.options.toPlainOnly !== !0 || t === ar.CLASS_TO_PLAIN;
			}).map(function(e) {
				return e.propertyName;
			});
		}, e.prototype.clear = function() {
			this._typeMetadatas.clear(), this._exposeMetadatas.clear(), this._excludeMetadatas.clear(), this._ancestorsMap.clear();
		}, e.prototype.getMetadata = function(e, t) {
			var n = e.get(t), r;
			n && (r = Array.from(n.values()).filter(function(e) {
				return e.propertyName !== void 0;
			}));
			for (var i = [], a = 0, o = this.getAncestors(t); a < o.length; a++) {
				var s = o[a], c = e.get(s);
				if (c) {
					var l = Array.from(c.values()).filter(function(e) {
						return e.propertyName !== void 0;
					});
					i.push.apply(i, l);
				}
			}
			return i.concat(r || []);
		}, e.prototype.findMetadata = function(e, t, n) {
			var r = e.get(t);
			if (r) {
				var i = r.get(n);
				if (i) return i;
			}
			for (var a = 0, o = this.getAncestors(t); a < o.length; a++) {
				var s = o[a], c = e.get(s);
				if (c) {
					var l = c.get(n);
					if (l) return l;
				}
			}
		}, e.prototype.findMetadatas = function(e, t, n) {
			var r = e.get(t), i;
			r && (i = r.get(n));
			for (var a = [], o = 0, s = this.getAncestors(t); o < s.length; o++) {
				var c = s[o], l = e.get(c);
				l && l.has(n) && a.push.apply(a, l.get(n));
			}
			return a.slice().reverse().concat((i || []).slice().reverse());
		}, e.prototype.getAncestors = function(e) {
			if (!e) return [];
			if (!this._ancestorsMap.has(e)) {
				for (var t = [], n = Object.getPrototypeOf(e.prototype.constructor); n.prototype !== void 0; n = Object.getPrototypeOf(n.prototype.constructor)) t.push(n);
				this._ancestorsMap.set(e, t);
			}
			return this._ancestorsMap.get(e);
		}, e;
	}();
})), ur, dr = p((() => {
	lr(), ur = new cr();
})), fr = p((() => {})), pr = p((() => {})), mr = p((() => {})), hr = p((() => {})), gr = p((() => {}));
//#endregion
//#region ../../../node_modules/class-transformer/esm5/decorators/transform.decorator.js
function _r(e, t) {
	return t === void 0 && (t = {}), function(n, r) {
		ur.addTransformMetadata({
			target: n.constructor,
			propertyName: r,
			transformFn: e,
			options: t
		});
	};
}
var vr = p((() => {
	dr();
}));
//#endregion
//#region ../../../node_modules/class-transformer/esm5/decorators/type.decorator.js
function yr(e, t) {
	return t === void 0 && (t = {}), function(n, r) {
		var i = Reflect.getMetadata("design:type", n, r);
		ur.addTypeMetadata({
			target: n.constructor,
			propertyName: r,
			reflectedType: i,
			typeFunction: e,
			options: t
		});
	};
}
var br = p((() => {
	dr();
})), xr = p((() => {
	fr(), pr(), mr(), hr(), gr(), vr(), br();
})), Sr = p((() => {})), Cr = p((() => {})), wr = p((() => {})), Tr = p((() => {})), Er = p((() => {})), Dr = p((() => {})), Or = p((() => {})), kr = p((() => {})), Ar = p((() => {})), jr = p((() => {})), Mr = p((() => {})), Nr = p((() => {})), Pr = p((() => {})), Fr = p((() => {})), Ir = p((() => {
	Sr(), Cr(), wr(), Tr(), Er(), Dr(), Or(), kr(), Ar(), jr(), Mr(), Nr(), Pr(), Fr();
})), Lr = p((() => {
	dr(), sr(), xr(), Ir(), sr();
})), Rr, zr = p((() => {
	(function(e) {
		(function(t) {
			var n = typeof global == "object" ? global : typeof self == "object" ? self : typeof this == "object" ? this : Function("return this;")(), r = i(e);
			n.Reflect === void 0 ? n.Reflect = e : r = i(n.Reflect, r), t(r);
			function i(e, t) {
				return function(n, r) {
					typeof e[n] != "function" && Object.defineProperty(e, n, {
						configurable: !0,
						writable: !0,
						value: r
					}), t && t(n, r);
				};
			}
		})(function(e) {
			var t = Object.prototype.hasOwnProperty, n = typeof Symbol == "function", r = n && Symbol.toPrimitive !== void 0 ? Symbol.toPrimitive : "@@toPrimitive", i = n && Symbol.iterator !== void 0 ? Symbol.iterator : "@@iterator", a = typeof Object.create == "function", o = { __proto__: [] } instanceof Array, s = !a && !o, c = {
				create: a ? function() {
					return z(Object.create(null));
				} : o ? function() {
					return z({ __proto__: null });
				} : function() {
					return z({});
				},
				has: s ? function(e, n) {
					return t.call(e, n);
				} : function(e, t) {
					return t in e;
				},
				get: s ? function(e, n) {
					return t.call(e, n) ? e[n] : void 0;
				} : function(e, t) {
					return e[t];
				}
			}, l = Object.getPrototypeOf(Function), u = typeof process == "object" && process.env && process.env.REFLECT_METADATA_USE_MAP_POLYFILL === "true", d = !u && typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : he(), f = !u && typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : ge(), p = new (!u && typeof WeakMap == "function" ? WeakMap : _e())();
			function m(e, t, n, r) {
				if (A(n)) {
					if (!P(e) || !I(t)) throw TypeError();
					return w(e, t);
				}
				if (!P(e) || !j(t) || !j(r) && !A(r) && !ae(r)) throw TypeError();
				return ae(r) && (r = void 0), n = N(n), ee(e, t, n, r);
			}
			e("decorate", m);
			function h(e, t) {
				function n(n, r) {
					if (!j(n) || !A(r) && !L(r)) throw TypeError();
					ne(e, t, n, r);
				}
				return n;
			}
			e("metadata", h);
			function g(e, t, n, r) {
				if (!j(n)) throw TypeError();
				return A(r) || (r = N(r)), ne(e, t, n, r);
			}
			e("defineMetadata", g);
			function _(e, t, n) {
				if (!j(t)) throw TypeError();
				return A(n) || (n = N(n)), E(e, t, n);
			}
			e("hasMetadata", _);
			function v(e, t, n) {
				if (!j(t)) throw TypeError();
				return A(n) || (n = N(n)), D(e, t, n);
			}
			e("hasOwnMetadata", v);
			function y(e, t, n) {
				if (!j(t)) throw TypeError();
				return A(n) || (n = N(n)), te(e, t, n);
			}
			e("getMetadata", y);
			function b(e, t, n) {
				if (!j(t)) throw TypeError();
				return A(n) || (n = N(n)), O(e, t, n);
			}
			e("getOwnMetadata", b);
			function x(e, t) {
				if (!j(e)) throw TypeError();
				return A(t) || (t = N(t)), re(e, t);
			}
			e("getMetadataKeys", x);
			function S(e, t) {
				if (!j(e)) throw TypeError();
				return A(t) || (t = N(t)), ie(e, t);
			}
			e("getOwnMetadataKeys", S);
			function C(e, t, n) {
				if (!j(t)) throw TypeError();
				A(n) || (n = N(n));
				var r = T(t, n, !1);
				if (A(r) || !r.delete(e)) return !1;
				if (r.size > 0) return !0;
				var i = p.get(t);
				return i.delete(n), i.size > 0 || p.delete(t), !0;
			}
			e("deleteMetadata", C);
			function w(e, t) {
				for (var n = e.length - 1; n >= 0; --n) {
					var r = e[n], i = r(t);
					if (!A(i) && !ae(i)) {
						if (!I(i)) throw TypeError();
						t = i;
					}
				}
				return t;
			}
			function ee(e, t, n, r) {
				for (var i = e.length - 1; i >= 0; --i) {
					var a = e[i], o = a(t, n, r);
					if (!A(o) && !ae(o)) {
						if (!j(o)) throw TypeError();
						r = o;
					}
				}
				return r;
			}
			function T(e, t, n) {
				var r = p.get(e);
				if (A(r)) {
					if (!n) return;
					r = new d(), p.set(e, r);
				}
				var i = r.get(t);
				if (A(i)) {
					if (!n) return;
					i = new d(), r.set(t, i);
				}
				return i;
			}
			function E(e, t, n) {
				if (D(e, t, n)) return !0;
				var r = me(t);
				return !ae(r) && E(e, r, n);
			}
			function D(e, t, n) {
				var r = T(t, n, !1);
				return !A(r) && ce(r.has(e));
			}
			function te(e, t, n) {
				if (D(e, t, n)) return O(e, t, n);
				var r = me(t);
				if (!ae(r)) return te(e, r, n);
			}
			function O(e, t, n) {
				var r = T(t, n, !1);
				if (!A(r)) return r.get(e);
			}
			function ne(e, t, n, r) {
				T(n, r, !0).set(e, t);
			}
			function re(e, t) {
				var n = ie(e, t), r = me(e);
				if (r === null) return n;
				var i = re(r, t);
				if (i.length <= 0) return n;
				if (n.length <= 0) return i;
				for (var a = new f(), o = [], s = 0, c = n; s < c.length; s++) {
					var l = c[s], u = a.has(l);
					u || (a.add(l), o.push(l));
				}
				for (var d = 0, p = i; d < p.length; d++) {
					var l = p[d], u = a.has(l);
					u || (a.add(l), o.push(l));
				}
				return o;
			}
			function ie(e, t) {
				var n = [], r = T(e, t, !1);
				if (A(r)) return n;
				for (var i = de(r.keys()), a = 0;;) {
					var o = fe(i);
					if (!o) return n.length = a, n;
					var s = R(o);
					try {
						n[a] = s;
					} catch (e) {
						try {
							pe(i);
						} finally {
							throw e;
						}
					}
					a++;
				}
			}
			function k(e) {
				if (e === null) return 1;
				switch (typeof e) {
					case "undefined": return 0;
					case "boolean": return 2;
					case "string": return 3;
					case "symbol": return 4;
					case "number": return 5;
					case "object": return e === null ? 1 : 6;
					default: return 6;
				}
			}
			function A(e) {
				return e === void 0;
			}
			function ae(e) {
				return e === null;
			}
			function oe(e) {
				return typeof e == "symbol";
			}
			function j(e) {
				return typeof e == "object" ? e !== null : typeof e == "function";
			}
			function M(e, t) {
				switch (k(e)) {
					case 0: return e;
					case 1: return e;
					case 2: return e;
					case 3: return e;
					case 4: return e;
					case 5: return e;
				}
				var n = t === 3 ? "string" : t === 5 ? "number" : "default", i = ue(e, r);
				if (i !== void 0) {
					var a = i.call(e, n);
					if (j(a)) throw TypeError();
					return a;
				}
				return se(e, n === "default" ? "number" : n);
			}
			function se(e, t) {
				if (t === "string") {
					var n = e.toString;
					if (F(n)) {
						var r = n.call(e);
						if (!j(r)) return r;
					}
					var i = e.valueOf;
					if (F(i)) {
						var r = i.call(e);
						if (!j(r)) return r;
					}
				} else {
					var i = e.valueOf;
					if (F(i)) {
						var r = i.call(e);
						if (!j(r)) return r;
					}
					var a = e.toString;
					if (F(a)) {
						var r = a.call(e);
						if (!j(r)) return r;
					}
				}
				throw TypeError();
			}
			function ce(e) {
				return !!e;
			}
			function le(e) {
				return "" + e;
			}
			function N(e) {
				var t = M(e, 3);
				return oe(t) ? t : le(t);
			}
			function P(e) {
				return Array.isArray ? Array.isArray(e) : e instanceof Object ? e instanceof Array : Object.prototype.toString.call(e) === "[object Array]";
			}
			function F(e) {
				return typeof e == "function";
			}
			function I(e) {
				return typeof e == "function";
			}
			function L(e) {
				switch (k(e)) {
					case 3: return !0;
					case 4: return !0;
					default: return !1;
				}
			}
			function ue(e, t) {
				var n = e[t];
				if (n != null) {
					if (!F(n)) throw TypeError();
					return n;
				}
			}
			function de(e) {
				var t = ue(e, i);
				if (!F(t)) throw TypeError();
				var n = t.call(e);
				if (!j(n)) throw TypeError();
				return n;
			}
			function R(e) {
				return e.value;
			}
			function fe(e) {
				var t = e.next();
				return !t.done && t;
			}
			function pe(e) {
				var t = e.return;
				t && t.call(e);
			}
			function me(e) {
				var t = Object.getPrototypeOf(e);
				if (typeof e != "function" || e === l || t !== l) return t;
				var n = e.prototype, r = n && Object.getPrototypeOf(n);
				if (r == null || r === Object.prototype) return t;
				var i = r.constructor;
				return typeof i != "function" || i === e ? t : i;
			}
			function he() {
				var e = {}, t = [], n = function() {
					function e(e, t, n) {
						this._index = 0, this._keys = e, this._values = t, this._selector = n;
					}
					return e.prototype["@@iterator"] = function() {
						return this;
					}, e.prototype[i] = function() {
						return this;
					}, e.prototype.next = function() {
						var e = this._index;
						if (e >= 0 && e < this._keys.length) {
							var n = this._selector(this._keys[e], this._values[e]);
							return e + 1 >= this._keys.length ? (this._index = -1, this._keys = t, this._values = t) : this._index++, {
								value: n,
								done: !1
							};
						}
						return {
							value: void 0,
							done: !0
						};
					}, e.prototype.throw = function(e) {
						throw this._index >= 0 && (this._index = -1, this._keys = t, this._values = t), e;
					}, e.prototype.return = function(e) {
						return this._index >= 0 && (this._index = -1, this._keys = t, this._values = t), {
							value: e,
							done: !0
						};
					}, e;
				}();
				return function() {
					function t() {
						this._keys = [], this._values = [], this._cacheKey = e, this._cacheIndex = -2;
					}
					return Object.defineProperty(t.prototype, "size", {
						get: function() {
							return this._keys.length;
						},
						enumerable: !0,
						configurable: !0
					}), t.prototype.has = function(e) {
						return this._find(e, !1) >= 0;
					}, t.prototype.get = function(e) {
						var t = this._find(e, !1);
						return t >= 0 ? this._values[t] : void 0;
					}, t.prototype.set = function(e, t) {
						var n = this._find(e, !0);
						return this._values[n] = t, this;
					}, t.prototype.delete = function(t) {
						var n = this._find(t, !1);
						if (n >= 0) {
							for (var r = this._keys.length, i = n + 1; i < r; i++) this._keys[i - 1] = this._keys[i], this._values[i - 1] = this._values[i];
							return this._keys.length--, this._values.length--, t === this._cacheKey && (this._cacheKey = e, this._cacheIndex = -2), !0;
						}
						return !1;
					}, t.prototype.clear = function() {
						this._keys.length = 0, this._values.length = 0, this._cacheKey = e, this._cacheIndex = -2;
					}, t.prototype.keys = function() {
						return new n(this._keys, this._values, r);
					}, t.prototype.values = function() {
						return new n(this._keys, this._values, a);
					}, t.prototype.entries = function() {
						return new n(this._keys, this._values, o);
					}, t.prototype["@@iterator"] = function() {
						return this.entries();
					}, t.prototype[i] = function() {
						return this.entries();
					}, t.prototype._find = function(e, t) {
						return this._cacheKey !== e && (this._cacheIndex = this._keys.indexOf(this._cacheKey = e)), this._cacheIndex < 0 && t && (this._cacheIndex = this._keys.length, this._keys.push(e), this._values.push(void 0)), this._cacheIndex;
					}, t;
				}();
				function r(e, t) {
					return e;
				}
				function a(e, t) {
					return t;
				}
				function o(e, t) {
					return [e, t];
				}
			}
			function ge() {
				return function() {
					function e() {
						this._map = new d();
					}
					return Object.defineProperty(e.prototype, "size", {
						get: function() {
							return this._map.size;
						},
						enumerable: !0,
						configurable: !0
					}), e.prototype.has = function(e) {
						return this._map.has(e);
					}, e.prototype.add = function(e) {
						return this._map.set(e, e), this;
					}, e.prototype.delete = function(e) {
						return this._map.delete(e);
					}, e.prototype.clear = function() {
						this._map.clear();
					}, e.prototype.keys = function() {
						return this._map.keys();
					}, e.prototype.values = function() {
						return this._map.values();
					}, e.prototype.entries = function() {
						return this._map.entries();
					}, e.prototype["@@iterator"] = function() {
						return this.keys();
					}, e.prototype[i] = function() {
						return this.keys();
					}, e;
				}();
			}
			function _e() {
				var e = c.create(), n = r();
				return function() {
					function e() {
						this._key = r();
					}
					return e.prototype.has = function(e) {
						var t = i(e, !1);
						return t !== void 0 && c.has(t, this._key);
					}, e.prototype.get = function(e) {
						var t = i(e, !1);
						return t === void 0 ? void 0 : c.get(t, this._key);
					}, e.prototype.set = function(e, t) {
						var n = i(e, !0);
						return n[this._key] = t, this;
					}, e.prototype.delete = function(e) {
						var t = i(e, !1);
						return t !== void 0 && delete t[this._key];
					}, e.prototype.clear = function() {
						this._key = r();
					}, e;
				}();
				function r() {
					var t;
					do
						t = "@@WeakMap@@" + s();
					while (c.has(e, t));
					return e[t] = !0, t;
				}
				function i(e, r) {
					if (!t.call(e, n)) {
						if (!r) return;
						Object.defineProperty(e, n, { value: c.create() });
					}
					return e[n];
				}
				function a(e, t) {
					for (var n = 0; n < t; ++n) e[n] = Math.random() * 255 | 0;
					return e;
				}
				function o(e) {
					return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(e)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(e)) : a(new Uint8Array(e), e) : a(Array(e), e);
				}
				function s() {
					var e = o(16);
					e[6] = e[6] & 79 | 64, e[8] = e[8] & 191 | 128;
					for (var t = "", n = 0; n < 16; ++n) {
						var r = e[n];
						(n === 4 || n === 6 || n === 8) && (t += "-"), r < 16 && (t += "0"), t += r.toString(16).toLowerCase();
					}
					return t;
				}
			}
			function z(e) {
				return e.__ = void 0, delete e.__, e;
			}
		});
	})(Rr ||= {});
})), Br = /* @__PURE__ */ m(((e, t) => {
	var n = T(), r = D(), i = "[object Number]";
	function a(e) {
		return typeof e == "number" || r(e) && n(e) == i;
	}
	t.exports = a;
})), Vr = /* @__PURE__ */ m(((e, t) => {
	var n = T(), r = D(), i = "[object Boolean]";
	function a(e) {
		return e === !0 || e === !1 || r(e) && n(e) == i;
	}
	t.exports = a;
})), Hr = /* @__PURE__ */ m(((e, t) => {
	function n(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	t.exports = n;
})), Ur = /* @__PURE__ */ m(((e, t) => {
	t.exports = Hr()(Object.getPrototypeOf, Object);
})), Wr = /* @__PURE__ */ m(((e, t) => {
	var n = T(), r = Ur(), i = D(), a = "[object Object]", o = Function.prototype, s = Object.prototype, c = o.toString, l = s.hasOwnProperty, u = c.call(Object);
	function d(e) {
		if (!i(e) || n(e) != a) return !1;
		var t = r(e);
		if (t === null) return !0;
		var o = l.call(t, "constructor") && t.constructor;
		return typeof o == "function" && o instanceof o && c.call(o) == u;
	}
	t.exports = d;
})), Gr = /* @__PURE__ */ m(((e, t) => {
	function n(e) {
		return e === null;
	}
	t.exports = n;
})), Kr = /* @__PURE__ */ m(((e, t) => {
	function n(e) {
		return e === void 0;
	}
	t.exports = n;
})), qr, Jr = p((() => {
	qr = {
		aa: {
			name: "Afar",
			nativeName: "Afaraf"
		},
		ab: {
			name: "Abkhaz",
			nativeName: "аҧсуа бызшәа"
		},
		ae: {
			name: "Avestan",
			nativeName: "avesta"
		},
		af: {
			name: "Afrikaans",
			nativeName: "Afrikaans"
		},
		ak: {
			name: "Akan",
			nativeName: "Akan"
		},
		am: {
			name: "Amharic",
			nativeName: "አማርኛ"
		},
		an: {
			name: "Aragonese",
			nativeName: "aragonés"
		},
		ar: {
			name: "Arabic",
			nativeName: "اَلْعَرَبِيَّةُ"
		},
		as: {
			name: "Assamese",
			nativeName: "অসমীয়া"
		},
		av: {
			name: "Avaric",
			nativeName: "авар мацӀ"
		},
		ay: {
			name: "Aymara",
			nativeName: "aymar aru"
		},
		az: {
			name: "Azerbaijani",
			nativeName: "azərbaycan dili"
		},
		ba: {
			name: "Bashkir",
			nativeName: "башҡорт теле"
		},
		be: {
			name: "Belarusian",
			nativeName: "беларуская мова"
		},
		bg: {
			name: "Bulgarian",
			nativeName: "български език"
		},
		bi: {
			name: "Bislama",
			nativeName: "Bislama"
		},
		bm: {
			name: "Bambara",
			nativeName: "bamanankan"
		},
		bn: {
			name: "Bengali",
			nativeName: "বাংলা"
		},
		bo: {
			name: "Tibetan",
			nativeName: "བོད་ཡིག"
		},
		br: {
			name: "Breton",
			nativeName: "brezhoneg"
		},
		bs: {
			name: "Bosnian",
			nativeName: "bosanski jezik"
		},
		ca: {
			name: "Catalan",
			nativeName: "Català"
		},
		ce: {
			name: "Chechen",
			nativeName: "нохчийн мотт"
		},
		ch: {
			name: "Chamorro",
			nativeName: "Chamoru"
		},
		co: {
			name: "Corsican",
			nativeName: "corsu"
		},
		cr: {
			name: "Cree",
			nativeName: "ᓀᐦᐃᔭᐍᐏᐣ"
		},
		cs: {
			name: "Czech",
			nativeName: "čeština"
		},
		cu: {
			name: "Old Church Slavonic",
			nativeName: "ѩзыкъ словѣньскъ"
		},
		cv: {
			name: "Chuvash",
			nativeName: "чӑваш чӗлхи"
		},
		cy: {
			name: "Welsh",
			nativeName: "Cymraeg"
		},
		da: {
			name: "Danish",
			nativeName: "dansk"
		},
		de: {
			name: "German",
			nativeName: "Deutsch"
		},
		dv: {
			name: "Divehi",
			nativeName: "ދިވެހި"
		},
		dz: {
			name: "Dzongkha",
			nativeName: "རྫོང་ཁ"
		},
		ee: {
			name: "Ewe",
			nativeName: "Eʋegbe"
		},
		el: {
			name: "Greek",
			nativeName: "Ελληνικά"
		},
		en: {
			name: "English",
			nativeName: "English"
		},
		eo: {
			name: "Esperanto",
			nativeName: "Esperanto"
		},
		es: {
			name: "Spanish",
			nativeName: "Español"
		},
		et: {
			name: "Estonian",
			nativeName: "eesti"
		},
		eu: {
			name: "Basque",
			nativeName: "euskara"
		},
		fa: {
			name: "Persian",
			nativeName: "فارسی"
		},
		ff: {
			name: "Fula",
			nativeName: "Fulfulde"
		},
		fi: {
			name: "Finnish",
			nativeName: "suomi"
		},
		fj: {
			name: "Fijian",
			nativeName: "vosa Vakaviti"
		},
		fo: {
			name: "Faroese",
			nativeName: "føroyskt"
		},
		fr: {
			name: "French",
			nativeName: "Français"
		},
		fy: {
			name: "Western Frisian",
			nativeName: "Frysk"
		},
		ga: {
			name: "Irish",
			nativeName: "Gaeilge"
		},
		gd: {
			name: "Scottish Gaelic",
			nativeName: "Gàidhlig"
		},
		gl: {
			name: "Galician",
			nativeName: "galego"
		},
		gn: {
			name: "Guaraní",
			nativeName: "Avañe'ẽ"
		},
		gu: {
			name: "Gujarati",
			nativeName: "ગુજરાતી"
		},
		gv: {
			name: "Manx",
			nativeName: "Gaelg"
		},
		ha: {
			name: "Hausa",
			nativeName: "هَوُسَ"
		},
		he: {
			name: "Hebrew",
			nativeName: "עברית"
		},
		hi: {
			name: "Hindi",
			nativeName: "हिन्दी"
		},
		ho: {
			name: "Hiri Motu",
			nativeName: "Hiri Motu"
		},
		hr: {
			name: "Croatian",
			nativeName: "Hrvatski"
		},
		ht: {
			name: "Haitian",
			nativeName: "Kreyòl ayisyen"
		},
		hu: {
			name: "Hungarian",
			nativeName: "magyar"
		},
		hy: {
			name: "Armenian",
			nativeName: "Հայերեն"
		},
		hz: {
			name: "Herero",
			nativeName: "Otjiherero"
		},
		ia: {
			name: "Interlingua",
			nativeName: "Interlingua"
		},
		id: {
			name: "Indonesian",
			nativeName: "Bahasa Indonesia"
		},
		ie: {
			name: "Interlingue",
			nativeName: "Interlingue"
		},
		ig: {
			name: "Igbo",
			nativeName: "Asụsụ Igbo"
		},
		ii: {
			name: "Nuosu",
			nativeName: "ꆈꌠ꒿ Nuosuhxop"
		},
		ik: {
			name: "Inupiaq",
			nativeName: "Iñupiaq"
		},
		io: {
			name: "Ido",
			nativeName: "Ido"
		},
		is: {
			name: "Icelandic",
			nativeName: "Íslenska"
		},
		it: {
			name: "Italian",
			nativeName: "Italiano"
		},
		iu: {
			name: "Inuktitut",
			nativeName: "ᐃᓄᒃᑎᑐᑦ"
		},
		ja: {
			name: "Japanese",
			nativeName: "日本語"
		},
		jv: {
			name: "Javanese",
			nativeName: "basa Jawa"
		},
		ka: {
			name: "Georgian",
			nativeName: "ქართული"
		},
		kg: {
			name: "Kongo",
			nativeName: "Kikongo"
		},
		ki: {
			name: "Kikuyu",
			nativeName: "Gĩkũyũ"
		},
		kj: {
			name: "Kwanyama",
			nativeName: "Kuanyama"
		},
		kk: {
			name: "Kazakh",
			nativeName: "қазақ тілі"
		},
		kl: {
			name: "Kalaallisut",
			nativeName: "kalaallisut"
		},
		km: {
			name: "Khmer",
			nativeName: "ខេមរភាសា"
		},
		kn: {
			name: "Kannada",
			nativeName: "ಕನ್ನಡ"
		},
		ko: {
			name: "Korean",
			nativeName: "한국어"
		},
		kr: {
			name: "Kanuri",
			nativeName: "Kanuri"
		},
		ks: {
			name: "Kashmiri",
			nativeName: "कश्मीरी"
		},
		ku: {
			name: "Kurdish",
			nativeName: "Kurdî"
		},
		kv: {
			name: "Komi",
			nativeName: "коми кыв"
		},
		kw: {
			name: "Cornish",
			nativeName: "Kernewek"
		},
		ky: {
			name: "Kyrgyz",
			nativeName: "Кыргызча"
		},
		la: {
			name: "Latin",
			nativeName: "latine"
		},
		lb: {
			name: "Luxembourgish",
			nativeName: "Lëtzebuergesch"
		},
		lg: {
			name: "Ganda",
			nativeName: "Luganda"
		},
		li: {
			name: "Limburgish",
			nativeName: "Limburgs"
		},
		ln: {
			name: "Lingala",
			nativeName: "Lingála"
		},
		lo: {
			name: "Lao",
			nativeName: "ພາສາລາວ"
		},
		lt: {
			name: "Lithuanian",
			nativeName: "lietuvių kalba"
		},
		lu: {
			name: "Luba-Katanga",
			nativeName: "Kiluba"
		},
		lv: {
			name: "Latvian",
			nativeName: "latviešu valoda"
		},
		mg: {
			name: "Malagasy",
			nativeName: "fiteny malagasy"
		},
		mh: {
			name: "Marshallese",
			nativeName: "Kajin M̧ajeļ"
		},
		mi: {
			name: "Māori",
			nativeName: "te reo Māori"
		},
		mk: {
			name: "Macedonian",
			nativeName: "македонски јазик"
		},
		ml: {
			name: "Malayalam",
			nativeName: "മലയാളം"
		},
		mn: {
			name: "Mongolian",
			nativeName: "Монгол хэл"
		},
		mr: {
			name: "Marathi",
			nativeName: "मराठी"
		},
		ms: {
			name: "Malay",
			nativeName: "Bahasa Melayu"
		},
		mt: {
			name: "Maltese",
			nativeName: "Malti"
		},
		my: {
			name: "Burmese",
			nativeName: "ဗမာစာ"
		},
		na: {
			name: "Nauru",
			nativeName: "Dorerin Naoero"
		},
		nb: {
			name: "Norwegian Bokmål",
			nativeName: "Norsk bokmål"
		},
		nd: {
			name: "Northern Ndebele",
			nativeName: "isiNdebele"
		},
		ne: {
			name: "Nepali",
			nativeName: "नेपाली"
		},
		ng: {
			name: "Ndonga",
			nativeName: "Owambo"
		},
		nl: {
			name: "Dutch",
			nativeName: "Nederlands"
		},
		nn: {
			name: "Norwegian Nynorsk",
			nativeName: "Norsk nynorsk"
		},
		no: {
			name: "Norwegian",
			nativeName: "Norsk"
		},
		nr: {
			name: "Southern Ndebele",
			nativeName: "isiNdebele"
		},
		nv: {
			name: "Navajo",
			nativeName: "Diné bizaad"
		},
		ny: {
			name: "Chichewa",
			nativeName: "chiCheŵa"
		},
		oc: {
			name: "Occitan",
			nativeName: "occitan"
		},
		oj: {
			name: "Ojibwe",
			nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ"
		},
		om: {
			name: "Oromo",
			nativeName: "Afaan Oromoo"
		},
		or: {
			name: "Oriya",
			nativeName: "ଓଡ଼ିଆ"
		},
		os: {
			name: "Ossetian",
			nativeName: "ирон æвзаг"
		},
		pa: {
			name: "Panjabi",
			nativeName: "ਪੰਜਾਬੀ"
		},
		pi: {
			name: "Pāli",
			nativeName: "पाऴि"
		},
		pl: {
			name: "Polish",
			nativeName: "Polski"
		},
		ps: {
			name: "Pashto",
			nativeName: "پښتو"
		},
		pt: {
			name: "Portuguese",
			nativeName: "Português"
		},
		qu: {
			name: "Quechua",
			nativeName: "Runa Simi"
		},
		rm: {
			name: "Romansh",
			nativeName: "rumantsch grischun"
		},
		rn: {
			name: "Kirundi",
			nativeName: "Ikirundi"
		},
		ro: {
			name: "Romanian",
			nativeName: "Română"
		},
		ru: {
			name: "Russian",
			nativeName: "Русский"
		},
		rw: {
			name: "Kinyarwanda",
			nativeName: "Ikinyarwanda"
		},
		sa: {
			name: "Sanskrit",
			nativeName: "संस्कृतम्"
		},
		sc: {
			name: "Sardinian",
			nativeName: "sardu"
		},
		sd: {
			name: "Sindhi",
			nativeName: "सिन्धी"
		},
		se: {
			name: "Northern Sami",
			nativeName: "Davvisámegiella"
		},
		sg: {
			name: "Sango",
			nativeName: "yângâ tî sängö"
		},
		si: {
			name: "Sinhala",
			nativeName: "සිංහල"
		},
		sk: {
			name: "Slovak",
			nativeName: "slovenčina"
		},
		sl: {
			name: "Slovenian",
			nativeName: "slovenščina"
		},
		sm: {
			name: "Samoan",
			nativeName: "gagana fa'a Samoa"
		},
		sn: {
			name: "Shona",
			nativeName: "chiShona"
		},
		so: {
			name: "Somali",
			nativeName: "Soomaaliga"
		},
		sq: {
			name: "Albanian",
			nativeName: "Shqip"
		},
		sr: {
			name: "Serbian",
			nativeName: "српски језик"
		},
		ss: {
			name: "Swati",
			nativeName: "SiSwati"
		},
		st: {
			name: "Southern Sotho",
			nativeName: "Sesotho"
		},
		su: {
			name: "Sundanese",
			nativeName: "Basa Sunda"
		},
		sv: {
			name: "Swedish",
			nativeName: "Svenska"
		},
		sw: {
			name: "Swahili",
			nativeName: "Kiswahili"
		},
		ta: {
			name: "Tamil",
			nativeName: "தமிழ்"
		},
		te: {
			name: "Telugu",
			nativeName: "తెలుగు"
		},
		tg: {
			name: "Tajik",
			nativeName: "тоҷикӣ"
		},
		th: {
			name: "Thai",
			nativeName: "ไทย"
		},
		ti: {
			name: "Tigrinya",
			nativeName: "ትግርኛ"
		},
		tk: {
			name: "Turkmen",
			nativeName: "Türkmençe"
		},
		tl: {
			name: "Tagalog",
			nativeName: "Wikang Tagalog"
		},
		tn: {
			name: "Tswana",
			nativeName: "Setswana"
		},
		to: {
			name: "Tonga",
			nativeName: "faka Tonga"
		},
		tr: {
			name: "Turkish",
			nativeName: "Türkçe"
		},
		ts: {
			name: "Tsonga",
			nativeName: "Xitsonga"
		},
		tt: {
			name: "Tatar",
			nativeName: "татар теле"
		},
		tw: {
			name: "Twi",
			nativeName: "Twi"
		},
		ty: {
			name: "Tahitian",
			nativeName: "Reo Tahiti"
		},
		ug: {
			name: "Uyghur",
			nativeName: "ئۇيغۇرچە‎"
		},
		uk: {
			name: "Ukrainian",
			nativeName: "Українська"
		},
		ur: {
			name: "Urdu",
			nativeName: "اردو"
		},
		uz: {
			name: "Uzbek",
			nativeName: "Ўзбек"
		},
		ve: {
			name: "Venda",
			nativeName: "Tshivenḓa"
		},
		vi: {
			name: "Vietnamese",
			nativeName: "Tiếng Việt"
		},
		vo: {
			name: "Volapük",
			nativeName: "Volapük"
		},
		wa: {
			name: "Walloon",
			nativeName: "walon"
		},
		wo: {
			name: "Wolof",
			nativeName: "Wollof"
		},
		xh: {
			name: "Xhosa",
			nativeName: "isiXhosa"
		},
		yi: {
			name: "Yiddish",
			nativeName: "ייִדיש"
		},
		yo: {
			name: "Yoruba",
			nativeName: "Yorùbá"
		},
		za: {
			name: "Zhuang",
			nativeName: "Saɯ cueŋƅ"
		},
		zh: {
			name: "Chinese",
			nativeName: "中文"
		},
		zu: {
			name: "Zulu",
			nativeName: "isiZulu"
		}
	};
})), Yr, Xr = p((() => {
	Jr(), Yr = class e {
		static getLanguages(t = []) {
			return t.map((t) => ({
				code: t,
				name: e.getName(t),
				nativeName: e.getNativeName(t)
			}));
		}
		static getName(t) {
			return e.validate(t) ? qr[t].name : "";
		}
		static getAllNames() {
			return Object.values(qr).map((e) => e.name);
		}
		static getNativeName(t) {
			return e.validate(t) ? qr[t].nativeName : "";
		}
		static getAllNativeNames() {
			return Object.values(qr).map((e) => e.nativeName);
		}
		static getCode(e) {
			return Object.keys(qr).find((t) => {
				let n = qr[t];
				return n.name.toLowerCase() === e.toLowerCase() || n.nativeName.toLowerCase() === e.toLowerCase();
			}) || "";
		}
		static getAllCodes() {
			return Object.keys(qr);
		}
		static validate(e) {
			return qr.hasOwnProperty(e);
		}
	};
}));
//#endregion
//#region ../../../node_modules/@devcycle/types/index.esm.js
function G(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
function K(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function Zr(e) {
	return function(t, n) {
		z({
			name: "isLongerThan",
			target: t.constructor,
			propertyName: n,
			options: e,
			validator: {
				validate: Qr,
				defaultMessage() {
					return "$property must be a JSON Object with only string / number / boolean / null types";
				}
			}
		});
	};
}
function Qr(e) {
	if (!(0, ci.default)(e)) return !1;
	for (let t in e) {
		if (!(0, ai.default)(t)) return !1;
		let n = e[t];
		if ((0, ui.default)(n) || !((0, ai.default)(n) || (0, oi.default)(n) || (0, si.default)(n) || (0, li.default)(n))) return !1;
	}
	return !0;
}
function $r(e) {
	return function(t, n) {
		z({
			name: "isNotBlank",
			target: t.constructor,
			propertyName: n,
			options: e,
			validator: { validate: ei }
		});
	};
}
function ei(e) {
	return typeof e == "string" && e.trim().length > 0;
}
function ti(e) {
	return typeof e == "string" && ri(e);
}
function ni(e) {
	return V({
		name: di,
		validator: {
			validate: (e, t) => ti(e),
			defaultMessage: B((e) => e + "$property must be a valid ISO6391 code", e)
		}
	}, e);
}
function ri(e) {
	return Yr.validate(e.toLocaleLowerCase());
}
function ii(e, t, n, r) {
	if (typeof e == "boolean") return Bi.boolean;
	if (typeof e == "number") return Bi.number;
	if (typeof e == "string") return Bi.string;
	if (typeof e == "object") return Bi.json;
	if (r) throw Error(`The default value for variable ${t} is not of type Boolean, Number, String, or JSON`);
	return n.warn(`The default value for variable ${t} is not of type Boolean, Number, String, or JSON`), null;
}
var ai, oi, si, ci, li, ui, di, fi, pi, mi, hi, gi, q, _i, J, vi, yi, bi, xi, Si, Ci, wi, Ti, Ei, Di, Oi, ki, Ai, ji, Mi, Ni, Pi, Fi, Ii, Li, Ri, zi, Bi, Vi, Hi, Ui, Wi = p((() => {
	ai = /* @__PURE__ */ _(te()), ir(), Lr(), zr(), oi = /* @__PURE__ */ _(Br()), si = /* @__PURE__ */ _(Vr()), ci = /* @__PURE__ */ _(Wr()), li = /* @__PURE__ */ _(Gr()), ui = /* @__PURE__ */ _(Kr()), Xr(), di = "isISO6391", (function(e) {
		e.TARGETING_MATCH = "TARGETING_MATCH", e.SPLIT = "SPLIT", e.DEFAULT = "DEFAULT", e.DISABLED = "DISABLED", e.ERROR = "ERROR", e.OVERRIDE = "OVERRIDE", e.OPT_IN = "OPT_IN";
	})(fi ||= {}), (function(e) {
		e.ALL_USERS = "All Users", e.AUDIENCE_MATCH = "Audience Match", e.NOT_IN_AUDIENCE = "Not in Audience", e.OPT_IN = "Opt-In", e.NOT_OPTED_IN = "Not Opt-In", e.OVERRIDE = "Override", e.USER_ID = "User ID", e.EMAIL = "Email", e.COUNTRY = "Country", e.PLATFORM = "Platform", e.PLATFORM_VERSION = "Platform Version", e.APP_VERSION = "App Version", e.DEVICE_MODEL = "Device Model", e.CUSTOM_DATA = "Custom Data", e.RANDOM_DISTRIBUTION = "Random Distribution", e.ROLLOUT = "Rollout";
	})(pi ||= {}), (function(e) {
		e.MISSING_CONFIG = "Missing Config", e.MISSING_VARIABLE = "Missing Variable", e.MISSING_FEATURE = "Missing Feature", e.MISSING_VARIATION = "Missing Variation", e.MISSING_VARIABLE_FOR_VARIATION = "Missing Variable for Variation", e.USER_NOT_IN_ROLLOUT = "User Not in Rollout", e.USER_NOT_TARGETED = "User Not Targeted", e.INVALID_VARIABLE_TYPE = "Invalid Variable Type", e.TYPE_MISMATCH = "Variable Type Mismatch", e.UNKNOWN = "Unknown", e.ERROR = "Error";
	})(mi ||= {}), hi = ({ value: e }) => e === "true" || e !== "false" && e, gi = ({ value: e }) => {
		if (!e) return;
		let t = Number(e);
		return isNaN(t) ? new Date(e) : new Date(t);
	}, q = class {
		isAnonymous;
		user_id;
		email;
		name;
		language;
		country;
		appVersion;
		appBuild;
		customData;
		privateCustomData;
		createdDate;
		lastSeenDate;
		platform;
		platformVersion;
		deviceModel;
		sdkType = "api";
		sdkVersion;
	}, G([
		xn(),
		U(),
		_r(hi),
		K("design:type", Boolean)
	], q.prototype, "isAnonymous", void 0), G([
		W(),
		$r(),
		Fe(),
		K("design:type", String)
	], q.prototype, "user_id", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "email", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "name", void 0), G([
		ni(),
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "language", void 0), G([
		Et(),
		U(),
		K("design:type", String)
	], q.prototype, "country", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "appVersion", void 0), G([
		kn(),
		U(),
		yr(() => Number),
		K("design:type", Number)
	], q.prototype, "appBuild", void 0), G([
		Zr(),
		U(),
		_r(({ value: e }) => (0, ai.default)(e) ? JSON.parse(e) : e),
		K("design:type", Object)
	], q.prototype, "customData", void 0), G([
		Zr(),
		U(),
		_r(({ value: e }) => (0, ai.default)(e) ? JSON.parse(e) : e),
		K("design:type", Object)
	], q.prototype, "privateCustomData", void 0), G([
		Tn(),
		U(),
		_r(gi),
		K("design:type", Date)
	], q.prototype, "createdDate", void 0), G([
		Tn(),
		U(),
		_r(gi),
		K("design:type", Date)
	], q.prototype, "lastSeenDate", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "platform", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "platformVersion", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "deviceModel", void 0), G([
		W(),
		U(),
		ze([
			"client",
			"server",
			"mobile",
			"api"
		]),
		_r(({ value: e }) => e),
		K("design:type", String)
	], q.prototype, "sdkType", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], q.prototype, "sdkVersion", void 0), _i = class extends q {
		optIns;
	}, G([
		U(),
		_r(({ value: e }) => (0, ai.default)(e) ? JSON.parse(e) : e),
		K("design:type", Object)
	], _i.prototype, "optIns", void 0), J = class {
		isAnonymous;
		user_id;
		email;
		name;
		language;
		country;
		appVersion;
		appBuild;
		customData;
		privateCustomData;
		createdDate;
		lastSeenDate;
		platform;
		platformVersion;
		deviceModel;
		sdkType;
		sdkVersion;
		isDebug;
	}, G([
		xn(),
		_r(hi),
		K("design:type", Boolean)
	], J.prototype, "isAnonymous", void 0), G([
		W(),
		$r(),
		Fe(),
		K("design:type", String)
	], J.prototype, "user_id", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], J.prototype, "email", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], J.prototype, "name", void 0), G([
		ni(),
		W(),
		U(),
		K("design:type", String)
	], J.prototype, "language", void 0), G([
		Et(),
		U(),
		K("design:type", String)
	], J.prototype, "country", void 0), G([
		W(),
		U(),
		K("design:type", String)
	], J.prototype, "appVersion", void 0), G([
		kn(),
		U(),
		yr(() => Number),
		K("design:type", Number)
	], J.prototype, "appBuild", void 0), G([
		Zr(),
		U(),
		_r(({ value: e }) => (0, ai.default)(e) ? JSON.parse(e) : e),
		K("design:type", Object)
	], J.prototype, "customData", void 0), G([
		Zr(),
		U(),
		_r(({ value: e }) => (0, ai.default)(e) ? JSON.parse(e) : e),
		K("design:type", Object)
	], J.prototype, "privateCustomData", void 0), G([
		Tn(),
		_r(gi),
		K("design:type", Date)
	], J.prototype, "createdDate", void 0), G([
		Tn(),
		_r(gi),
		K("design:type", Date)
	], J.prototype, "lastSeenDate", void 0), G([
		W(),
		Fe(),
		K("design:type", String)
	], J.prototype, "platform", void 0), G([
		W(),
		Fe(),
		K("design:type", String)
	], J.prototype, "platformVersion", void 0), G([
		W(),
		Fe(),
		K("design:type", String)
	], J.prototype, "deviceModel", void 0), G([
		W(),
		ze(["client", "mobile"]),
		K("design:type", String)
	], J.prototype, "sdkType", void 0), G([
		W(),
		Fe(),
		K("design:type", String)
	], J.prototype, "sdkVersion", void 0), G([
		xn(),
		U(),
		_r(({ value: e }) => (0, ai.default)(e) ? e === "true" : e),
		K("design:type", Boolean)
	], J.prototype, "isDebug", void 0), vi = class {
		user_id;
	}, G([
		W(),
		$r(),
		Fe(),
		K("design:type", String)
	], vi.prototype, "user_id", void 0), yi = class {
		type;
		target;
		date;
		value;
		metaData;
	}, G([
		Fe(),
		W(),
		K("design:type", String)
	], yi.prototype, "type", void 0), G([
		U(),
		W(),
		K("design:type", String)
	], yi.prototype, "target", void 0), G([
		U(),
		kn(),
		K("design:type", Number)
	], yi.prototype, "date", void 0), G([
		U(),
		kn(),
		K("design:type", Number)
	], yi.prototype, "value", void 0), G([
		U(),
		Hn(),
		K("design:type", Object)
	], yi.prototype, "metaData", void 0), bi = class {
		user;
		events;
	}, G([
		Fe(),
		Ce(),
		yr(() => q),
		K("design:type", q)
	], bi.prototype, "user", void 0), G([
		Fe(),
		Rn(),
		Ce({ each: !0 }),
		yr(() => yi),
		K("design:type", Array)
	], bi.prototype, "events", void 0), (function(e) {
		e["="] = "=", e["!="] = "!=", e[">"] = ">", e[">="] = ">=", e["<"] = "<", e["<="] = "<=", e.exist = "exist", e["!exist"] = "!exist", e.contain = "contain", e["!contain"] = "!contain", e.startWith = "startWith", e["!startWith"] = "!startWith", e.endWith = "endWith", e["!endWith"] = "!endWith";
	})(xi ||= {}), (function(e) {
		e["="] = "=", e.exist = "exist", e["!exist"] = "!exist";
	})(Si ||= {}), (function(e) {
		e["="] = "=", e["!="] = "!=", e.exist = "exist", e["!exist"] = "!exist", e.contain = "contain", e["!contain"] = "!contain", e.startWith = "startWith", e["!startWith"] = "!startWith", e.endWith = "endWith", e["!endWith"] = "!endWith";
	})(Ci ||= {}), (function(e) {
		e["="] = "=", e["!="] = "!=", e[">"] = ">", e[">="] = ">=", e["<"] = "<", e["<="] = "<=", e.exist = "exist", e["!exist"] = "!exist";
	})(wi ||= {}), (function(e) {
		e["="] = "=", e["!="] = "!=", e[">"] = ">", e[">="] = ">=", e["<"] = "<", e["<="] = "<=", e.exist = "exist", e["!exist"] = "!exist";
	})(Ti ||= {}), (function(e) {
		e.all = "all", e.user = "user", e.optIn = "optIn", e.audienceMatch = "audienceMatch";
	})(Ei ||= {}), (function(e) {
		e.user_id = "user_id", e.email = "email", e.country = "country", e.platform = "platform", e.platformVersion = "platformVersion", e.appVersion = "appVersion", e.deviceModel = "deviceModel", e.customData = "customData";
	})(Di ||= {}), (function(e) {
		e.mixpanel = "mixpanel", e.csv = "csv";
	})(Oi ||= {}), (function(e) {
		e.string = "String", e.boolean = "Boolean", e.number = "Number", e.semver = "Semver";
	})(ki ||= {}), (function(e) {
		e.and = "and", e.or = "or";
	})(Ai ||= {}), (function(e) {
		e.override = "override";
	})(ji ||= {}), Mi = class {
		type;
		date;
		percentage;
	}, G([yr(() => Date), K("design:type", Date)], Mi.prototype, "date", void 0), Ni = class {
		type;
		startPercentage;
		startDate;
		stages;
	}, G([yr(() => Date), K("design:type", Date)], Ni.prototype, "startDate", void 0), G([yr(() => Mi), K("design:type", Array)], Ni.prototype, "stages", void 0), Pi = class {
		_id;
		_audience;
		rollout;
		distribution;
		type;
		bucketingKey;
	}, G([yr(() => Ni), K("design:type", Ni)], Pi.prototype, "rollout", void 0), Fi = class {
		_id;
		prerequisites;
		winningVariation;
		forcedUsers;
		targets;
	}, G([yr(() => Pi), K("design:type", Array)], Fi.prototype, "targets", void 0), (function(e) {
		e.api = "api", e.dashboard = "dashboard";
	})(Ii ||= {}), (function(e) {
		e.release = "release", e.experiment = "experiment", e.permission = "permission", e.ops = "ops";
	})(Li ||= {}), Ri = class {
		_id;
		type;
		key;
		variations;
		configuration;
		settings;
		tags;
	}, G([yr(() => Fi), K("design:type", Fi)], Ri.prototype, "configuration", void 0), (function(e) {
		e.api = "api", e.dashboard = "dashboard", e.clientSDK = "clientSDK", e.serverSDK = "serverSDK";
	})(zi ||= {}), (function(e) {
		e.string = "String", e.boolean = "Boolean", e.number = "Number", e.json = "JSON";
	})(Bi ||= {}), Vi = class {
		project;
		environment;
		features;
		variables;
		audiences;
		variableHashes;
		listAudiences;
		debugUsers;
		sse;
		ably;
		clientSDKKey;
	}, G([yr(() => Ri), K("design:type", Array)], Vi.prototype, "features", void 0), Hi = class {
		type;
		target;
		customType;
		user_id;
		date;
		clientDate;
		value;
		featureVars;
		metaData;
	}, G([W(), K("design:type", String)], Hi.prototype, "type", void 0), G([
		U(),
		W(),
		K("design:type", String)
	], Hi.prototype, "target", void 0), G([
		U(),
		W(),
		K("design:type", String)
	], Hi.prototype, "customType", void 0), G([
		W(),
		Fe(),
		K("design:type", String)
	], Hi.prototype, "user_id", void 0), G([kn(), K("design:type", Number)], Hi.prototype, "date", void 0), G([kn(), K("design:type", Number)], Hi.prototype, "clientDate", void 0), G([
		U(),
		kn(),
		K("design:type", Number)
	], Hi.prototype, "value", void 0), G([Fe(), K("design:type", Object)], Hi.prototype, "featureVars", void 0), G([U(), K("design:type", Object)], Hi.prototype, "metaData", void 0), Ui = class extends Error {
		constructor(e) {
			super(e instanceof Error ? e.message : e), this.name = "UserError", e instanceof Error && (this.stack = e.stack);
		}
	};
})), Gi = /* @__PURE__ */ m(((e, t) => {
	function n(e, t, n) {
		var r = -1, i = e.length;
		t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
		for (var a = Array(i); ++r < i;) a[r] = e[r + t];
		return a;
	}
	t.exports = n;
})), Ki = /* @__PURE__ */ m(((e, t) => {
	function n(e, t) {
		return e === t || e !== e && t !== t;
	}
	t.exports = n;
})), qi = /* @__PURE__ */ m(((e, t) => {
	function n(e) {
		var t = typeof e;
		return e != null && (t == "object" || t == "function");
	}
	t.exports = n;
})), Ji = /* @__PURE__ */ m(((e, t) => {
	var n = T(), r = qi(), i = "[object AsyncFunction]", a = "[object Function]", o = "[object GeneratorFunction]", s = "[object Proxy]";
	function c(e) {
		if (!r(e)) return !1;
		var t = n(e);
		return t == a || t == o || t == i || t == s;
	}
	t.exports = c;
})), Yi = /* @__PURE__ */ m(((e, t) => {
	function n(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= 9007199254740991;
	}
	t.exports = n;
})), Xi = /* @__PURE__ */ m(((e, t) => {
	var n = Ji(), r = Yi();
	function i(e) {
		return e != null && r(e.length) && !n(e);
	}
	t.exports = i;
})), Zi = /* @__PURE__ */ m(((e, t) => {
	var n = /^(?:0|[1-9]\d*)$/;
	function r(e, t) {
		var r = typeof e;
		return t ??= 9007199254740991, !!t && (r == "number" || r != "symbol" && n.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	t.exports = r;
})), Qi = /* @__PURE__ */ m(((e, t) => {
	var n = Ki(), r = Xi(), i = Zi(), a = qi();
	function o(e, t, o) {
		if (!a(o)) return !1;
		var s = typeof t;
		return (s == "number" ? r(o) && i(t, o.length) : s == "string" && t in o) ? n(o[t], e) : !1;
	}
	t.exports = o;
})), $i = /* @__PURE__ */ m(((e, t) => {
	var n = /\s/;
	function r(e) {
		for (var t = e.length; t-- && n.test(e.charAt(t)););
		return t;
	}
	t.exports = r;
})), ea = /* @__PURE__ */ m(((e, t) => {
	var n = $i(), r = /^\s+/;
	function i(e) {
		return e && e.slice(0, n(e) + 1).replace(r, "");
	}
	t.exports = i;
})), ta = /* @__PURE__ */ m(((e, t) => {
	var n = T(), r = D(), i = "[object Symbol]";
	function a(e) {
		return typeof e == "symbol" || r(e) && n(e) == i;
	}
	t.exports = a;
})), na = /* @__PURE__ */ m(((e, t) => {
	var n = ea(), r = qi(), i = ta(), a = NaN, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, c = /^0o[0-7]+$/i, l = parseInt;
	function u(e) {
		if (typeof e == "number") return e;
		if (i(e)) return a;
		if (r(e)) {
			var t = typeof e.valueOf == "function" ? e.valueOf() : e;
			e = r(t) ? t + "" : t;
		}
		if (typeof e != "string") return e === 0 ? e : +e;
		e = n(e);
		var u = s.test(e);
		return u || c.test(e) ? l(e.slice(2), u ? 2 : 8) : o.test(e) ? a : +e;
	}
	t.exports = u;
})), ra = /* @__PURE__ */ m(((e, t) => {
	var n = na(), r = 1 / 0, i = 17976931348623157e292;
	function a(e) {
		return e ? (e = n(e), e === r || e === -r ? (e < 0 ? -1 : 1) * i : e === e ? e : 0) : e === 0 ? e : 0;
	}
	t.exports = a;
})), ia = /* @__PURE__ */ m(((e, t) => {
	var n = ra();
	function r(e) {
		var t = n(e), r = t % 1;
		return t === t ? r ? t - r : t : 0;
	}
	t.exports = r;
})), aa = /* @__PURE__ */ m(((e, t) => {
	var n = Gi(), r = Qi(), i = ia(), a = Math.ceil, o = Math.max;
	function s(e, t, s) {
		t = (s ? r(e, t, s) : t === void 0) ? 1 : o(i(t), 0);
		var c = e == null ? 0 : e.length;
		if (!c || t < 1) return [];
		for (var l = 0, u = 0, d = Array(a(c / t)); l < c;) d[u++] = n(e, l, l += t);
		return d;
	}
	t.exports = s;
})), oa = /* @__PURE__ */ m(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self, n.fetchRetry = r());
	})(e, (function() {
		var e = function(e, r) {
			if (r ||= {}, typeof e != "function") throw new n("fetch must be a function");
			if (typeof r != "object") throw new n("defaults must be an object");
			if (r.retries !== void 0 && !t(r.retries)) throw new n("retries must be a positive integer");
			if (r.retryDelay !== void 0 && !t(r.retryDelay) && typeof r.retryDelay != "function") throw new n("retryDelay must be a positive integer or a function returning a positive integer");
			if (r.retryOn !== void 0 && !Array.isArray(r.retryOn) && typeof r.retryOn != "function") throw new n("retryOn property expects an array or function");
			return r = Object.assign({
				retries: 3,
				retryDelay: 1e3,
				retryOn: []
			}, r), function(i, a) {
				var o = r.retries, s = r.retryDelay, c = r.retryOn;
				if (a && a.retries !== void 0) {
					if (t(a.retries)) o = a.retries;
					else throw new n("retries must be a positive integer");
				}
				if (a && a.retryDelay !== void 0) {
					if (t(a.retryDelay) || typeof a.retryDelay == "function") s = a.retryDelay;
					else throw new n("retryDelay must be a positive integer or a function returning a positive integer");
				}
				if (a && a.retryOn) {
					if (Array.isArray(a.retryOn) || typeof a.retryOn == "function") c = a.retryOn;
					else throw new n("retryOn property expects an array or function");
				}
				return new Promise(function(t, n) {
					var r = function(r) {
						e(typeof Request < "u" && i instanceof Request ? i.clone() : i, a).then(function(e) {
							if (Array.isArray(c) && c.indexOf(e.status) === -1) t(e);
							else if (typeof c == "function") try {
								return Promise.resolve(c(r, null, e)).then(function(n) {
									n ? l(r, null, e) : t(e);
								}).catch(n);
							} catch (e) {
								n(e);
							}
							else r < o ? l(r, null, e) : t(e);
						}).catch(function(e) {
							if (typeof c == "function") try {
								Promise.resolve(c(r, e, null)).then(function(t) {
									t ? l(r, e, null) : n(e);
								}).catch(function(e) {
									n(e);
								});
							} catch (e) {
								n(e);
							}
							else r < o ? l(r, e, null) : n(e);
						});
					};
					function l(e, t, n) {
						var i = typeof s == "function" ? s(e, t, n) : s;
						setTimeout(function() {
							r(++e);
						}, i);
					}
					r(0);
				});
			};
		};
		function t(e) {
			return Number.isInteger(e) && e >= 0;
		}
		function n(e) {
			this.name = "ArgumentError", this.message = e;
		}
		return e;
	}));
}));
//#endregion
//#region ../../../node_modules/uuid/dist/esm-browser/stringify.js
function sa(e, t = 0) {
	return (Y[e[t + 0]] + Y[e[t + 1]] + Y[e[t + 2]] + Y[e[t + 3]] + "-" + Y[e[t + 4]] + Y[e[t + 5]] + "-" + Y[e[t + 6]] + Y[e[t + 7]] + "-" + Y[e[t + 8]] + Y[e[t + 9]] + "-" + Y[e[t + 10]] + Y[e[t + 11]] + Y[e[t + 12]] + Y[e[t + 13]] + Y[e[t + 14]] + Y[e[t + 15]]).toLowerCase();
}
var Y, ca = p((() => {
	Y = [];
	for (let e = 0; e < 256; ++e) Y.push((e + 256).toString(16).slice(1));
}));
//#endregion
//#region ../../../node_modules/uuid/dist/esm-browser/rng.js
function la() {
	if (!ua) {
		if (typeof crypto > "u" || !crypto.getRandomValues) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
		ua = crypto.getRandomValues.bind(crypto);
	}
	return ua(da);
}
var ua, da, fa = p((() => {
	da = /* @__PURE__ */ new Uint8Array(16);
})), pa, ma, ha = p((() => {
	pa = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ma = { randomUUID: pa };
}));
//#endregion
//#region ../../../node_modules/uuid/dist/esm-browser/v4.js
function ga(e, t, n) {
	if (ma.randomUUID && !t && !e) return ma.randomUUID();
	e ||= {};
	let r = e.random ?? e.rng?.() ?? la();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return sa(r);
}
var _a = p((() => {
	ha(), fa(), ca();
})), va = p((() => {
	ca(), fa(), _a();
})), ya = /* @__PURE__ */ m(((e, t) => {
	(function(n, r) {
		var i = "1.0.41", a = "", o = "function", s = "undefined", c = "object", l = "string", u = "major", d = "model", f = "name", p = "type", m = "vendor", h = "version", g = "architecture", _ = "console", v = "mobile", y = "tablet", b = "smarttv", x = "wearable", S = "embedded", C = "Amazon", w = "Apple", ee = "ASUS", T = "BlackBerry", E = "Browser", D = "Chrome", te = "Edge", O = "Firefox", ne = "Google", re = "Honor", ie = "Huawei", k = "Lenovo", A = "LG", ae = "Microsoft", oe = "Motorola", j = "Nvidia", M = "OnePlus", se = "Opera", ce = "OPPO", le = "Samsung", N = "Sharp", P = "Sony", F = "Xiaomi", I = "Zebra", L = "Facebook", ue = "Chromium OS", de = "Mac OS", R = " Browser", fe = function(e, t) {
			var n = {};
			for (var r in e) n[r] = t[r] && t[r].length % 2 == 0 ? t[r].concat(e[r]) : e[r];
			return n;
		}, pe = function(e) {
			for (var t = {}, n = 0; n < e.length; n++) t[e[n].toUpperCase()] = e[n];
			return t;
		}, me = function(e, t) {
			return typeof e == l && he(t).indexOf(he(e)) !== -1;
		}, he = function(e) {
			return e.toLowerCase();
		}, ge = function(e) {
			return typeof e == l ? e.replace(/[^\d\.]/g, a).split(".")[0] : r;
		}, _e = function(e, t) {
			if (typeof e == l) return e = e.replace(/^\s\s*/, a), typeof t === s ? e : e.substring(0, 500);
		}, z = function(e, t) {
			for (var n = 0, i, a, s, l, u, d; n < t.length && !u;) {
				var f = t[n], p = t[n + 1];
				for (i = a = 0; i < f.length && !u && f[i];) if (u = f[i++].exec(e), u) for (s = 0; s < p.length; s++) d = u[++a], l = p[s], typeof l == c && l.length > 0 ? l.length === 2 ? typeof l[1] == o ? this[l[0]] = l[1].call(this, d) : this[l[0]] = l[1] : l.length === 3 ? typeof l[1] === o && !(l[1].exec && l[1].test) ? this[l[0]] = d ? l[1].call(this, d, l[2]) : r : this[l[0]] = d ? d.replace(l[1], l[2]) : r : l.length === 4 && (this[l[0]] = d ? l[3].call(this, d.replace(l[1], l[2])) : r) : this[l] = d || r;
				n += 2;
			}
		}, ve = function(e, t) {
			for (var n in t) if (typeof t[n] == c && t[n].length > 0) {
				for (var i = 0; i < t[n].length; i++) if (me(t[n][i], e)) return n === "?" ? r : n;
			} else if (me(t[n], e)) return n === "?" ? r : n;
			return t.hasOwnProperty("*") ? t["*"] : e;
		}, B = {
			"1.0": "/8",
			"1.2": "/1",
			"1.3": "/3",
			"2.0": "/412",
			"2.0.2": "/416",
			"2.0.3": "/417",
			"2.0.4": "/419",
			"?": "/"
		}, V = {
			ME: "4.90",
			"NT 3.11": "NT3.51",
			"NT 4.0": "NT4.0",
			2e3: "NT 5.0",
			XP: ["NT 5.1", "NT 5.2"],
			Vista: "NT 6.0",
			7: "NT 6.1",
			8: "NT 6.2",
			"8.1": "NT 6.3",
			10: ["NT 6.4", "NT 10.0"],
			RT: "ARM"
		}, ye = {
			browser: [
				[/\b(?:crmo|crios)\/([\w\.]+)/i],
				[h, [f, "Chrome"]],
				[/edg(?:e|ios|a)?\/([\w\.]+)/i],
				[h, [f, "Edge"]],
				[
					/(opera mini)\/([-\w\.]+)/i,
					/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
					/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
				],
				[f, h],
				[/opios[\/ ]+([\w\.]+)/i],
				[h, [f, se + " Mini"]],
				[/\bop(?:rg)?x\/([\w\.]+)/i],
				[h, [f, se + " GX"]],
				[/\bopr\/([\w\.]+)/i],
				[h, [f, se]],
				[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],
				[h, [f, "Baidu"]],
				[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],
				[h, [f, "Maxthon"]],
				[
					/(kindle)\/([\w\.]+)/i,
					/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
					/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
					/(?:ms|\()(ie) ([\w\.]+)/i,
					/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
					/(heytap|ovi|115)browser\/([\d\.]+)/i,
					/(weibo)__([\d\.]+)/i
				],
				[f, h],
				[/quark(?:pc)?\/([-\w\.]+)/i],
				[h, [f, "Quark"]],
				[/\bddg\/([\w\.]+)/i],
				[h, [f, "DuckDuckGo"]],
				[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],
				[h, [f, "UC" + E]],
				[
					/microm.+\bqbcore\/([\w\.]+)/i,
					/\bqbcore\/([\w\.]+).+microm/i,
					/micromessenger\/([\w\.]+)/i
				],
				[h, [f, "WeChat"]],
				[/konqueror\/([\w\.]+)/i],
				[h, [f, "Konqueror"]],
				[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],
				[h, [f, "IE"]],
				[/ya(?:search)?browser\/([\w\.]+)/i],
				[h, [f, "Yandex"]],
				[/slbrowser\/([\w\.]+)/i],
				[h, [f, "Smart Lenovo " + E]],
				[/(avast|avg)\/([\w\.]+)/i],
				[[
					f,
					/(.+)/,
					"$1 Secure " + E
				], h],
				[/\bfocus\/([\w\.]+)/i],
				[h, [f, O + " Focus"]],
				[/\bopt\/([\w\.]+)/i],
				[h, [f, se + " Touch"]],
				[/coc_coc\w+\/([\w\.]+)/i],
				[h, [f, "Coc Coc"]],
				[/dolfin\/([\w\.]+)/i],
				[h, [f, "Dolphin"]],
				[/coast\/([\w\.]+)/i],
				[h, [f, se + " Coast"]],
				[/miuibrowser\/([\w\.]+)/i],
				[h, [f, "MIUI" + R]],
				[/fxios\/([\w\.-]+)/i],
				[h, [f, O]],
				[/\bqihoobrowser\/?([\w\.]*)/i],
				[h, [f, "360"]],
				[/\b(qq)\/([\w\.]+)/i],
				[[
					f,
					/(.+)/,
					"$1Browser"
				], h],
				[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],
				[[
					f,
					/(.+)/,
					"$1" + R
				], h],
				[/samsungbrowser\/([\w\.]+)/i],
				[h, [f, le + " Internet"]],
				[/metasr[\/ ]?([\d\.]+)/i],
				[h, [f, "Sogou Explorer"]],
				[/(sogou)mo\w+\/([\d\.]+)/i],
				[[f, "Sogou Mobile"], h],
				[
					/(electron)\/([\w\.]+) safari/i,
					/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
					/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
				],
				[f, h],
				[/(lbbrowser|rekonq)/i, /\[(linkedin)app\]/i],
				[f],
				[/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i],
				[h, f],
				[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],
				[[f, L], h],
				[
					/(Klarna)\/([\w\.]+)/i,
					/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
					/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
					/(daum)apps[\/ ]([\w\.]+)/i,
					/safari (line)\/([\w\.]+)/i,
					/\b(line)\/([\w\.]+)\/iab/i,
					/(alipay)client\/([\w\.]+)/i,
					/(twitter)(?:and| f.+e\/([\w\.]+))/i,
					/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
				],
				[f, h],
				[/\bgsa\/([\w\.]+) .*safari\//i],
				[h, [f, "GSA"]],
				[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],
				[h, [f, "TikTok"]],
				[/headlesschrome(?:\/([\w\.]+)| )/i],
				[h, [f, D + " Headless"]],
				[/ wv\).+(chrome)\/([\w\.]+)/i],
				[[f, D + " WebView"], h],
				[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],
				[h, [f, "Android " + E]],
				[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],
				[f, h],
				[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],
				[h, [f, "Mobile Safari"]],
				[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],
				[h, f],
				[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],
				[f, [
					h,
					ve,
					B
				]],
				[/(webkit|khtml)\/([\w\.]+)/i],
				[f, h],
				[/(navigator|netscape\d?)\/([-\w\.]+)/i],
				[[f, "Netscape"], h],
				[/(wolvic|librewolf)\/([\w\.]+)/i],
				[f, h],
				[/mobile vr; rv:([\w\.]+)\).+firefox/i],
				[h, [f, O + " Reality"]],
				[
					/ekiohf.+(flow)\/([\w\.]+)/i,
					/(swiftfox)/i,
					/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
					/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
					/(firefox)\/([\w\.]+)/i,
					/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
					/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
					/\b(links) \(([\w\.]+)/i
				],
				[f, [
					h,
					/_/g,
					"."
				]],
				[/(cobalt)\/([\w\.]+)/i],
				[f, [
					h,
					/master.|lts./,
					""
				]]
			],
			cpu: [
				[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],
				[[g, "amd64"]],
				[/(ia32(?=;))/i, /\b((i[346]|x)86)(pc)?\b/i],
				[[g, "ia32"]],
				[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],
				[[g, "arm64"]],
				[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],
				[[g, "armhf"]],
				[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],
				[[g, "arm"]],
				[/((ppc|powerpc)(64)?)( mac|;|\))/i],
				[[
					g,
					/ower/,
					a,
					he
				]],
				[/ sun4\w[;\)]/i],
				[[g, "sparc"]],
				[/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i],
				[[g, he]]
			],
			device: [
				[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],
				[
					d,
					[m, le],
					[p, y]
				],
				[
					/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
					/samsung[- ]((?!sm-[lr])[-\w]+)/i,
					/sec-(sgh\w+)/i
				],
				[
					d,
					[m, le],
					[p, v]
				],
				[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],
				[
					d,
					[m, w],
					[p, v]
				],
				[
					/\((ipad);[-\w\),; ]+apple/i,
					/applecoremedia\/[\w\.]+ \((ipad)/i,
					/\b(ipad)\d\d?,\d\d?[;\]].+ios/i
				],
				[
					d,
					[m, w],
					[p, y]
				],
				[/(macintosh);/i],
				[d, [m, w]],
				[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],
				[
					d,
					[m, N],
					[p, v]
				],
				[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],
				[
					d,
					[m, re],
					[p, y]
				],
				[/honor([-\w ]+)[;\)]/i],
				[
					d,
					[m, re],
					[p, v]
				],
				[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],
				[
					d,
					[m, ie],
					[p, y]
				],
				[/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],
				[
					d,
					[m, ie],
					[p, v]
				],
				[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i, /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],
				[
					[
						d,
						/_/g,
						" "
					],
					[m, F],
					[p, y]
				],
				[
					/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
					/\b; (\w+) build\/hm\1/i,
					/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
					/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
					/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
					/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
					/ ([\w ]+) miui\/v?\d/i
				],
				[
					[
						d,
						/_/g,
						" "
					],
					[m, F],
					[p, v]
				],
				[/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],
				[
					d,
					[m, ce],
					[p, v]
				],
				[/\b(opd2(\d{3}a?))(?: bui|\))/i],
				[
					d,
					[
						m,
						ve,
						{
							OnePlus: [
								"304",
								"403",
								"203"
							],
							"*": ce
						}
					],
					[p, y]
				],
				[/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i],
				[
					d,
					[m, "Vivo"],
					[p, v]
				],
				[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],
				[
					d,
					[m, "Realme"],
					[p, v]
				],
				[
					/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
					/\bmot(?:orola)?[- ](\w*)/i,
					/((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
				],
				[
					d,
					[m, oe],
					[p, v]
				],
				[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
				[
					d,
					[m, oe],
					[p, y]
				],
				[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],
				[
					d,
					[m, A],
					[p, y]
				],
				[
					/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
					/\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
					/\blg-?([\d\w]+) bui/i
				],
				[
					d,
					[m, A],
					[p, v]
				],
				[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i, /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],
				[
					d,
					[m, k],
					[p, y]
				],
				[/(nokia) (t[12][01])/i],
				[
					m,
					d,
					[p, y]
				],
				[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*))/i],
				[
					[
						d,
						/_/g,
						" "
					],
					[p, v],
					[m, "Nokia"]
				],
				[/(pixel (c|tablet))\b/i],
				[
					d,
					[m, ne],
					[p, y]
				],
				[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],
				[
					d,
					[m, ne],
					[p, v]
				],
				[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
				[
					d,
					[m, P],
					[p, v]
				],
				[/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
				[
					[d, "Xperia Tablet"],
					[m, P],
					[p, y]
				],
				[/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],
				[
					d,
					[m, M],
					[p, v]
				],
				[
					/(alexa)webm/i,
					/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
					/(kf[a-z]+)( bui|\)).+silk\//i
				],
				[
					d,
					[m, C],
					[p, y]
				],
				[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],
				[
					[
						d,
						/(.+)/g,
						"Fire Phone $1"
					],
					[m, C],
					[p, v]
				],
				[/(playbook);[-\w\),; ]+(rim)/i],
				[
					d,
					m,
					[p, y]
				],
				[/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i],
				[
					d,
					[m, T],
					[p, v]
				],
				[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],
				[
					d,
					[m, ee],
					[p, y]
				],
				[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
				[
					d,
					[m, ee],
					[p, v]
				],
				[/(nexus 9)/i],
				[
					d,
					[m, "HTC"],
					[p, y]
				],
				[
					/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
					/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
					/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
				],
				[
					m,
					[
						d,
						/_/g,
						" "
					],
					[p, v]
				],
				[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],
				[
					d,
					[m, "TCL"],
					[p, y]
				],
				[/(itel) ((\w+))/i],
				[
					[m, he],
					d,
					[
						p,
						ve,
						{
							tablet: ["p10001l", "w7001"],
							"*": "mobile"
						}
					]
				],
				[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],
				[
					d,
					[m, "Acer"],
					[p, y]
				],
				[/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i],
				[
					d,
					[m, "Meizu"],
					[p, v]
				],
				[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],
				[
					d,
					[m, "Ulefone"],
					[p, v]
				],
				[/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i],
				[
					d,
					[m, "Energizer"],
					[p, v]
				],
				[/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],
				[
					d,
					[m, "Cat"],
					[p, v]
				],
				[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],
				[
					d,
					[m, "Smartfren"],
					[p, v]
				],
				[/droid.+; (a(?:015|06[35]|142p?))/i],
				[
					d,
					[m, "Nothing"],
					[p, v]
				],
				[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i, /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],
				[
					d,
					[m, "Archos"],
					[p, y]
				],
				[/archos ([\w ]+)( b|\))/i, /; (ac[3-6]\d\w{2,8})( b|\))/i],
				[
					d,
					[m, "Archos"],
					[p, v]
				],
				[/(imo) (tab \w+)/i, /(infinix) (x1101b?)/i],
				[
					m,
					d,
					[p, y]
				],
				[
					/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
					/; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
					/(hp) ([\w ]+\w)/i,
					/(microsoft); (lumia[\w ]+)/i,
					/(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
					/(oppo) ?([\w ]+) bui/i
				],
				[
					m,
					d,
					[p, v]
				],
				[
					/(kobo)\s(ereader|touch)/i,
					/(hp).+(touchpad(?!.+tablet)|tablet)/i,
					/(kindle)\/([\w\.]+)/i,
					/(nook)[\w ]+build\/(\w+)/i,
					/(dell) (strea[kpr\d ]*[\dko])/i,
					/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
					/(trinity)[- ]*(t\d{3}) bui/i,
					/(gigaset)[- ]+(q\w{1,9}) bui/i,
					/(vodafone) ([\w ]+)(?:\)| bui)/i
				],
				[
					m,
					d,
					[p, y]
				],
				[/(surface duo)/i],
				[
					d,
					[m, ae],
					[p, y]
				],
				[/droid [\d\.]+; (fp\du?)(?: b|\))/i],
				[
					d,
					[m, "Fairphone"],
					[p, v]
				],
				[/(u304aa)/i],
				[
					d,
					[m, "AT&T"],
					[p, v]
				],
				[/\bsie-(\w*)/i],
				[
					d,
					[m, "Siemens"],
					[p, v]
				],
				[/\b(rct\w+) b/i],
				[
					d,
					[m, "RCA"],
					[p, y]
				],
				[/\b(venue[\d ]{2,7}) b/i],
				[
					d,
					[m, "Dell"],
					[p, y]
				],
				[/\b(q(?:mv|ta)\w+) b/i],
				[
					d,
					[m, "Verizon"],
					[p, y]
				],
				[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],
				[
					d,
					[m, "Barnes & Noble"],
					[p, y]
				],
				[/\b(tm\d{3}\w+) b/i],
				[
					d,
					[m, "NuVision"],
					[p, y]
				],
				[/\b(k88) b/i],
				[
					d,
					[m, "ZTE"],
					[p, y]
				],
				[/\b(nx\d{3}j) b/i],
				[
					d,
					[m, "ZTE"],
					[p, v]
				],
				[/\b(gen\d{3}) b.+49h/i],
				[
					d,
					[m, "Swiss"],
					[p, v]
				],
				[/\b(zur\d{3}) b/i],
				[
					d,
					[m, "Swiss"],
					[p, y]
				],
				[/\b((zeki)?tb.*\b) b/i],
				[
					d,
					[m, "Zeki"],
					[p, y]
				],
				[/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i],
				[
					[m, "Dragon Touch"],
					d,
					[p, y]
				],
				[/\b(ns-?\w{0,9}) b/i],
				[
					d,
					[m, "Insignia"],
					[p, y]
				],
				[/\b((nxa|next)-?\w{0,9}) b/i],
				[
					d,
					[m, "NextBook"],
					[p, y]
				],
				[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],
				[
					[m, "Voice"],
					d,
					[p, v]
				],
				[/\b(lvtel\-)?(v1[12]) b/i],
				[
					[m, "LvTel"],
					d,
					[p, v]
				],
				[/\b(ph-1) /i],
				[
					d,
					[m, "Essential"],
					[p, v]
				],
				[/\b(v(100md|700na|7011|917g).*\b) b/i],
				[
					d,
					[m, "Envizen"],
					[p, y]
				],
				[/\b(trio[-\w\. ]+) b/i],
				[
					d,
					[m, "MachSpeed"],
					[p, y]
				],
				[/\btu_(1491) b/i],
				[
					d,
					[m, "Rotor"],
					[p, y]
				],
				[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],
				[
					d,
					[m, j],
					[p, y]
				],
				[/(sprint) (\w+)/i],
				[
					m,
					d,
					[p, v]
				],
				[/(kin\.[onetw]{3})/i],
				[
					[
						d,
						/\./g,
						" "
					],
					[m, ae],
					[p, v]
				],
				[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],
				[
					d,
					[m, I],
					[p, y]
				],
				[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
				[
					d,
					[m, I],
					[p, v]
				],
				[/smart-tv.+(samsung)/i],
				[m, [p, b]],
				[/hbbtv.+maple;(\d+)/i],
				[
					[
						d,
						/^/,
						"SmartTV"
					],
					[m, le],
					[p, b]
				],
				[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],
				[[m, A], [p, b]],
				[/(apple) ?tv/i],
				[
					m,
					[d, w + " TV"],
					[p, b]
				],
				[/crkey/i],
				[
					[d, D + "cast"],
					[m, ne],
					[p, b]
				],
				[/droid.+aft(\w+)( bui|\))/i],
				[
					d,
					[m, C],
					[p, b]
				],
				[/(shield \w+ tv)/i],
				[
					d,
					[m, j],
					[p, b]
				],
				[/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i],
				[
					d,
					[m, N],
					[p, b]
				],
				[/(bravia[\w ]+)( bui|\))/i],
				[
					d,
					[m, P],
					[p, b]
				],
				[/(mi(tv|box)-?\w+) bui/i],
				[
					d,
					[m, F],
					[p, b]
				],
				[/Hbbtv.*(technisat) (.*);/i],
				[
					m,
					d,
					[p, b]
				],
				[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],
				[
					[m, _e],
					[d, _e],
					[p, b]
				],
				[/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],
				[d, [p, b]],
				[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],
				[[p, b]],
				[/(ouya)/i, /(nintendo) ([wids3utch]+)/i],
				[
					m,
					d,
					[p, _]
				],
				[/droid.+; (shield)( bui|\))/i],
				[
					d,
					[m, j],
					[p, _]
				],
				[/(playstation \w+)/i],
				[
					d,
					[m, P],
					[p, _]
				],
				[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],
				[
					d,
					[m, ae],
					[p, _]
				],
				[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],
				[
					d,
					[m, le],
					[p, x]
				],
				[/((pebble))app/i, /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],
				[
					m,
					d,
					[p, x]
				],
				[/(ow(?:19|20)?we?[1-3]{1,3})/i],
				[
					d,
					[m, ce],
					[p, x]
				],
				[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],
				[
					d,
					[m, w],
					[p, x]
				],
				[/(opwwe\d{3})/i],
				[
					d,
					[m, M],
					[p, x]
				],
				[/(moto 360)/i],
				[
					d,
					[m, oe],
					[p, x]
				],
				[/(smartwatch 3)/i],
				[
					d,
					[m, P],
					[p, x]
				],
				[/(g watch r)/i],
				[
					d,
					[m, A],
					[p, x]
				],
				[/droid.+; (wt63?0{2,3})\)/i],
				[
					d,
					[m, I],
					[p, x]
				],
				[/droid.+; (glass) \d/i],
				[
					d,
					[m, ne],
					[p, x]
				],
				[/(pico) (4|neo3(?: link|pro)?)/i],
				[
					m,
					d,
					[p, x]
				],
				[/; (quest( \d| pro)?)/i],
				[
					d,
					[m, L],
					[p, x]
				],
				[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],
				[m, [p, S]],
				[/(aeobc)\b/i],
				[
					d,
					[m, C],
					[p, S]
				],
				[/(homepod).+mac os/i],
				[
					d,
					[m, w],
					[p, S]
				],
				[/windows iot/i],
				[[p, S]],
				[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],
				[d, [p, v]],
				[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],
				[d, [p, y]],
				[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],
				[[p, y]],
				[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],
				[[p, v]],
				[/droid .+?; ([\w\. -]+)( bui|\))/i],
				[d, [m, "Generic"]]
			],
			engine: [
				[/windows.+ edge\/([\w\.]+)/i],
				[h, [f, te + "HTML"]],
				[/(arkweb)\/([\w\.]+)/i],
				[f, h],
				[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],
				[h, [f, "Blink"]],
				[
					/(presto)\/([\w\.]+)/i,
					/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
					/ekioh(flow)\/([\w\.]+)/i,
					/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
					/(icab)[\/ ]([23]\.[\d\.]+)/i,
					/\b(libweb)/i
				],
				[f, h],
				[/ladybird\//i],
				[[f, "LibWeb"]],
				[/rv\:([\w\.]{1,9})\b.+(gecko)/i],
				[h, f]
			],
			os: [
				[/microsoft (windows) (vista|xp)/i],
				[f, h],
				[/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],
				[f, [
					h,
					ve,
					V
				]],
				[
					/windows nt 6\.2; (arm)/i,
					/windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
					/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
				],
				[[
					h,
					ve,
					V
				], [f, "Windows"]],
				[
					/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
					/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
					/cfnetwork\/.+darwin/i
				],
				[[
					h,
					/_/g,
					"."
				], [f, "iOS"]],
				[/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i],
				[[f, de], [
					h,
					/_/g,
					"."
				]],
				[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],
				[h, f],
				[/(ubuntu) ([\w\.]+) like android/i],
				[[
					f,
					/(.+)/,
					"$1 Touch"
				], h],
				[/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i],
				[f, h],
				[/\(bb(10);/i],
				[h, [f, T]],
				[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],
				[h, [f, "Symbian"]],
				[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],
				[h, [f, O + " OS"]],
				[/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],
				[h, [f, "webOS"]],
				[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],
				[h, [f, "watchOS"]],
				[/crkey\/([\d\.]+)/i],
				[h, [f, D + "cast"]],
				[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],
				[[f, ue], h],
				[
					/panasonic;(viera)/i,
					/(netrange)mmh/i,
					/(nettv)\/(\d+\.[\w\.]+)/i,
					/(nintendo|playstation) ([wids345portablevuch]+)/i,
					/(xbox); +xbox ([^\);]+)/i,
					/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
					/(mint)[\/\(\) ]?(\w*)/i,
					/(mageia|vectorlinux)[; ]/i,
					/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
					/(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
					/(gnu) ?([\w\.]*)/i,
					/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
					/(haiku) (\w+)/i
				],
				[f, h],
				[/(sunos) ?([\w\.\d]*)/i],
				[[f, "Solaris"], h],
				[
					/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
					/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
					/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
					/(unix) ?([\w\.]*)/i
				],
				[f, h]
			]
		}, H = function(e, t) {
			if (typeof e == c && (t = e, e = r), !(this instanceof H)) return new H(e, t).getResult();
			var i = typeof n !== s && n.navigator ? n.navigator : r, _ = e || (i && i.userAgent ? i.userAgent : a), b = i && i.userAgentData ? i.userAgentData : r, x = t ? fe(ye, t) : ye, S = i && i.userAgent == _;
			return this.getBrowser = function() {
				var e = {};
				return e[f] = r, e[h] = r, z.call(e, _, x.browser), e[u] = ge(e[h]), S && i && i.brave && typeof i.brave.isBrave == o && (e[f] = "Brave"), e;
			}, this.getCPU = function() {
				var e = {};
				return e[g] = r, z.call(e, _, x.cpu), e;
			}, this.getDevice = function() {
				var e = {};
				return e[m] = r, e[d] = r, e[p] = r, z.call(e, _, x.device), S && !e[p] && b && b.mobile && (e[p] = v), S && e[d] == "Macintosh" && i && typeof i.standalone !== s && i.maxTouchPoints && i.maxTouchPoints > 2 && (e[d] = "iPad", e[p] = y), e;
			}, this.getEngine = function() {
				var e = {};
				return e[f] = r, e[h] = r, z.call(e, _, x.engine), e;
			}, this.getOS = function() {
				var e = {};
				return e[f] = r, e[h] = r, z.call(e, _, x.os), S && !e[f] && b && b.platform && b.platform != "Unknown" && (e[f] = b.platform.replace(/chrome os/i, ue).replace(/macos/i, de)), e;
			}, this.getResult = function() {
				return {
					ua: this.getUA(),
					browser: this.getBrowser(),
					engine: this.getEngine(),
					os: this.getOS(),
					device: this.getDevice(),
					cpu: this.getCPU()
				};
			}, this.getUA = function() {
				return _;
			}, this.setUA = function(e) {
				return _ = typeof e == l && e.length > 500 ? _e(e, 500) : e, this;
			}, this.setUA(_), this;
		};
		H.VERSION = i, H.BROWSER = pe([
			f,
			h,
			u
		]), H.CPU = pe([g]), H.DEVICE = pe([
			d,
			m,
			p,
			_,
			v,
			b,
			y,
			x,
			S
		]), H.ENGINE = H.OS = pe([f, h]), typeof e === s ? typeof define === o && define.amd ? define(function() {
			return H;
		}) : typeof n !== s && (n.UAParser = H) : (typeof t !== s && t.exports && (e = t.exports = H), e.UAParser = H);
		var U = typeof n !== s && (n.jQuery || n.Zepto);
		if (U && !U.ua) {
			var be = new H();
			U.ua = be.getResult(), U.ua.get = function() {
				return be.getUA();
			}, U.ua.set = function(e) {
				be.setUA(e);
				var t = be.getResult();
				for (var n in t) U.ua[n] = t[n];
			};
		}
	})(typeof window == "object" ? window : e);
})), ba = /* @__PURE__ */ h({
	DVCPopulatedUser: () => oo,
	StoreKey: () => X,
	UserError: () => Ui,
	dvcDefaultLogger: () => ja,
	initialize: () => To,
	initializeDevCycle: () => Ma
});
function xa() {
	return typeof self < "u" && self.constructor && self.constructor.name === "ServiceWorkerGlobalScope";
}
function Sa(e, t, n) {
	return {
		events: n.map((n) => new Ga(n, t.user_id, e)),
		user: t
	};
}
async function Ca(e) {
	if (!e.ok && e.status >= 400) {
		let t;
		try {
			let n = await e.clone().json();
			t = new Ka(n.message || "Something went wrong");
		} catch {
			t = new Ka("Something went wrong");
		}
		throw t.status = e.status, t;
	}
	return e;
}
async function wa(e, t, n) {
	let r = new AbortController();
	try {
		let i = setTimeout(() => {
			r.abort();
		}, n), a = await Da(e, {
			...t,
			signal: r.signal
		});
		return clearTimeout(i), a;
	} catch (e) {
		throw r?.signal?.aborted ? Error("Network connection timed out.") : e;
	}
}
async function Ta(e, t, n) {
	let [r, i] = await ka(t), a = {
		...i.headers,
		Authorization: n,
		"Content-Type": "application/json"
	};
	return Ca(await r(e, {
		...i,
		headers: a,
		method: "POST"
	}));
}
async function Ea(e, t, n) {
	let [r, i] = await ka(t), a = {
		...i.headers,
		Authorization: n,
		"Content-Type": "application/json"
	};
	return Ca(await r(e, {
		...i,
		headers: a,
		method: "PATCH"
	}));
}
async function Da(e, t) {
	let [n, r] = await ka(t), i = {
		...r.headers,
		"Content-Type": "application/json"
	};
	return Ca(await n(e, {
		...r,
		headers: i,
		method: "GET"
	}));
}
function Oa() {
	return (0, Pa.default)(fetch);
}
async function ka(e) {
	if ("retries" in e && e.retries) {
		let t = { ...e };
		return t.retryOn = Ja(e.retries), t.retryDelay = qa, [Oa(), t];
	}
	return [fetch, e];
}
function Aa() {
	return xa() ? new po() : new uo(typeof window > "u");
}
function ja(e) {
	let t = e?.level && (0, Ia.default)(vo[e?.level]) ? vo[e?.level] : vo.error, n = e?.logWriter || console.log, r = e?.logWriter || console.error, i = (e) => n(_o + e), a = (e, t) => r(_o + e, t), o = (e) => {};
	return {
		error: vo.error >= t ? a : o,
		warn: vo.warn >= t ? i : o,
		info: vo.info >= t ? i : o,
		debug: vo.debug >= t ? i : o
	};
}
function Ma(e, t, n = {}) {
	if (!e) throw new Ui("Missing SDK key! Call initialize with a valid SDK key");
	if (!e.startsWith("client") && !e.startsWith("dvc_client") && !n?.next) throw new Ui("Invalid SDK key provided. Please call initialize with a valid client SDK key");
	let r = wo(t, n), { options: i } = r, a = xa();
	if (typeof window < "u" && !window.addEventListener && !a && !i?.reactNative) throw Error("Window is not defined, try initializing in a browser context. If running on React Native, initialize with the option reactNative: true");
	if (i?.reactNative && !globalThis.DeviceInfo) throw Error("DeviceInfo is not defined. Import react-native-device-info and set global.DeviceInfo when running on React Native");
	if (!i || i === null) throw Error("Invalid options! Call initialize with valid options");
	let o;
	return o = r.isDeferred ? new So(e, void 0, r.options) : new So(e, r.user, r.options), o.onClientInitialized().then(() => o.logger.info("Successfully initialized DevCycle!")).catch((e) => o.logger.error(`Error initializing DevCycle: ${e}`)), o;
}
var Na, Pa, Fa, Ia, X, La, Ra, za, Ba, Va, Ha, Ua, Wa, Ga, Ka, qa, Ja, Ya, Xa, Za, Qa, $a, eo, to, no, ro, io, ao, oo, so, co, lo, uo, fo, po, Z, mo, ho, go, _o, vo, yo, bo, xo, So, Co, wo, To, Eo = p((() => {
	Wi(), Na = /* @__PURE__ */ _(aa()), Pa = /* @__PURE__ */ _(oa()), va(), Fa = /* @__PURE__ */ _(ya()), Ia = /* @__PURE__ */ _(Br()), X = {
		User: "dvc:user",
		AnonUserId: "dvc:anonymous_user_id",
		AnonymousConfig: "dvc:anonymous_config",
		IdentifiedConfig: "dvc:identified_config"
	}, La = (e) => e instanceof Date ? e.getTime() : typeof e == "object" ? JSON.stringify(e) : e, Ra = (e, t) => {
		for (let n in e) {
			let r = La(e[n]);
			r != null && t.append(n, r);
		}
	}, za = (e, t) => {
		if (!Ba(t)) throw Error(`Missing parameter: ${e}`);
	}, Ba = (e) => e != null, Va = (e, t, n) => {
		if (!t) throw Error(`Missing parameter: ${e}`);
		if (typeof t !== n) throw Error(`${e} is not of type ${n}`);
	}, Ha = class {
		constructor(e) {
			let { key: t, defaultValue: n } = e;
			Va("key", t, "string"), za("defaultValue", n), this.key = t.toLowerCase(), e.value === void 0 || e.value === null ? (this.isDefaulted = !0, this.value = n) : (this.value = e.value, this.isDefaulted = !1), this.defaultValue = e.defaultValue, this.eval = e.eval, this._feature = e._feature || null;
		}
		onUpdate(e) {
			return Va("callback", e, "function"), this.callback = e, this;
		}
	}, Ua = {
		variableEvaluated: "variableEvaluated",
		variableDefaulted: "variableDefaulted"
	}, Wa = class {
		constructor(e, t, n) {
			this.eventQueueBatchSize = 100, this.sdkKey = e, this.client = t, this.eventQueue = [], this.aggregateEventMap = {}, this.options = n;
			let r = typeof n.eventFlushIntervalMS == "number" ? n.eventFlushIntervalMS : 1e4;
			if (r < 500) throw Error(`eventFlushIntervalMS: ${r} must be larger than 500ms`);
			if (r > 6e4) throw Error(`eventFlushIntervalMS: ${r} must be smaller than 1 minute`);
			if (n.next?.disableAutomaticEventFlush || (this.flushInterval = setInterval(this.flushEvents.bind(this), r)), this.flushEventQueueSize = n?.flushEventQueueSize ?? 100, this.maxEventQueueSize = n?.maxEventQueueSize ?? 1e3, this.flushEventQueueSize >= this.maxEventQueueSize) throw Error(`flushEventQueueSize: ${this.flushEventQueueSize} must be smaller than maxEventQueueSize: ${this.maxEventQueueSize}`);
			if (this.flushEventQueueSize < 10 || this.flushEventQueueSize > 1e3) throw Error(`flushEventQueueSize: ${this.flushEventQueueSize} must be between 10 and 1000`);
			if (this.maxEventQueueSize < 100 || this.maxEventQueueSize > 5e3) throw Error(`maxEventQueueSize: ${this.maxEventQueueSize} must be between 100 and 5000`);
		}
		async flushEvents() {
			let e = this.client.user;
			if (!e) {
				this.client.logger.warn("Skipping event flush, user has not been set yet.");
				return;
			}
			let t = [...this.eventQueue], n = this.eventsFromAggregateEventMap();
			if (t.push(...n), !t.length) return;
			this.client.logger.info(`Flush ${t.length} Events`), this.eventQueue = [], this.aggregateEventMap = {};
			let r = (0, Na.default)(t, this.eventQueueBatchSize);
			for (let t of r) try {
				let n = await ro(this.sdkKey, this.client.config, e, t, this.client.logger, this.options);
				n.status === 201 ? this.client.logger.info(`DevCycle Flushed ${t.length} Events.`) : n.status >= 500 || n.status === 408 ? (this.client.logger.warn(`failed to flush events, retrying events. Response status: ${n.status}, message: ${n.statusText}`), this.eventQueue.push(...t)) : this.client.logger.error(`failed to flush events, dropping events. Response status: ${n.status}, message: ${n.statusText}`);
			} catch (e) {
				this.client.eventEmitter.emitError(e), this.client.logger.error(`failed to flush events due to error, dropping events. Error message: ${e?.message}`);
			}
		}
		queueEvent(e) {
			if (this.checkEventQueueSize()) {
				this.client.logger.warn(`DevCycle: Max event queue size (${this.maxEventQueueSize}) reached, dropping event: ${e}`);
				return;
			}
			this.eventQueue.push(e);
		}
		queueAggregateEvent(e) {
			if (this.checkEventQueueSize()) {
				this.client.logger.warn(`DevCycle: Max event queue size (${this.maxEventQueueSize}) reached, dropping event: ${e}`);
				return;
			}
			za("type", e.type), za("target", e.target), e.date = Date.now(), e.value = 1;
			let t = this.aggregateEventMap[e.type];
			t ? t[e.target] ? t[e.target].value++ : t[e.target] = e : this.aggregateEventMap[e.type] = { [e.target]: e };
		}
		checkEventQueueSize() {
			let e = Object.values(this.aggregateEventMap).reduce((e, t) => e + Object.keys(t).length, 0), t = this.eventQueue.length + e;
			return t >= this.flushEventQueueSize && this.flushEvents(), t >= this.maxEventQueueSize;
		}
		eventsFromAggregateEventMap() {
			return Object.values(this.aggregateEventMap).map((e) => Object.values(e)).flat();
		}
		async close() {
			clearInterval(this.flushInterval), await this.flushEvents();
		}
	}, Ga = class {
		constructor(e, t, n) {
			let { type: r, target: i, date: a, value: o, metaData: s } = e;
			za("type", r);
			let c = !(r in Ua);
			if (this.type = c ? "customEvent" : r, this.customType = c ? r : void 0, this.target = i, this.user_id = t, this.clientDate = a || Date.now(), this.value = o, n && n.settings?.filterFeatureVars && (r === "variableEvaluated" || r === "variableDefaulted") && i) {
				let e = n?.variables[i]?._feature;
				this.featureVars = e && n?.featureVariationMap[e] ? { [e]: n?.featureVariationMap[e] } : {};
			} else this.featureVars = n?.featureVariationMap || {};
			this.metaData = s;
		}
	}, Ka = class extends Error {
		constructor(e) {
			super(e), this.name = "ResponseError";
		}
	}, qa = (e) => {
		let t = 2 ** e * 100;
		return t + t * .2 * Math.random();
	}, Ja = (e) => (t, n, r) => t >= e ? !1 : !(r && r?.status < 500), Ya = ".devcycle.com", Xa = "https://sdk-api" + Ya, Za = "https://events" + Ya, Qa = "/v1/sdkConfig", $a = "/v1/events", eo = "/v1/edgedb", to = {
		retries: 5,
		retryDelay: qa
	}, no = async (e, t, n, r, i) => {
		let a = new URLSearchParams({ sdkKey: e });
		Ra(t, a), r?.enableEdgeDB && a.append("enableEdgeDB", r.enableEdgeDB.toString()), i?.sse && (a.append("sse", "1"), i.lastModified && a.append("sseLastModified", i.lastModified.toString()), i.etag && a.append("sseEtag", i.etag)), r?.enableObfuscation && a.append("obfuscated", "1");
		let o = `${r?.apiProxyURL || Xa}${Qa}?` + a.toString();
		try {
			return await (await wa(o, to, 5e3)).json();
		} catch (e) {
			throw n.error(`Request to get config failed for url: ${o}, response message: ${e}`), e instanceof Ka ? e.status === 401 || e.status === 403 ? new Ui(`Invalid SDK Key. Error details: ${e.message}`) : Error(`Failed to download DevCycle config. Error details: ${e.message}`) : Error(`Failed to download DevCycle config. Error details: ${e}`);
		}
	}, ro = async (e, t, n, r, i, a) => {
		if (!e) throw Error("Missing sdkKey to publish events to Events API");
		let o = Sa(t, n, r);
		i.info(`Submit Events Payload: ${JSON.stringify(o)}`);
		let s = `${a?.apiProxyURL || Za}${$a}`;
		a?.enableObfuscation && (s += "?obfuscated=1");
		let c = await Ta(s, {
			...to,
			body: JSON.stringify(o)
		}, e), l = await c.json();
		return c.status >= 400 ? i.error(`Error posting events, status: ${c.status}, body: ${l}`) : i.info(`Posted Events, status: ${c.status}, body: ${l}`), c;
	}, io = async (e, t, n, r) => {
		if (!t) throw Error("Missing sdkKey to save to Edge DB!");
		if (!e || !e.user_id) throw Error("Missing user to save to Edge DB!");
		if (e.isAnonymous) throw Error("Cannot save user data for an anonymous user!");
		try {
			return await Ea(`${r?.apiProxyURL || Xa}${eo}/${encodeURIComponent(e.user_id)}`, {
				...to,
				body: JSON.stringify(e)
			}, t);
		} catch (e) {
			let t = e;
			t.status === 403 ? n.warn("Warning: EdgeDB feature is not enabled for this project") : t.status >= 400 ? n.warn(`Error saving user entity, status: ${t.status}, body: ${t.message}`) : n.info(`Saved user entity, status: ${t.status}, body: ${t.message}`);
			return;
		}
	}, ao = {
		name: "@devcycle/js-client-sdk",
		version: "1.47.8",
		description: "The Javascript Client SDK for DevCycle",
		author: "DevCycle <support@devcycle.com>",
		keywords: [
			"devcycle",
			"feature flag",
			"javascript",
			"client",
			"sdk"
		],
		license: "MIT",
		homepage: "https://devcycle.com",
		typesVersions: { "<4.0": { "*": ["./ts3.5/*"] } },
		types: "./index.cjs.d.ts",
		devDependencies: { "cross-fetch": "^4.1.0" },
		dependencies: {
			"@devcycle/types": "1.32.5",
			"fetch-retry": "^5.0.6",
			lodash: "^4.17.21",
			"ua-parser-js": "^1.0.40",
			uuid: "^8.3.2"
		},
		repository: {
			type: "git",
			url: "git://github.com/DevCycleHQ/js-sdks.git"
		}
	}, oo = class e {
		generateAndSaveAnonUserId(e, t) {
			let n = e || ga();
			return !e && t && t.saveAnonUserId(n), n;
		}
		constructor(e, t, n, r, i, a) {
			let o = e.user_id === "" ? void 0 : e.user_id;
			if (e.isAnonymous === !1 && !o) throw Error("A User cannot be created with isAnonymous: false without a valid user_id");
			o ? (this.user_id = o, this.isAnonymous = !1) : (this.user_id = this.generateAndSaveAnonUserId(r, a), this.isAnonymous = !0), this.email = e.email, this.name = e.name, this.language = e.language, this.country = e.country, this.appVersion = e.appVersion, this.appBuild = e.appBuild, this.customData = e.customData, this.privateCustomData = e.privateCustomData, this.lastSeenDate = /* @__PURE__ */ new Date();
			let s = typeof window < "u" ? window.navigator.userAgent : i;
			if (n) Object.assign(this, n);
			else {
				let e = new Fa.default(s), n = e.getBrowser().name && `${e.getBrowser().name} ${e.getBrowser().version}`;
				this.createdDate = /* @__PURE__ */ new Date(), this.platform = t?.reactNative ? "ReactNative" : "web", this.platformVersion = n ?? "unknown", this.deviceModel = t?.reactNative && globalThis.DeviceInfo ? globalThis.DeviceInfo.getModel() : s ?? "SSR - unknown", this.sdkType = "client", this.sdkVersion = ao.version, this.sdkPlatform = t?.sdkPlatform;
			}
		}
		getStaticData() {
			return {
				createdDate: this.createdDate,
				platform: this.platform,
				platformVersion: this.platformVersion,
				deviceModel: this.deviceModel,
				sdkType: this.sdkType,
				sdkVersion: this.sdkVersion,
				sdkPlatform: this.sdkPlatform
			};
		}
		updateUser(t, n) {
			if (this.user_id !== t.user_id) throw Error("Cannot update a user with a different user_id");
			return new e(t, n, this.getStaticData());
		}
	}, so = 2592e6, co = class {
		constructor(e, t, n = so) {
			this.store = e, this.logger = t, this.configCacheTTL = n;
		}
		getConfigKey(e) {
			return e.isAnonymous ? `${X.AnonymousConfig}.${e.user_id}` : `${X.IdentifiedConfig}.${e.user_id}`;
		}
		getConfigExpiryKey(e) {
			return `${this.getConfigKey(e)}.expiry_date`;
		}
		async loadConfigExpiryDate(e) {
			let t = this.getConfigExpiryKey(e), n = await this.store.load(t) || "0";
			return parseInt(n, 10);
		}
		async saveConfig(e, t) {
			var n;
			let r = this.getConfigKey(t), i = this.getConfigExpiryKey(t), a = Date.now() + this.configCacheTTL;
			await Promise.all([this.store.save(r, e), this.store.save(i, a)]), (n = this.logger) == null || n.info(`Successfully saved config for user ${t.user_id} to local storage`);
		}
		isBucketedUserConfig(e) {
			return !e || typeof e != "object" ? !1 : "features" in e && "project" in e && "environment" in e && "featureVariationMap" in e && "variableVariationMap" in e && "variables" in e;
		}
		async loadConfig(e) {
			var t, n, r;
			await this.migrateLegacyConfigs(), await this.cleanupExpiredConfigs();
			let i = this.getConfigKey(e), a = await this.store.load(i);
			if (!a) return (t = this.logger) == null || t.debug("Skipping cached config: no config found"), null;
			if (!this.isBucketedUserConfig(a)) return (n = this.logger) == null || n.debug(`Skipping cached config: invalid config found: ${JSON.stringify(a)}`), null;
			let o = await this.loadConfigExpiryDate(e);
			if (Date.now() > o) {
				(r = this.logger) == null || r.debug("Skipping cached config: config has expired");
				let t = this.getConfigExpiryKey(e);
				return await Promise.all([this.store.remove(i), this.store.remove(t)]), null;
			}
			return a;
		}
		async saveAnonUserId(e) {
			var t;
			await this.store.save(X.AnonUserId, e), (t = this.logger) == null || t.info("Successfully saved anonymous user id to local storage");
		}
		async loadAnonUserId() {
			return await this.store.load(X.AnonUserId);
		}
		async removeAnonUserId() {
			let e = await this.loadAnonUserId();
			if (e) {
				let t = `${X.AnonymousConfig}.${e}`, n = `${t}.expiry_date`;
				await Promise.all([this.store.remove(t), this.store.remove(n)]);
			}
			await this.store.remove(X.AnonUserId);
		}
		async migrateLegacyConfigs() {
			await Promise.all([this.migrateLegacyConfigType(X.AnonymousConfig, !0), this.migrateLegacyConfigType(X.IdentifiedConfig, !1)]);
		}
		async migrateLegacyConfigType(e, t) {
			var n, r;
			try {
				let r = await this.store.load(e);
				if (!r || !this.isBucketedUserConfig(r)) return;
				let i = `${e}.user_id`, a = await this.store.load(i);
				if (!a) return;
				let o = new oo({
					user_id: a,
					isAnonymous: t
				}, {}), s = `${e}.fetch_date`, c = this.getConfigKey(o);
				if (await this.store.load(c)) {
					await Promise.all([
						this.store.remove(e),
						this.store.remove(i),
						this.store.remove(s),
						this.store.remove(X.User)
					]);
					return;
				}
				(n = this.logger) == null || n.debug(`Migrating legacy ${t ? "anonymous" : "identified"} config for user ${a} to new format`), await this.saveConfig(r, o), await Promise.all([
					this.store.remove(e),
					this.store.remove(i),
					this.store.remove(s),
					this.store.remove(X.User)
				]);
			} catch (t) {
				(r = this.logger) == null || r.debug(`Failed to migrate legacy config from ${e}: ${t}`);
			}
		}
		async cleanupExpiredConfigs() {
			var e, t, n, r;
			if (!this.store.listKeys) {
				(e = this.logger) == null || e.debug("Storage does not support key enumeration, skipping cleanup");
				return;
			}
			try {
				let e = Date.now(), r = [X.AnonymousConfig, X.IdentifiedConfig];
				for (let i of r) {
					let r = await this.store.listKeys(i);
					for (let i of r) {
						if (i.endsWith(".expiry_date")) continue;
						let r = `${i}.expiry_date`, a = await this.store.load(r);
						a ? e > parseInt(a, 10) && ((t = this.logger) == null || t.debug(`Cleaning up expired config: ${i}`), await Promise.all([this.store.remove(i), this.store.remove(r)])) : ((n = this.logger) == null || n.debug(`Cleaning up orphaned config: ${i}`), await this.store.remove(i));
					}
				}
			} catch (e) {
				(r = this.logger) == null || r.debug(`Failed to cleanup expired configs: ${e}`);
			}
		}
	}, lo = class {}, uo = class extends lo {
		constructor(e = !1) {
			super(), this.isTesting = e, this.init();
		}
		async init() {
			this.store = this.isTesting ? fo : window.localStorage;
		}
		async save(e, t) {
			this.store.setItem(e, JSON.stringify(t));
		}
		async load(e) {
			let t = this.store.getItem(e);
			return t ? JSON.parse(t) : void 0;
		}
		async remove(e) {
			this.store.removeItem(e);
		}
		async listKeys(e) {
			let t = [];
			for (let n = 0; n < this.store.length; n++) {
				let r = this.store.key(n);
				r && r.startsWith(e) && t.push(r);
			}
			return t;
		}
	}, fo = {
		getItem: () => null,
		setItem: () => void 0,
		removeItem: () => void 0,
		clear: () => void 0,
		key: () => null,
		length: 0
	}, po = class e extends lo {
		constructor() {
			super(), this.connectionPromise = new Promise((e, t) => {
				this.init().then((t) => {
					this.store = t, this.isReady = !0, e();
				}).catch((e) => t(e));
			});
		}
		async init() {
			return new Promise((t, n) => {
				let r = indexedDB.open(e.DBName, 1);
				r.onupgradeneeded = (t) => {
					let n = r.result;
					n.objectStoreNames.contains(e.storeName) || n.createObjectStore(e.storeName, { keyPath: "id" });
				}, r.onsuccess = (e) => {
					t(r.result);
				}, r.onerror = (e) => {
					n(r.error);
				};
			});
		}
		async save(t, n) {
			await this.connectionPromise, this.store.transaction(e.storeName, "readwrite").objectStore(e.storeName).put({
				id: t,
				data: n
			});
		}
		async load(t) {
			await this.connectionPromise;
			let n = this.store.transaction(e.storeName, "readonly").objectStore(e.storeName).get(t);
			return new Promise((e, t) => {
				n.onsuccess = () => {
					e(n.result ? n.result.data : void 0);
				}, n.onerror = () => t(n.error);
			});
		}
		async remove(t) {
			await this.connectionPromise, this.store.transaction(e.storeName, "readwrite").objectStore(e.storeName).delete(t);
		}
		async listKeys(t) {
			let n = [];
			await this.connectionPromise;
			let r = this.store.transaction(e.storeName, "readonly").objectStore(e.storeName).openCursor();
			return new Promise((e, i) => {
				r.onsuccess = (r) => {
					let i = r.target.result;
					if (i) {
						let e = i.key;
						e.startsWith(t) && n.push(e), i.continue();
					} else e(n);
				}, r.onerror = () => i(r.error);
			});
		}
	}, po.storeName = "DevCycleStore", po.DBName = "DevCycleDB", Z = {
		INITIALIZED: "initialized",
		NEW_VARIABLES: "newVariables",
		ERROR: "error",
		VARIABLE_UPDATED: "variableUpdated",
		FEATURE_UPDATED: "featureUpdated",
		CONFIG_UPDATED: "configUpdated",
		VARIABLE_EVALUATED: "variableEvaluated",
		DEBUG_USER_SET: "debugUserSet",
		DEBUG_USER_REVERTED: "debugUserReverted"
	}, mo = (e) => !Object.values(Z).includes(e) && !e.startsWith(Z.VARIABLE_UPDATED) && !e.startsWith(Z.FEATURE_UPDATED) && !e.startsWith(Z.NEW_VARIABLES) && !e.startsWith(Z.VARIABLE_EVALUATED), ho = class {
		constructor() {
			this.handlers = {};
		}
		subscribe(e, t) {
			if (Va("key", e, "string"), Va("handler", t, "function"), mo(e)) throw Error("Not a valid event to subscribe to");
			this.handlers[e] ? this.handlers[e].push(t) : this.handlers[e] = [t];
		}
		unsubscribe(e, t) {
			if (Va("key", e, "string"), !mo(e)) {
				if (t) {
					let n = this.handlers[e].findIndex((e) => e === t);
					this.handlers[e].splice(n, 1);
				} else this.handlers[e] = [];
			}
		}
		emit(e, ...t) {
			var n;
			Va("key", e, "string"), (n = this.handlers[e]) == null || n.forEach((e) => {
				new Promise((n) => {
					e(...t), n(!0);
				});
			});
		}
		emitDebugUserSet(e) {
			this.emit(Z.DEBUG_USER_SET, e);
		}
		emitDebugUserReverted(e) {
			this.emit(Z.DEBUG_USER_REVERTED, e);
		}
		emitInitialized(e) {
			this.emit(Z.INITIALIZED, e);
		}
		emitError(e) {
			this.emit(Z.ERROR, e);
		}
		emitConfigUpdate(e) {
			this.emit(Z.CONFIG_UPDATED, e);
		}
		emitVariableEvaluated(e) {
			this.emit(`${Z.VARIABLE_EVALUATED}:*`, e.key, e), this.emit(`${Z.VARIABLE_EVALUATED}:${e.key}`, e.key, e);
		}
		emitVariableUpdates(e, t, n) {
			let r = new Set(Object.keys(e).concat(Object.keys(t))), i = !1;
			r.forEach((r) => {
				let a = e[r] && e[r].value, o = t[r], s = o && t[r].value;
				if (JSON.stringify(a) !== JSON.stringify(s)) {
					let e = n[r] && Object.values(n[r]);
					e && (i = !0, e.forEach((e) => {
						var t;
						e.value = s ?? e.defaultValue, e.isDefaulted = s == null, (t = e.callback) == null || t.call(e, e.value);
					}));
					let t = o || null;
					this.emit(`${Z.VARIABLE_UPDATED}:*`, r, t), this.emit(`${Z.VARIABLE_UPDATED}:${r}`, r, t);
				}
			}), i && this.emit(`${Z.NEW_VARIABLES}`);
		}
		emitFeatureUpdates(e, t) {
			Object.keys(e).concat(Object.keys(t)).forEach((n) => {
				let r = e[n] && e[n]._variation, i = t[n], a = i && t[n]._variation, o = i || null;
				r !== a && (this.emit(`${Z.FEATURE_UPDATED}:*`, n, o), this.emit(`${Z.FEATURE_UPDATED}:${n}`, n, o));
			});
		}
	}, go = class {
		constructor(e, t, n) {
			this.requestConfigFunction = e, this.handleConfigReceivedFunction = t, this.nextUser = n, this.resolvers = [], this.requestParams = null;
		}
		async queue(e, t) {
			e && (this.nextUser = e), t && (this.requestParams = t);
			let n = new Promise((e, t) => {
				this.resolvers.push({
					resolve: e,
					reject: t
				});
			});
			return this.currentPromise || this.processQueue(), n;
		}
		async processQueue() {
			if (!this.resolvers.length) return;
			let e = this.resolvers.splice(0);
			await this.performRequest(this.nextUser).then((t) => {
				this.resolvers.length ? this.resolvers.push(...e) : (this.handleConfigReceivedFunction(t, this.nextUser), e.forEach(({ resolve: e }) => e(t)));
			}).catch((t) => {
				e.forEach(({ reject: e }) => e(t));
			}), this.resolvers.length && this.processQueue();
		}
		async performRequest(e) {
			return this.currentPromise = this.requestConfigFunction(e, this.requestParams ? this.requestParams : void 0), this.requestParams = null, await this.currentPromise.finally(() => {
				this.currentPromise = null;
			});
		}
	}, _o = "[DevCycle]: ", (function(e) {
		e[e.debug = 0] = "debug", e[e.info = 1] = "info", e[e.warn = 2] = "warn", e[e.error = 3] = "error";
	})(vo ||= {}), yo = class {
		constructor(e, t, n) {
			this.url = e, this.onMessage = t, this.logger = n, this.openConnection();
		}
		updateURL(e) {
			this.close(), this.url = e, this.openConnection();
		}
		openConnection() {
			if (typeof EventSource > "u") {
				this.logger.warn("StreamingConnection not opened. EventSource is not available.");
				return;
			}
			this.connection = new EventSource(this.url, { withCredentials: !0 }), this.connection.onmessage = (e) => {
				this.onMessage(e.data);
			}, this.connection.onerror = () => {
				this.logger.warn("StreamingConnection warning. Connection failed to establish.");
			}, this.connection.onopen = () => {
				this.logger.debug("StreamingConnection opened");
			};
		}
		isConnected() {
			return this.connection?.readyState === this.connection?.OPEN;
		}
		reopen() {
			this.isConnected() || (this.close(), this.openConnection());
		}
		close() {
			var e;
			(e = this.connection) == null || e.close();
		}
	}, bo = class {
		constructor(e, t, n, r, i) {
			this.user = e, this.variableKey = t, this.defaultValue = n, this.metadata = r, this.evaluationContext = i;
		}
	}, xo = class {
		constructor(e = [], t) {
			this.hooks = e, this.logger = t;
		}
		runHooksForEvaluation(e, t, n, r) {
			let i = new bo(e ?? {}, t, n, {}), a = [...this.hooks], o = [...a].reverse(), s;
			try {
				let e = Object.freeze({ ...i });
				this.runBefore(a, e), s = r.call(e), i.evaluationContext = {
					key: t,
					value: s.value,
					isDefaulted: s.isDefaulted,
					eval: s.eval
				}, this.runAfter(o, i);
			} catch (e) {
				throw this.runError(o, i, e), this.runFinally(o, i), e;
			}
			return this.runFinally(o, i), s;
		}
		runBefore(e, t) {
			for (let n of e) n.before(t);
		}
		runAfter(e, t) {
			for (let n of e) n.after(t);
		}
		runFinally(e, t) {
			var n;
			try {
				for (let n of e) n.onFinally(t);
			} catch (e) {
				(n = this.logger) == null || n.error("Error running before hooks", e);
			}
		}
		runError(e, t, n) {
			var r;
			try {
				for (let r of e) r.error(t, n);
			} catch (e) {
				(r = this.logger) == null || r.error("Error running error hooks", e);
			}
		}
		enqueue(e) {
			this.hooks.push(e);
		}
		clear() {
			this.hooks = [];
		}
	}, So = class {
		get isInitialized() {
			return this._isInitialized;
		}
		constructor(e, t, n = {}) {
			if (this._isInitialized = !1, this.userSaved = !1, this._closing = !1, this.isConfigCached = !1, this.initializeTriggered = !1, this.clientInitialization = async (e) => {
				if (this.initializeTriggered || this._closing) return this;
				this.initializeTriggered = !0;
				let t = e.user_id ? void 0 : await this.store.loadAnonUserId();
				this.user = new oo(e, this.options, void 0, t, void 0, this.store), this.options.bootstrapConfig || await this.getConfigCache(this.user), this.requestConsolidator = new go((e, t) => no(this.sdkKey, e, this.logger, this.options, t), (e, t) => this.handleConfigReceived(e, t), this.user);
				try {
					this.options.bootstrapConfig ? this.handleConfigReceived(this.options.bootstrapConfig, this.user) : await this.requestConsolidator.queue(this.user), this._isInitialized = !0, this.settleOnInitialized(this), this.logger.info("Client initialized");
				} catch (e) {
					return this.initializeOnConfigFailure(this.user, e), this;
				}
				return this.eventEmitter.emitInitialized(!0), this;
			}, this.initializeOnConfigFailure = (e, t) => {
				this.isInitialized || (this.eventEmitter.emitInitialized(!1), t && this.eventEmitter.emitError(t), this.setUser(e), this.settleOnInitialized(this, t instanceof Ui ? t : null));
			}, n.sdkPlatform ||= "js", n.next?.configRefreshHandler && (this.configRefetchHandler = n.next.configRefreshHandler), this.logger = n.logger || ja({ level: n.logLevel }), this.store = new co(n.storage || Aa(), this.logger, n.configCacheTTL), this.options = n, this.sdkKey = e, this.variableDefaultMap = {}, this.evalHooksRunner = new xo(n.hooks), this.options.disableAutomaticEventLogging && this.options.disableCustomEventLogging || (this.eventQueue = new Wa(e, this, n)), this.eventEmitter = new ho(), this.options.disableRealtimeUpdates || this.registerVisibilityChangeHandler(), this.onInitialized = new Promise((e, t) => {
				this.settleOnInitialized = (n, r) => {
					r ? (this._isInitialized = !1, t(r)) : (this._isInitialized = !0, e(n));
				};
			}), !this.options.deferInitialization) {
				if (!t) throw Error("User must be provided to initialize SDK");
				this.clientInitialization(t);
			} else if (this.options.bootstrapConfig) throw Error("bootstrapConfig option can not be combined with deferred initialization!");
			!n?.reactNative && typeof window < "u" && (this.windowMessageHandler = (e) => {
				e.data?.type === "DVC.optIn.saved" && this.refetchConfig(!1);
			}, window.addEventListener("message", this.windowMessageHandler), this.windowPageHideHandler = () => {
				this.flushEvents();
			}, window.addEventListener("pagehide", this.windowPageHideHandler));
		}
		onClientInitialized(e) {
			if (e && typeof e == "function") {
				this.onInitialized.then(() => e(null, this)).catch((t) => e(t));
				return;
			}
			return this.onInitialized;
		}
		variable(e, t) {
			return this.evalHooksRunner.runHooksForEvaluation(this.user, e, t, () => this._variable(e, t));
		}
		_variable(e, t) {
			if (t == null) throw Error("Default value is a required param");
			let n = ii(t, e, this.logger, !0), r = typeof t == "string" ? t : JSON.stringify(t), i;
			if (this.variableDefaultMap[e] && this.variableDefaultMap[e][r]) i = this.variableDefaultMap[e][r];
			else {
				let a = this.config?.variables?.[e], o = {
					key: e,
					defaultValue: t
				};
				a ? a.type === n ? (o.value = a.value, o._feature = a._feature, o.eval = a.eval) : (this.logger.warn(`Type mismatch for variable ${e}. Expected ${n}, got ${a.type}`), o.eval = {
					reason: fi.DEFAULT,
					details: mi.TYPE_MISMATCH
				}) : o.eval = {
					reason: fi.DEFAULT,
					details: mi.USER_NOT_TARGETED
				}, i = new Ha(o), this.variableDefaultMap[e] = {
					[r]: i,
					...this.variableDefaultMap[e]
				};
			}
			return this.trackVariableEvaluated(i), this.eventEmitter.emitVariableEvaluated(i), i;
		}
		trackVariableEvaluated(e) {
			var t;
			if (!this.options.disableAutomaticEventLogging) try {
				let n = this.config?.variables?.[e.key];
				(t = this.eventQueue) == null || t.queueAggregateEvent({
					type: e.isDefaulted ? Ua.variableDefaulted : Ua.variableEvaluated,
					target: e.key,
					metaData: {
						value: e.value,
						type: ii(e.defaultValue, e.key, this.logger),
						_variable: n?._id,
						eval: e.eval
					}
				});
			} catch (e) {
				this.eventEmitter.emitError(e), this.logger.warn(`Error with queueing aggregate events ${e}`);
			}
		}
		variableValue(e, t) {
			return this.variable(e, t).value;
		}
		identifyUser(e, t) {
			if (this.options.next) {
				this.logger.error("Unable to change user identity from the clientside in Next.js");
				return;
			}
			let n = this._identifyUser(e);
			if (t && typeof t == "function") {
				n.then((e) => t(null, e)).catch((e) => t(e, null));
				return;
			}
			return n;
		}
		async _identifyUser(e) {
			var t;
			let n;
			if (this.options.deferInitialization && !this.initializeTriggered) return await this.clientInitialization(e), this.config?.variables || {};
			(t = this.eventQueue) == null || t.flushEvents();
			try {
				await this.onInitialized;
				let t = await this.store.loadAnonUserId();
				n = this.user && e.user_id === this.user.user_id ? this.user.updateUser(e, this.options) : new oo(e, this.options, void 0, t, void 0, this.store);
				let r = await this.requestConsolidator.queue(n);
				if (r) return r.variables;
				throw this.logger.error("Config fetch returned no config"), Error("Failed to fetch user configuration");
			} catch (e) {
				if (n) try {
					let e = await this.store.loadConfig(n);
					if (e) return this.logger.warn("Config fetch failed, using cached user config"), this.handleConfigReceived(e, n), e.variables || {};
					this.logger.debug("Config fetch failed and no cached config available");
				} catch (e) {
					this.logger.error("Failed to load cached config", e);
				}
				throw this.eventEmitter.emitError(e), e;
			}
		}
		resetUser(e) {
			if (this.options.next) {
				this.logger.error("Unable to change user identity from the clientside in Next.js");
				return;
			}
			let t = new Promise((e, t) => {
				var n;
				(n = this.eventQueue) == null || n.flushEvents(), this.onInitialized.then(async () => {
					let e = await this.store.loadAnonUserId();
					await this.store.removeAnonUserId();
					let t = new oo({ isAnonymous: !0 }, this.options, void 0, void 0, void 0, this.store);
					try {
						let e = await this.requestConsolidator.queue(t);
						if (!e) throw this.logger.error("Config fetch returned no config"), Error("Failed to fetch user configuration");
						return e;
					} catch (t) {
						throw e ? await this.store.saveAnonUserId(e) : await this.store.removeAnonUserId(), t;
					}
				}).then(async (t) => {
					e(t.variables);
				}).catch(async (e) => {
					this.eventEmitter.emitError(e), t(e);
				});
			});
			if (e && typeof e == "function") {
				t.then((t) => e(null, t)).catch((t) => e(t, null));
				return;
			}
			return t;
		}
		allFeatures() {
			return this.config?.features || {};
		}
		allVariables() {
			return this.config?.variables || {};
		}
		subscribe(e, t) {
			this.eventEmitter.subscribe(e, t);
		}
		unsubscribe(e, t) {
			this.eventEmitter.unsubscribe(e, t);
		}
		track(e) {
			if (this._closing) {
				this.logger.error("Client is closing, cannot track new events.");
				return;
			}
			this.options.disableCustomEventLogging || (za("type", e.type), this.onInitialized.then(() => {
				var t;
				(t = this.eventQueue) == null || t.queueEvent(e);
			}));
		}
		flushEvents(e) {
			return this.eventQueue?.flushEvents().then(() => e?.()) ?? Promise.resolve().then(() => e?.());
		}
		async close() {
			var e;
			this.logger.debug("Closing client"), this._closing = !0, this.pageVisibilityHandler && document.removeEventListener("visibilitychange", this.pageVisibilityHandler), this.windowMessageHandler && window.removeEventListener("message", this.windowMessageHandler), this.windowPageHideHandler && window.removeEventListener("pagehide", this.windowPageHideHandler), (e = this.streamingConnection) == null || e.close(), await this.eventQueue?.close();
		}
		get closing() {
			return this._closing;
		}
		synchronizeBootstrapData(e, t, n) {
			let r = new oo(t, this.options, void 0, void 0, n, this.store);
			if (!e) {
				this.initializeOnConfigFailure(r);
				return;
			}
			if (this.options.bootstrapConfig = e, this.options.deferInitialization && !this.initializeTriggered) {
				this.clientInitialization(t);
				return;
			}
			this.handleConfigReceived(e, r);
		}
		async refetchConfig(e, t, n) {
			await this.onInitialized, this.configRefetchHandler ? this.configRefetchHandler(t) : await this.requestConsolidator.queue(null, {
				sse: e,
				lastModified: t,
				etag: n
			});
		}
		addHook(e) {
			this.evalHooksRunner.enqueue(e);
		}
		clearHooks() {
			this.evalHooksRunner.clear();
		}
		handleConfigReceived(e, t) {
			if (!e) return;
			let n = this.config;
			this.config = e, this.store.saveConfig(e, t), this.isConfigCached = !1, this.setUser(t);
			let r = n?.features || {}, i = n?.variables || {};
			this.eventEmitter.emitFeatureUpdates(r, e.features), this.eventEmitter.emitVariableUpdates(i, e.variables, this.variableDefaultMap);
			let a = (this.config?.sse?.url)?.includes("dvc_user");
			if ((!n || a || n.etag !== this.config.etag) && this.eventEmitter.emitConfigUpdate(e.variables), e?.sse?.url) {
				if (this.streamingConnection) e.sse.url !== n?.sse?.url && this.streamingConnection.updateURL(e.sse.url);
				else if (this.options.disableRealtimeUpdates) this.logger.info("Disabling Realtime Updates based on Initialization parameter");
				else {
					let t = this.options.sseConnectionClass || yo;
					this.streamingConnection = new t(e.sse.url, this.onSSEMessage.bind(this), this.logger);
				}
			}
		}
		async setUser(e) {
			if (this.user != e || !this.userSaved) {
				if (this.user = e, !this.user.isAnonymous && Co(this.logger, this.config, this.options?.enableEdgeDB, !0)) {
					let e = await io(this.user, this.sdkKey, this.logger, this.options);
					this.logger.info(`Saved response entity! ${e}`);
				}
				this.userSaved = !0;
			}
		}
		onSSEMessage(e) {
			try {
				let t = JSON.parse(e), n = JSON.parse(t.data);
				if (!n) return;
				(!n.type || n.type === "refetchConfig") && (!this.config?.etag || n.etag !== this.config?.etag) && this.refetchConfig(!0, n.lastModified, n.etag).catch((e) => {
					this.logger.warn(`Failed to refetch config ${e}`);
				});
			} catch (e) {
				this.logger.warn(`Streaming Connection: Unparseable message ${e}`);
			}
		}
		registerVisibilityChangeHandler() {
			var e;
			if (typeof document > "u") return;
			let t = this.config?.sse?.inactivityDelay || 12e4;
			this.pageVisibilityHandler = () => {
				var e;
				if (this.config?.sse) document.visibilityState === "visible" ? (this.streamingConnection?.isConnected() || (this.logger.debug("Page became visible, refetching config"), this.refetchConfig(!1).catch((e) => {
					this.logger.warn(`Failed to refetch config ${e}`);
				}), (e = this.streamingConnection) == null || e.reopen()), window == null || window.clearTimeout(this.inactivityHandlerId)) : (window == null || window.clearTimeout(this.inactivityHandlerId), this.inactivityHandlerId = window == null ? void 0 : window.setTimeout(() => {
					var e;
					this.logger.debug("Page is not visible, closing streaming connection"), (e = this.streamingConnection) == null || e.close();
				}, t));
				else return;
			}, (e = document.addEventListener) == null || e.call(document, "visibilitychange", this.pageVisibilityHandler);
		}
		async getConfigCache(e) {
			if (this.options.disableConfigCache) {
				this.logger.info("Skipping config cache");
				return;
			}
			let t = await this.store.loadConfig(e);
			t && (this.config = t, this.isConfigCached = !0, this.eventEmitter.emitFeatureUpdates({}, t.features), this.eventEmitter.emitVariableUpdates({}, t.variables, this.variableDefaultMap), this.logger.debug("Initialized with a cached config"));
		}
	}, Co = (e, t, n, r = !1) => t?.project?.settings?.edgeDB?.enabled ? !!n : (n && r && e.warn("EdgeDB is not enabled for this project. Only using local user data."), !1), wo = (e, t = {}) => {
		let n;
		if (e && "deferInitialization" in e) {
			if (e.deferInitialization) return {
				user: void 0,
				options: e,
				isDeferred: !0
			};
		} else n = e;
		if (!n) throw Error("Missing user! Call initialize with a valid user");
		return {
			user: n,
			options: t,
			isDeferred: !1
		};
	}, To = Ma;
})), Do = /* @__PURE__ */ m(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = b(), n = (Eo(), v(ba));
	e.default = class {
		get devcycleClient() {
			return this._devcycleClient;
		}
		constructor(e, n = {}) {
			this.metadata = { name: "devcycle-web-provider" }, this.runsOn = "client", this.events = new t.OpenFeatureEventEmitter(), this._devcycleClient = null, this.sdkKey = e, n.sdkPlatform ? n.sdkPlatform.toLowerCase().endsWith("-of") || (n.sdkPlatform = `${n.sdkPlatform}-of`) : n.sdkPlatform = "js-of", this.options = n;
		}
		async initialize(e) {
			this._devcycleClient = await (0, n.initializeDevCycle)(this.sdkKey, e ? this.dvcUserFromContext(e) : {}, this.options).onClientInitialized(), this._devcycleClient.eventEmitter.subscribe("configUpdated", (e) => {
				this.events.emit(t.ProviderEvents.ConfigurationChanged, e);
			}), this._devcycleClient.eventEmitter.subscribe("error", (e) => {
				this.events.emit(t.ProviderEvents.Error, e);
			}), e || this._devcycleClient.logger.warn("DevCycle initialized without context being set. It is highly recommended to set a context `OpenFeature.setContext()` before setting an OpenFeature Provider `OpenFeature.setProvider()` to avoid multiple API fetch calls.");
		}
		get status() {
			return this._devcycleClient?.isInitialized ? t.ProviderStatus.READY : t.ProviderStatus.NOT_READY;
		}
		async onClose() {
			await this._devcycleClient?.close();
		}
		async onContextChange(e, t) {
			await this._devcycleClient?.identifyUser(this.dvcUserFromContext(t));
		}
		track(e, t, n) {
			var r;
			(r = this._devcycleClient) == null || r.track({
				type: e,
				value: n?.value,
				metaData: n && {
					...n,
					value: void 0
				}
			});
		}
		getDVCVariable(e, t, n) {
			let r = this._devcycleClient?.variable(e, t);
			return this.resultFromDVCVariable(r, n);
		}
		resolveBooleanEvaluation(e, t) {
			return this.getDVCVariable(e, t, t);
		}
		resolveStringEvaluation(e, t) {
			return this.getDVCVariable(e, t, t);
		}
		resolveNumberEvaluation(e, t) {
			return this.getDVCVariable(e, t, t);
		}
		resolveObjectEvaluation(e, t) {
			return this.getDVCVariable(e, this.defaultValueFromJsonValue(t), t);
		}
		defaultValueFromJsonValue(e) {
			if (typeof e != "object" || Array.isArray(e)) throw new t.ParseError("DevCycle only supports object values for JSON flags");
			if (!e) throw new t.ParseError("DevCycle does not support null default values for JSON flags");
			return e;
		}
		resultFromDVCVariable(e, n) {
			return e ? {
				value: e.value,
				reason: e.isDefaulted ? t.StandardResolutionReasons.DEFAULT : e.eval?.reason ?? t.StandardResolutionReasons.TARGETING_MATCH
			} : {
				value: n,
				reason: t.StandardResolutionReasons.DEFAULT
			};
		}
		dvcUserFromContext(e) {
			var t, n, r, i, a, o;
			let s = [
				e.targetingKey,
				e.user_id,
				e.userId
			].filter((e) => typeof e == "string" && e !== "").shift() || null, c = {}, l = {}, u = {};
			s && typeof s == "string" && (c.user_id = s);
			for (let [s, d] of Object.entries(e)) s !== "targetingKey" && s !== "user_id" && s !== "userId" && (s === "email" || s === "name" || s === "language" || s === "country" || s === "appVersion" ? typeof d == "string" ? c[s] = d : (t = this._devcycleClient) == null || t.logger.warn(`Expected DevCycleUser property "${s}" to be "string" but got "${typeof d}" in EvaluationContext. Ignoring value.`) : s === "appBuild" ? typeof d == "number" ? c[s] = d : (n = this._devcycleClient) == null || n.logger.warn(`Expected DevCycleUser property "${s}" to be "number" but got "${typeof d}" in EvaluationContext. Ignoring value.`) : s === "isAnonymous" ? typeof d == "boolean" ? c[s] = d : (r = this._devcycleClient) == null || r.logger.warn(`Expected isAnonymous to be boolean but got "${typeof d}" in EvaluationContext. Ignoring value.`) : s === "privateCustomData" ? typeof d == "object" && d && !Array.isArray(d) ? u = this.convertToDVCCustomDataJSON(d) : (i = this._devcycleClient) == null || i.logger.warn(`Expected DevCycleUser property "privateCustomData" to be "object" but got "${typeof d}" in EvaluationContext. Ignoring value.`) : s === "customData" ? typeof d == "object" && d && !Array.isArray(d) ? l = {
				...l,
				...this.convertToDVCCustomDataJSON(d)
			} : (a = this._devcycleClient) == null || a.logger.warn(`Expected DevCycleUser property "customData" to be "object" but got "${typeof d}" in EvaluationContext. Ignoring value.`) : this.isFlatJsonValue(d) ? l[s] = d : (o = this._devcycleClient) == null || o.logger.warn(`Unknown EvaluationContext property "${s}" type. DevCycleUser only supports flat customData properties of type string / number / boolean / null`));
			return !s && typeof e.isAnonymous != "boolean" && (c.isAnonymous = !0), {
				...c,
				customData: Object.keys(l).length ? l : void 0,
				privateCustomData: Object.keys(u).length ? u : void 0
			};
		}
		convertToDVCCustomDataJSON(e) {
			var t;
			let n = {};
			for (let [r, i] of Object.entries(e)) switch (typeof i) {
				case "string":
					n[r] = i;
					break;
				case "number":
					n[r] = i;
					break;
				case "boolean":
					n[r] = i;
					break;
				case "undefined":
					n[r] = null;
					break;
				default: (t = this._devcycleClient) == null || t.logger.warn(`EvaluationContext property "customData" contains "${r}" property of type ${typeof i}.DevCycleUser only supports flat customData properties of type string / number / boolean / null`);
			}
			return n;
		}
		isFlatJsonValue(e) {
			return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === null;
		}
	};
})), Oo = /* @__PURE__ */ m(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t(Do()).default;
})), ko = /* @__PURE__ */ _((/* @__PURE__ */ m(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 });
	var n = t(Oo());
	e.default = class extends n.default {
		constructor(e, t = {}) {
			t.sdkPlatform = "react-of", super(e, t);
		}
	};
})))(), 1), Ao = Object.defineProperty, jo = Object.defineProperties, Mo = Object.getOwnPropertyDescriptors, No = Object.getOwnPropertySymbols, Po = Object.prototype.hasOwnProperty, Fo = Object.prototype.propertyIsEnumerable, Io = (e, t, n) => t in e ? Ao(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Lo = (e, t) => {
	for (var n in t ||= {}) Po.call(t, n) && Io(e, n, t[n]);
	if (No) for (var n of No(t)) Fo.call(t, n) && Io(e, n, t[n]);
	return e;
}, Ro = (e, t) => jo(e, Mo(t)), zo = (e, t, n) => new Promise((r, i) => {
	var a = (e) => {
		try {
			s(n.next(e));
		} catch (e) {
			i(e);
		}
	}, o = (e) => {
		try {
			s(n.throw(e));
		} catch (e) {
			i(e);
		}
	}, s = (e) => e.done ? r(e.value) : Promise.resolve(e.value).then(a, o);
	s((n = n.apply(e, t)).next());
}), Bo = class {
	constructor() {
		this.data = /* @__PURE__ */ new Map();
	}
	set(e, t) {
		this.data.set(e, t);
	}
	get(e) {
		return this.data.get(e);
	}
	has(e) {
		return this.data.has(e);
	}
	delete(e) {
		return this.data.delete(e);
	}
	clear() {
		this.data.clear();
	}
}, Vo = {
	STATIC: "STATIC",
	DEFAULT: "DEFAULT",
	TARGETING_MATCH: "TARGETING_MATCH",
	SPLIT: "SPLIT",
	CACHED: "CACHED",
	DISABLED: "DISABLED",
	UNKNOWN: "UNKNOWN",
	STALE: "STALE",
	ERROR: "ERROR"
}, Ho = /* @__PURE__ */ ((e) => (e.PROVIDER_NOT_READY = "PROVIDER_NOT_READY", e.PROVIDER_FATAL = "PROVIDER_FATAL", e.FLAG_NOT_FOUND = "FLAG_NOT_FOUND", e.PARSE_ERROR = "PARSE_ERROR", e.TYPE_MISMATCH = "TYPE_MISMATCH", e.TARGETING_KEY_MISSING = "TARGETING_KEY_MISSING", e.INVALID_CONTEXT = "INVALID_CONTEXT", e.GENERAL = "GENERAL", e))(Ho || {}), Uo = class e extends Error {
	constructor(t, n) {
		super(t), Object.setPrototypeOf(this, e.prototype), this.name = "OpenFeatureError", this.cause = n?.cause;
	}
}, Wo = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "FlagNotFoundError", this.code = "FLAG_NOT_FOUND";
	}
}, Go = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "GeneralError", this.code = "GENERAL";
	}
}, Ko = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "InvalidContextError", this.code = "INVALID_CONTEXT";
	}
}, qo = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ParseError", this.code = "PARSE_ERROR";
	}
}, Jo = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ProviderFatalError", this.code = "PROVIDER_FATAL";
	}
}, Yo = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ProviderNotReadyError", this.code = "PROVIDER_NOT_READY";
	}
}, Xo = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "TargetingKeyMissingError", this.code = "TARGETING_KEY_MISSING";
	}
}, Zo = class e extends Uo {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "TypeMismatchError", this.code = "TYPE_MISMATCH";
	}
}, Qo = (e, t) => {
	switch (e) {
		case "FLAG_NOT_FOUND": return new Wo(t);
		case "PARSE_ERROR": return new qo(t);
		case "TYPE_MISMATCH": return new Zo(t);
		case "TARGETING_KEY_MISSING": return new Xo(t);
		case "INVALID_CONTEXT": return new Ko(t);
		case "PROVIDER_NOT_READY": return new Yo(t);
		case "PROVIDER_FATAL": return new Jo(t);
		default: return new Go(t);
	}
}, $o = /* @__PURE__ */ ((e) => (e.NOT_READY = "NOT_READY", e.READY = "READY", e.ERROR = "ERROR", e.STALE = "STALE", e.FATAL = "FATAL", e.RECONCILING = "RECONCILING", e))($o || {}), Q = /* @__PURE__ */ ((e) => (e.Ready = "PROVIDER_READY", e.Error = "PROVIDER_ERROR", e.ConfigurationChanged = "PROVIDER_CONFIGURATION_CHANGED", e.ContextChanged = "PROVIDER_CONTEXT_CHANGED", e.Reconciling = "PROVIDER_RECONCILING", e.Stale = "PROVIDER_STALE", e))(Q || {}), es = {
	READY: "PROVIDER_READY",
	ERROR: "PROVIDER_ERROR",
	FATAL: "PROVIDER_ERROR",
	STALE: "PROVIDER_STALE",
	RECONCILING: "PROVIDER_RECONCILING",
	NOT_READY: void 0
}, ts = (e, t) => !t && e === "PROVIDER_READY" || es[t] === e, ns = class {
	error(...e) {
		console.error(...e);
	}
	warn(...e) {
		console.warn(...e);
	}
	info() {}
	debug() {}
}, rs = [
	"error",
	"warn",
	"info",
	"debug"
], is = class {
	constructor(e) {
		this.fallbackLogger = new ns();
		try {
			for (let t of rs) if (!e[t] || typeof e[t] != "function") throw Error(`The provided logger is missing the ${t} method.`);
			this.logger = e;
		} catch (e) {
			console.error(e), console.error("Falling back to the default logger."), this.logger = this.fallbackLogger;
		}
	}
	error(...e) {
		this.log("error", ...e);
	}
	warn(...e) {
		this.log("warn", ...e);
	}
	info(...e) {
		this.log("info", ...e);
	}
	debug(...e) {
		this.log("debug", ...e);
	}
	log(e, ...t) {
		try {
			this.logger[e](...t);
		} catch {
			this.fallbackLogger[e](...t);
		}
	}
}, as = class {
	constructor(e) {
		this.globalLogger = e, this._handlers = {
			PROVIDER_CONFIGURATION_CHANGED: /* @__PURE__ */ new WeakMap(),
			PROVIDER_CONTEXT_CHANGED: /* @__PURE__ */ new WeakMap(),
			PROVIDER_READY: /* @__PURE__ */ new WeakMap(),
			PROVIDER_ERROR: /* @__PURE__ */ new WeakMap(),
			PROVIDER_STALE: /* @__PURE__ */ new WeakMap(),
			PROVIDER_RECONCILING: /* @__PURE__ */ new WeakMap()
		};
	}
	emit(e, t) {
		this.eventEmitter.emit(e, t);
	}
	addHandler(e, t) {
		let n = (e) => zo(this, null, function* () {
			var n;
			try {
				yield t(e);
			} catch (e) {
				(n = this._logger) == null || n.error("Error running event handler:", e);
			}
		}), r = this._handlers[e].get(t);
		this._handlers[e].set(t, [...r || [], n]), this.eventEmitter.on(e, n);
	}
	removeHandler(e, t) {
		let n = this._handlers[e].get(t);
		if (n) {
			let t = n.pop();
			t && this.eventEmitter.removeListener(e, t);
		}
	}
	removeAllHandlers(e) {
		e ? this.eventEmitter.removeAllListeners(e) : this.eventEmitter.removeAllListeners();
	}
	getHandlers(e) {
		return this.eventEmitter.listeners(e);
	}
	setLogger(e) {
		return this._eventLogger = new is(e), this;
	}
	get _logger() {
		return this._eventLogger ?? this.globalLogger?.call(this);
	}
};
function os(e) {
	return typeof e == "string";
}
function ss(e) {
	return os(e) ? e : void 0;
}
function cs(e) {
	return typeof e == "object";
}
function ls(e) {
	return cs(e) ? e : void 0;
}
function us(e) {
	return e != null;
}
var ds = class {
	constructor(e, t, n) {
		this._provider = e, this._status = t, this._pendingContextChanges = 0;
		var r, i, a;
		(r = e.events) == null || r.addHandler("PROVIDER_READY", () => {
			this._status = n.READY;
		}), (i = e.events) == null || i.addHandler("PROVIDER_STALE", () => {
			this._status = n.STALE;
		}), (a = e.events) == null || a.addHandler("PROVIDER_ERROR", (e) => {
			this._status = e?.errorCode === "PROVIDER_FATAL" ? n.FATAL : n.ERROR;
		});
	}
	get provider() {
		return this._provider;
	}
	set provider(e) {
		this._provider = e;
	}
	get status() {
		return this._status;
	}
	set status(e) {
		this._status = e;
	}
	get allContextChangesSettled() {
		return this._pendingContextChanges === 0;
	}
	incrementPendingContextChanges() {
		this._pendingContextChanges++;
	}
	decrementPendingContextChanges() {
		this._pendingContextChanges--;
	}
}, fs = class {
	constructor(e) {
		this._hooks = [], this._context = {}, this._logger = new ns(), this._clientEventHandlers = /* @__PURE__ */ new Map(), this._domainScopedContext = /* @__PURE__ */ new Map(), this._clientEvents = /* @__PURE__ */ new Map(), this._runsOn = e;
	}
	addHooks(...e) {
		return this._hooks = [...this._hooks, ...e], this;
	}
	getHooks() {
		return this._hooks;
	}
	clearHooks() {
		return this._hooks = [], this;
	}
	setLogger(e) {
		return this._logger = new is(e), this;
	}
	get providerMetadata() {
		return this.getProviderMetadata();
	}
	getProviderMetadata(e) {
		return this.getProviderForClient(e).metadata;
	}
	addHandler(e, t, n) {
		[.../* @__PURE__ */ new Map([[void 0, this._defaultProvider]]), ...this._domainScopedProviders].forEach((n) => {
			var r;
			let i = n[0], a = n[1].provider, o = n[1].status;
			if (ts(e, o)) try {
				t({
					domain: i,
					providerName: a.metadata.name
				});
			} catch (e) {
				(r = this._logger) == null || r.error("Error running event handler:", e);
			}
		}), this._apiEmitter.addHandler(e, t), n?.signal && typeof n.signal.addEventListener == "function" && n.signal.addEventListener("abort", () => {
			this.removeHandler(e, t);
		});
	}
	removeHandler(e, t) {
		this._apiEmitter.removeHandler(e, t);
	}
	clearHandlers() {
		this._apiEmitter.removeAllHandlers();
	}
	getHandlers(e) {
		return this._apiEmitter.getHandlers(e);
	}
	setAwaitableProvider(e, t) {
		var n, r;
		let i = ss(e), a = ls(e) ?? ls(t);
		if (!a) {
			this._logger.debug("No provider defined, ignoring setProvider call");
			return;
		}
		let o = this.getProviderForClient(i), s = a.metadata.name;
		if (o === a) {
			this._logger.debug("Provider is already set, ignoring setProvider call");
			return;
		}
		if (!a.runsOn) this._logger.debug(`Provider '${a.metadata.name}' has not defined its intended use.`);
		else if (a.runsOn !== this._runsOn) throw new Go(`Provider '${a.metadata.name}' is intended for use on the ${a.runsOn}.`);
		let c = this.getAssociatedEventEmitters(i), l, u = new ds(a, this._statusEnumType.NOT_READY, this._statusEnumType);
		return typeof a.initialize == "function" && !this.allProviders.includes(a) ? l = ((a.initialize?.call(a, i ? this._domainScopedContext.get(i) ?? this._context : this._context))?.then(() => {
			var e;
			u.status = this._statusEnumType.READY, this.getAssociatedEventEmitters(i).forEach((e) => {
				e?.emit("PROVIDER_READY", {
					clientName: i,
					domain: i,
					providerName: s
				});
			}), (e = this._apiEmitter) == null || e.emit("PROVIDER_READY", {
				clientName: i,
				domain: i,
				providerName: s
			});
		}))?.catch((e) => {
			var t;
			throw e?.code === "PROVIDER_FATAL" ? u.status = this._statusEnumType.FATAL : u.status = this._statusEnumType.ERROR, this.getAssociatedEventEmitters(i).forEach((t) => {
				t?.emit("PROVIDER_ERROR", {
					clientName: i,
					domain: i,
					providerName: s,
					message: e?.message
				});
			}), (t = this._apiEmitter) == null || t.emit("PROVIDER_ERROR", {
				clientName: i,
				domain: i,
				providerName: s,
				message: e?.message
			}), e;
		}) : (u.status = this._statusEnumType.READY, c.forEach((e) => {
			e?.emit("PROVIDER_READY", {
				clientName: i,
				domain: i,
				providerName: s
			});
		}), (n = this._apiEmitter) == null || n.emit("PROVIDER_READY", {
			clientName: i,
			domain: i,
			providerName: s
		})), i ? this._domainScopedProviders.set(i, u) : this._defaultProvider = u, this.transferListeners(o, a, i, c), this.allProviders.includes(o) || (r = (o?.onClose)?.call(o)) == null || r.catch((e) => {
			this._logger.error(`error closing provider: ${e?.message}, ${e?.stack}`);
		}), l;
	}
	getProviderForClient(e) {
		return e ? this._domainScopedProviders.get(e)?.provider ?? this._defaultProvider.provider : this._defaultProvider.provider;
	}
	buildAndCacheEventEmitterForClient(e) {
		let t = this._clientEvents.get(e);
		if (t) return t;
		let n = this._createEventEmitter();
		this._clientEvents.set(e, n);
		let r = this.getProviderForClient(e);
		return Object.values(Q).forEach((t) => r.events?.addHandler(t, (i) => zo(this, null, function* () {
			n.emit(t, Ro(Lo({}, i), {
				clientName: e,
				domain: e,
				providerName: r.metadata.name
			}));
		}))), n;
	}
	getUnboundEmitters() {
		let e = [...this._domainScopedProviders.keys()];
		return [...[...this._clientEvents.keys()].filter(us).filter((t) => !e.includes(t)).map((e) => this._clientEvents.get(e)), this._clientEvents.get(void 0)].filter(us);
	}
	getAssociatedEventEmitters(e) {
		return e ? [this.buildAndCacheEventEmitterForClient(e)] : this.getUnboundEmitters();
	}
	transferListeners(e, t, n, r) {
		var i;
		(i = this._clientEventHandlers.get(n)) == null || i.forEach((t) => e.events?.removeHandler(...t));
		let a = Object.values(Q).map((e) => [e, (i) => zo(this, null, function* () {
			r.forEach((r) => {
				r?.emit(e, Ro(Lo({}, i), {
					clientName: n,
					domain: n,
					providerName: t.metadata.name
				}));
			}), this._apiEmitter.emit(e, Ro(Lo({}, i), {
				clientName: n,
				domain: n,
				providerName: t.metadata.name
			}));
		})]);
		this._clientEventHandlers.set(n, a), a.forEach((e) => t.events?.addHandler(...e));
	}
	close() {
		return zo(this, null, function* () {
			var e;
			try {
				yield ((e = this == null ? void 0 : this._defaultProvider.provider)?.onClose)?.call(e);
			} catch (e) {
				this.handleShutdownError(this._defaultProvider.provider, e);
			}
			let t = Array.from(this._domainScopedProviders);
			yield Promise.all(t.map((e) => zo(this, [e], function* ([, e]) {
				var t;
				try {
					yield (e == null ? void 0 : (t = e.provider).onClose)?.call(t);
				} catch (t) {
					this.handleShutdownError(e?.provider, t);
				}
			})));
		});
	}
	clearProvidersAndSetDefault(e) {
		return zo(this, null, function* () {
			try {
				yield this.close();
			} catch {
				this._logger.error("Unable to cleanly close providers. Resetting to the default configuration.");
			} finally {
				this._domainScopedProviders.clear(), this._defaultProvider = new ds(e, this._statusEnumType.NOT_READY, this._statusEnumType);
			}
		});
	}
	get allProviders() {
		return [...[...this._domainScopedProviders.values()].map((e) => e.provider), this._defaultProvider.provider];
	}
	handleShutdownError(e, t) {
		this._logger.error(`Error during shutdown of provider ${e.metadata.name}: ${t}`), this._logger.error(t?.stack);
	}
}, ps = Object.create, ms = Object.defineProperty, hs = Object.defineProperties, gs = Object.getOwnPropertyDescriptor, _s = Object.getOwnPropertyDescriptors, vs = Object.getOwnPropertyNames, ys = Object.getOwnPropertySymbols, bs = Object.getPrototypeOf, xs = Object.prototype.hasOwnProperty, Ss = Object.prototype.propertyIsEnumerable, Cs = Reflect.get, ws = (e, t, n) => t in e ? ms(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Ts = (e, t) => {
	for (var n in t ||= {}) xs.call(t, n) && ws(e, n, t[n]);
	if (ys) for (var n of ys(t)) Ss.call(t, n) && ws(e, n, t[n]);
	return e;
}, Es = (e, t) => hs(e, _s(t)), Ds = (e, t) => function() {
	return t || (0, e[vs(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Os = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (let i of vs(t)) !xs.call(e, i) && i !== n && ms(e, i, {
		get: () => t[i],
		enumerable: !(r = gs(t, i)) || r.enumerable
	});
	return e;
}, ks = (e, t, n) => (n = e == null ? {} : ps(bs(e)), Os(t || !e || !e.__esModule ? ms(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), As = (e, t, n) => Cs(bs(e), n, t), js = (e, t, n) => new Promise((r, i) => {
	var a = (e) => {
		try {
			s(n.next(e));
		} catch (e) {
			i(e);
		}
	}, o = (e) => {
		try {
			s(n.throw(e));
		} catch (e) {
			i(e);
		}
	}, s = (e) => e.done ? r(e.value) : Promise.resolve(e.value).then(a, o);
	s((n = n.apply(e, t)).next());
}), Ms = Ds({ "../../node_modules/eventemitter3/index.js"(e, t) {
	var n = Object.prototype.hasOwnProperty, r = "~";
	function i() {}
	Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (r = !1));
	function a(e, t, n) {
		this.fn = e, this.context = t, this.once = n || !1;
	}
	function o(e, t, n, i, o) {
		if (typeof n != "function") throw TypeError("The listener must be a function");
		var s = new a(n, i || e, o), c = r ? r + t : t;
		return e._events[c] ? e._events[c].fn ? e._events[c] = [e._events[c], s] : e._events[c].push(s) : (e._events[c] = s, e._eventsCount++), e;
	}
	function s(e, t) {
		--e._eventsCount === 0 ? e._events = new i() : delete e._events[t];
	}
	function c() {
		this._events = new i(), this._eventsCount = 0;
	}
	c.prototype.eventNames = function() {
		var e = [], t, i;
		if (this._eventsCount === 0) return e;
		for (i in t = this._events) n.call(t, i) && e.push(r ? i.slice(1) : i);
		return Object.getOwnPropertySymbols ? e.concat(Object.getOwnPropertySymbols(t)) : e;
	}, c.prototype.listeners = function(e) {
		var t = r ? r + e : e, n = this._events[t];
		if (!n) return [];
		if (n.fn) return [n.fn];
		for (var i = 0, a = n.length, o = Array(a); i < a; i++) o[i] = n[i].fn;
		return o;
	}, c.prototype.listenerCount = function(e) {
		var t = r ? r + e : e, n = this._events[t];
		return n ? n.fn ? 1 : n.length : 0;
	}, c.prototype.emit = function(e, t, n, i, a, o) {
		var s = r ? r + e : e;
		if (!this._events[s]) return !1;
		var c = this._events[s], l = arguments.length, u, d;
		if (c.fn) {
			switch (c.once && this.removeListener(e, c.fn, void 0, !0), l) {
				case 1: return c.fn.call(c.context), !0;
				case 2: return c.fn.call(c.context, t), !0;
				case 3: return c.fn.call(c.context, t, n), !0;
				case 4: return c.fn.call(c.context, t, n, i), !0;
				case 5: return c.fn.call(c.context, t, n, i, a), !0;
				case 6: return c.fn.call(c.context, t, n, i, a, o), !0;
			}
			for (d = 1, u = Array(l - 1); d < l; d++) u[d - 1] = arguments[d];
			c.fn.apply(c.context, u);
		} else {
			var f = c.length, p;
			for (d = 0; d < f; d++) switch (c[d].once && this.removeListener(e, c[d].fn, void 0, !0), l) {
				case 1:
					c[d].fn.call(c[d].context);
					break;
				case 2:
					c[d].fn.call(c[d].context, t);
					break;
				case 3:
					c[d].fn.call(c[d].context, t, n);
					break;
				case 4:
					c[d].fn.call(c[d].context, t, n, i);
					break;
				default:
					if (!u) for (p = 1, u = Array(l - 1); p < l; p++) u[p - 1] = arguments[p];
					c[d].fn.apply(c[d].context, u);
			}
		}
		return !0;
	}, c.prototype.on = function(e, t, n) {
		return o(this, e, t, n, !1);
	}, c.prototype.once = function(e, t, n) {
		return o(this, e, t, n, !0);
	}, c.prototype.removeListener = function(e, t, n, i) {
		var a = r ? r + e : e;
		if (!this._events[a]) return this;
		if (!t) return s(this, a), this;
		var o = this._events[a];
		if (o.fn) o.fn === t && (!i || o.once) && (!n || o.context === n) && s(this, a);
		else {
			for (var c = 0, l = [], u = o.length; c < u; c++) (o[c].fn !== t || i && !o[c].once || n && o[c].context !== n) && l.push(o[c]);
			l.length ? this._events[a] = l.length === 1 ? l[0] : l : s(this, a);
		}
		return this;
	}, c.prototype.removeAllListeners = function(e) {
		var t;
		return e ? (t = r ? r + e : e, this._events[t] && s(this, t)) : (this._events = new i(), this._eventsCount = 0), this;
	}, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, t !== void 0 && (t.exports = c);
} }), Ns = "No-op", Ps = new class {
	constructor() {
		this.metadata = { name: "No-op Provider" };
	}
	resolveBooleanEvaluation(e, t) {
		return this.noOp(t);
	}
	resolveStringEvaluation(e, t) {
		return this.noOp(t);
	}
	resolveNumberEvaluation(e, t) {
		return this.noOp(t);
	}
	resolveObjectEvaluation(e, t) {
		return this.noOp(t);
	}
	noOp(e) {
		return {
			value: e,
			reason: Ns
		};
	}
}(), Fs = ks(Ms(), 1), Is = class extends as {
	constructor() {
		super(), this.eventEmitter = new Fs.default();
	}
}, Ls = class {
	constructor(e, t, n, r, i, a, o) {
		this.providerAccessor = e, this.providerStatusAccessor = t, this.emitterAccessor = n, this.apiContextAccessor = r, this.apiHooksAccessor = i, this.globalLogger = a, this.options = o, this._hooks = [];
	}
	get metadata() {
		return {
			name: this.options.domain ?? this.options.name,
			domain: this.options.domain ?? this.options.name,
			version: this.options.version,
			providerMetadata: this.providerAccessor().metadata
		};
	}
	get providerStatus() {
		return this.providerStatusAccessor();
	}
	addHandler(e, t, n) {
		var r;
		if (this.emitterAccessor().addHandler(e, t), ts(e, this.providerStatus)) try {
			t({
				clientName: this.metadata.name,
				domain: this.metadata.domain,
				providerName: this._provider.metadata.name
			});
		} catch (e) {
			(r = this._logger) == null || r.error("Error running event handler:", e);
		}
		n?.signal && typeof n.signal.addEventListener == "function" && n.signal.addEventListener("abort", () => {
			this.removeHandler(e, t);
		});
	}
	removeHandler(e, t) {
		this.emitterAccessor().removeHandler(e, t);
	}
	getHandlers(e) {
		return this.emitterAccessor().getHandlers(e);
	}
	setLogger(e) {
		return this._clientLogger = new is(e), this;
	}
	addHooks(...e) {
		return this._hooks = [...this._hooks, ...e], this;
	}
	getHooks() {
		return this._hooks;
	}
	clearHooks() {
		return this._hooks = [], this;
	}
	getBooleanValue(e, t, n) {
		return this.getBooleanDetails(e, t, n).value;
	}
	getBooleanDetails(e, t, n) {
		return this.evaluate(e, this._provider.resolveBooleanEvaluation, t, "boolean", n);
	}
	getStringValue(e, t, n) {
		return this.getStringDetails(e, t, n).value;
	}
	getStringDetails(e, t, n) {
		return this.evaluate(e, this._provider.resolveStringEvaluation, t, "string", n);
	}
	getNumberValue(e, t, n) {
		return this.getNumberDetails(e, t, n).value;
	}
	getNumberDetails(e, t, n) {
		return this.evaluate(e, this._provider.resolveNumberEvaluation, t, "number", n);
	}
	getObjectValue(e, t, n) {
		return this.getObjectDetails(e, t, n).value;
	}
	getObjectDetails(e, t, n) {
		return this.evaluate(e, this._provider.resolveObjectEvaluation, t, "object", n);
	}
	track(e, t = {}) {
		var n;
		try {
			if (this.shortCircuitIfNotReady(), typeof this._provider.track == "function") {
				let r = Object.freeze(Ts({}, this.apiContextAccessor((this == null ? void 0 : this.options)?.domain)));
				return (n = this._provider).track?.call(n, e, r, t);
			}
			this._logger.debug("Provider does not support the track function; will no-op.");
		} catch (e) {
			this._logger.debug("Error recording tracking event.", e);
		}
	}
	evaluate(e, t, n, r, i = {}) {
		let a = [
			...this.apiHooksAccessor(),
			...this.getHooks(),
			...i.hooks || [],
			...this._provider.hooks || []
		], o = [...a].reverse(), s = Ts({}, this.apiContextAccessor((this == null ? void 0 : this.options)?.domain)), c = o.map(() => Object.freeze({
			flagKey: e,
			defaultValue: n,
			flagValueType: r,
			clientMetadata: this.metadata,
			providerMetadata: this._provider.metadata,
			context: s,
			logger: this._logger,
			hookData: new Bo()
		})), l;
		try {
			this.beforeHooks(a, c, i), this.shortCircuitIfNotReady();
			let r = t.call(this._provider, e, n, s, this._logger), u = Es(Ts({}, r), {
				flagMetadata: Object.freeze(r.flagMetadata ?? {}),
				flagKey: e
			});
			if (u.errorCode) {
				let t = Qo(u.errorCode, u.errorMessage);
				this.errorHooks(o, c, t, i), l = this.getErrorEvaluationDetails(e, n, t, u.flagMetadata);
			} else this.afterHooks(o, c, u, i), l = u;
		} catch (t) {
			this.errorHooks(o, c, t, i), l = this.getErrorEvaluationDetails(e, n, t);
		}
		return this.finallyHooks(o, c, l, i), l;
	}
	beforeHooks(e, t, n) {
		var r;
		for (let [i, a] of e.entries()) {
			let o = t[e.length - 1 - i];
			Object.freeze(o), Object.freeze(o.context), (r = a?.before) == null || r.call(a, o, Object.freeze(n.hookHints));
		}
	}
	afterHooks(e, t, n, r) {
		var i;
		for (let [a, o] of e.entries()) {
			let e = t[a];
			(i = o?.after) == null || i.call(o, e, n, r.hookHints);
		}
	}
	errorHooks(e, t, n, r) {
		var i;
		for (let [a, o] of e.entries()) try {
			let e = t[a];
			(i = o?.error) == null || i.call(o, e, n, r.hookHints);
		} catch (e) {
			this._logger.error(`Unhandled error during 'error' hook: ${e}`), e instanceof Error && this._logger.error(e.stack), this._logger.error(e?.stack);
		}
	}
	finallyHooks(e, t, n, r) {
		var i;
		for (let [a, o] of e.entries()) try {
			let e = t[a];
			(i = o?.finally) == null || i.call(o, e, n, r.hookHints);
		} catch (e) {
			this._logger.error(`Unhandled error during 'finally' hook: ${e}`), e instanceof Error && this._logger.error(e.stack), this._logger.error(e?.stack);
		}
	}
	get _provider() {
		return this.providerAccessor();
	}
	get _logger() {
		return this._clientLogger || this.globalLogger();
	}
	shortCircuitIfNotReady() {
		if (this.providerStatus === $o.NOT_READY) throw new Yo("provider has not yet initialized");
		if (this.providerStatus === $o.FATAL) throw new Jo("provider is in an irrecoverable error state");
	}
	getErrorEvaluationDetails(e, t, n, r = {}) {
		let i = n?.message;
		return {
			errorCode: n?.code || Ho.GENERAL,
			errorMessage: i,
			value: t,
			reason: Vo.ERROR,
			flagMetadata: Object.freeze(r),
			flagKey: e
		};
	}
}, Rs = Symbol.for("@openfeature/web-sdk/api"), zs = globalThis, Bs = class e extends fs {
	constructor() {
		super("client"), this._statusEnumType = $o, this._apiEmitter = new Is(), this._defaultProvider = new ds(Ps, $o.NOT_READY, this._statusEnumType), this._domainScopedProviders = /* @__PURE__ */ new Map(), this._createEventEmitter = () => new Is();
	}
	static getInstance() {
		let t = zs[Rs];
		if (t) return t;
		let n = new e();
		return zs[Rs] = n, n;
	}
	getProviderStatus(e) {
		return e ? this._domainScopedProviders.get(e)?.status ?? this._defaultProvider.status : this._defaultProvider.status;
	}
	setProviderAndWait(e, t, n) {
		return js(this, null, function* () {
			let r = ss(e), i = ls(r ? t : e), a = ls(r ? n : t);
			a && (r ? this._domainScopedContext.set(r, a) : this._context = a), yield this.setAwaitableProvider(r, i);
		});
	}
	setProvider(e, t, n) {
		let r = ss(e), i = ls(r ? t : e), a = ls(r ? n : t);
		a && (r ? this._domainScopedContext.set(r, a) : this._context = a);
		let o = this.setAwaitableProvider(r, i);
		return Promise.resolve(o).catch((e) => {
			this._logger.error("Error during provider initialization:", e);
		}), this;
	}
	getProvider(e) {
		return this.getProviderForClient(e);
	}
	setContext(e, t) {
		return js(this, null, function* () {
			let n = ss(e), r = ls(e) ?? ls(t) ?? {};
			if (n) {
				let e = this._domainScopedProviders.get(n);
				if (e) {
					let t = this.getContext(n);
					this._domainScopedContext.set(n, r), yield this.runProviderContextChangeHandler(n, e, t, r);
				} else this._domainScopedContext.set(n, r);
			} else {
				let e = this._context;
				this._context = r;
				let t = Array.from(this._domainScopedProviders.entries()).filter(([e]) => !this._domainScopedContext.has(e)).reduce((e, [t, n]) => (e.push({
					domain: t,
					wrapper: n
				}), e), []), n = [{
					domain: void 0,
					wrapper: this._defaultProvider
				}, ...t];
				yield Promise.all(n.map((t) => this.runProviderContextChangeHandler(t.domain, t.wrapper, e, r)));
			}
		});
	}
	getContext(e) {
		let t = ss(e);
		if (t) {
			let e = this._domainScopedContext.get(t);
			if (e) return e;
			this._logger.debug(`Unable to find context for '${t}'.`);
		}
		return this._context;
	}
	clearContext(e) {
		return js(this, null, function* () {
			let t = ss(e);
			if (t) {
				let e = this._domainScopedProviders.get(t);
				if (e) {
					let n = this.getContext(t);
					this._domainScopedContext.delete(t);
					let r = this.getContext();
					yield this.runProviderContextChangeHandler(t, e, n, r);
				} else this._domainScopedContext.delete(t);
			} else return this.setContext({});
		});
	}
	clearContexts() {
		return js(this, null, function* () {
			yield this.clearContext(), yield Promise.allSettled(Array.from(this._domainScopedProviders.keys()).map((e) => this.clearContext(e)));
		});
	}
	getClient(e, t) {
		return new Ls(() => this.getProviderForClient(e), () => this.getProviderStatus(e), () => this.buildAndCacheEventEmitterForClient(e), (e) => this.getContext(e), () => this.getHooks(), () => this._logger, {
			domain: e,
			version: t
		});
	}
	clearProviders() {
		return js(this, null, function* () {
			yield As(e.prototype, this, "clearProvidersAndSetDefault").call(this, Ps), this._domainScopedContext.clear();
		});
	}
	runProviderContextChangeHandler(e, t, n, r) {
		return js(this, null, function* () {
			var i, a, o, s;
			let c = t.provider?.metadata?.name || "unnamed-provider";
			try {
				if (typeof t.provider.onContextChange == "function") {
					let a = t.provider.onContextChange(n, r);
					a && typeof a?.then == "function" && (t.incrementPendingContextChanges(), t.status = this._statusEnumType.RECONCILING, this.getAssociatedEventEmitters(e).forEach((t) => {
						t?.emit(Q.Reconciling, {
							domain: e,
							providerName: c
						});
					}), (i = this._apiEmitter) == null || i.emit(Q.Reconciling, {
						domain: e,
						providerName: c
					}), yield a, t.decrementPendingContextChanges());
				}
				t.status = this._statusEnumType.READY, t.allContextChangesSettled && (this.getAssociatedEventEmitters(e).forEach((t) => {
					t?.emit(Q.ContextChanged, {
						clientName: e,
						domain: e,
						providerName: c
					});
				}), (a = this._apiEmitter) == null || a.emit(Q.ContextChanged, {
					clientName: e,
					domain: e,
					providerName: c
				}));
			} catch (n) {
				if (t.decrementPendingContextChanges(), t.status = this._statusEnumType.ERROR, t.allContextChangesSettled) {
					let t = `Error running ${c}'s context change handler: ${n?.message}`;
					(o = this._logger) == null || o.error(`${t}`, n), this.getAssociatedEventEmitters(e).forEach((n) => {
						n?.emit(Q.Error, {
							clientName: e,
							domain: e,
							providerName: c,
							message: t
						});
					}), (s = this._apiEmitter) == null || s.emit(Q.Error, {
						clientName: e,
						domain: e,
						providerName: c,
						message: t
					});
				}
			}
		});
	}
}.getInstance(), Vs = Object.defineProperty, Hs = Object.getOwnPropertySymbols, Us = Object.prototype.hasOwnProperty, Ws = Object.prototype.propertyIsEnumerable, Gs = (e, t, n) => t in e ? Vs(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Ks = (e, t) => {
	for (var n in t ||= {}) Us.call(t, n) && Gs(e, n, t[n]);
	if (Hs) for (var n of Hs(t)) Ws.call(t, n) && Gs(e, n, t[n]);
	return e;
}, qs = (e, t) => {
	var n = {};
	for (var r in e) Us.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Hs) for (var r of Hs(e)) t.indexOf(r) < 0 && Ws.call(e, r) && (n[r] = e[r]);
	return n;
}, Js = (e, t, n) => new Promise((r, i) => {
	var a = (e) => {
		try {
			s(n.next(e));
		} catch (e) {
			i(e);
		}
	}, o = (e) => {
		try {
			s(n.throw(e));
		} catch (e) {
			i(e);
		}
	}, s = (e) => e.done ? r(e.value) : Promise.resolve(e.value).then(a, o);
	s((n = n.apply(e, t)).next());
}), Ys = t.createContext(void 0);
function Xs() {
	let { options: e } = t.useContext(Ys) || {};
	return $s(e);
}
function Zs(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "object" && e && typeof t == "object" && t) {
		let n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (let r of n) if (!Zs(e[r], t[r])) return !1;
		return !0;
	}
	return !1;
}
var Qs = {
	updateOnContextChanged: !0,
	updateOnConfigurationChanged: !0,
	suspendUntilReady: !1,
	suspendWhileReconciling: !1
}, $s = (e = {}) => {
	let t = e.updateOnContextChanged, n = e.updateOnConfigurationChanged, r = "suspendUntilReady" in e ? e.suspendUntilReady : e.suspend, i = "suspendWhileReconciling" in e ? e.suspendWhileReconciling : e.suspend;
	return Ks(Ks(Ks(Ks({}, typeof r == "boolean" && { suspendUntilReady: r }), typeof i == "boolean" && { suspendWhileReconciling: i }), typeof t == "boolean" && { updateOnContextChanged: t }), typeof n == "boolean" && { updateOnConfigurationChanged: n });
}, ec = t.use || ((e) => {
	switch (e.status) {
		case "pending": throw e;
		case "fulfilled": return e.value;
		case "rejected": throw e.reason;
		default: throw e.status = "pending", e.then((t) => {
			e.status = "fulfilled", e.value = t;
		}, (t) => {
			e.status = "rejected", e.reason = t;
		}), e;
	}
}), tc = /* @__PURE__ */ new WeakMap();
function nc(e, t) {
	let n = tc.get(e);
	if (n) ec(n);
	else {
		let n = e === Ps ? Promise.resolve() : ic(t);
		tc.set(e, n), ec(n);
	}
}
function rc(e) {
	ec(ic(e));
}
function ic(e) {
	return Js(this, null, function* () {
		let t = new AbortController();
		try {
			return yield new Promise((n, r) => {
				e.addHandler(Q.Ready, n, { signal: t.signal }), e.addHandler(Q.Error, r, { signal: t.signal });
			});
		} finally {
			t.abort();
		}
	});
}
var ac = "Components using OpenFeature must be wrapped with an <OpenFeatureProvider>.", oc = "If you are seeing this in a test, see: https://openfeature.dev/docs/reference/technologies/client/web/react#testing", sc = class extends Error {
	constructor(e) {
		super(`${e}: ${ac} ${oc}`), this.name = "MissingContextError";
	}
};
function cc() {
	let { client: e } = t.useContext(Ys) || {};
	if (!e) throw new sc("No OpenFeature client available");
	return e;
}
function lc() {
	let e = cc(), [t, n] = a(e.providerStatus);
	return r(() => {
		let t = new AbortController(), r = () => n(e.providerStatus);
		return e.addHandler(Q.ConfigurationChanged, r, { signal: t.signal }), e.addHandler(Q.ContextChanged, r, { signal: t.signal }), e.addHandler(Q.Error, r, { signal: t.signal }), e.addHandler(Q.Ready, r, { signal: t.signal }), e.addHandler(Q.Stale, r, { signal: t.signal }), e.addHandler(Q.Reconciling, r, { signal: t.signal }), () => {
			t.abort();
		};
	}, [e]), t;
}
function uc() {
	let e = t.useContext(Ys);
	if (!e) throw new sc("No OpenFeature context available");
	return Bs.getProvider(e.client.metadata.domain);
}
function dc(e, t, n) {
	return fc(e, t, n).value;
}
function fc(e, t, n) {
	return gc(e, t, (e) => e.getBooleanDetails, n);
}
function pc(e, t, n) {
	return mc(e, t, n).value;
}
function mc(e, t, n) {
	return gc(e, t, (e) => e.getStringDetails, n);
}
function hc(e, t) {
	return !t || t.includes(e);
}
function gc(e, t, o, s) {
	let c = Ks(Ks(Ks({}, Qs), Xs()), $s(s)), l = cc(), u = lc(), d = uc(), f = i(!0);
	c.suspendUntilReady && u === $o.NOT_READY && nc(d, l), c.suspendWhileReconciling && u === $o.RECONCILING && rc(l);
	let [p, m] = a(() => o(l).call(l, e, t, s));
	r(() => {
		if (f.current) {
			f.current = !1;
			return;
		}
		let n = o(l).call(l, e, t, s);
		Zs(n, p) || m(n);
	}, [
		l,
		e,
		t,
		s,
		o,
		p
	]);
	let h = i(p);
	r(() => {
		h.current = p;
	}, [p]);
	let g = n(() => {
		let n = o(l).call(l, e, t, s);
		Zs(n, h.current) || m(n);
	}, [
		l,
		e,
		t,
		s,
		o
	]), _ = n((t) => {
		hc(e, t?.flagsChanged) && g();
	}, [e, g]);
	return r(() => {
		let e = new AbortController();
		return l.addHandler(Q.Ready, g, { signal: e.signal }), c.updateOnContextChanged && l.addHandler(Q.ContextChanged, g, { signal: e.signal }), c.updateOnConfigurationChanged && l.addHandler(Q.ConfigurationChanged, _, { signal: e.signal }), () => {
			e.abort();
		};
	}, [
		l,
		c.updateOnContextChanged,
		c.updateOnConfigurationChanged,
		g,
		_
	]), p;
}
function _c(t) {
	var n = t, { client: r, domain: i, children: a } = n, o = qs(n, [
		"client",
		"domain",
		"children"
	]);
	let s = e.useMemo(() => r || Bs.getClient(i), [r, i]);
	return /* @__PURE__ */ e.createElement(Ys.Provider, { value: {
		client: s,
		options: o
	} }, a);
}
//#endregion
//#region ../../../node_modules/@devcycle/web-debugger/src/initializeDevCycleDebugger.js
var $ = { current: {
	liveEvents: [],
	loadCount: 0,
	expanded: !1,
	allowIdentify: !0
} }, vc = () => !1, yc = class {
	constructor(e, { position: t = "right", debuggerUrl: n = "https://debugger.devcycle.com", debugLogs: r = !1 } = {}) {
		this.client = e, $.current.allowIdentify = "identifyUser" in e, this.debuggerUrl = n, this.position = t, this.debugLogs = r, this.mainIframe = document.createElement("iframe"), this.buttonIframe = document.createElement("iframe"), this.debouncedUpdateIframeData = this.debounce(() => {
			this._updateIframeData();
		}, 300);
	}
	debounce(e, t) {
		let n = null;
		return () => {
			n && clearTimeout(n), n = setTimeout(() => {
				e(), n = null;
			}, t);
		};
	}
	createIframesWhenReady() {
		this.client.onClientInitialized().then(() => {
			$.current.config = this.client.config, $.current.user = this.client.user, this.createMainIframe(), this.createButtonIframe();
		});
	}
	_updateIframeData() {
		var e;
		$.current.config = this.client.config, $.current.user = this.client.user, this.synchronizeIframeUrl(), this.debugLogs && this.log("posting message", $.current), $.current.loadCount && ((e = this.mainIframe.contentWindow) == null || e.postMessage({
			...$.current,
			type: "dvcDebuggerData"
		}, this.debuggerUrl));
	}
	updateIframeData() {
		this.debouncedUpdateIframeData();
	}
	setupSubscriptions() {
		let e = (e) => {
			$.current.liveEvents.unshift(e), $.current.liveEvents.length > 200 && $.current.liveEvents.pop();
		}, t = () => {
			$.current.config = this.client.config, $.current.user = this.client.user, e({
				type: "configUpdated",
				date: Date.now()
			}), this.updateIframeData();
		}, n = (t, n) => {
			e({
				type: "variableEvaluated",
				key: t,
				variable: { ...n },
				date: Date.now()
			}), this.updateIframeData();
		}, r = (t, n) => {
			e({
				type: "variableUpdated",
				key: t,
				variable: n ? { ...n } : null,
				date: Date.now()
			}), this.updateIframeData();
		};
		this.log("subscribing to events"), this.client.subscribe("configUpdated", t), this.client.subscribe("variableEvaluated:*", n), this.client.subscribe("variableUpdated:*", r);
		let i = this.client.track.bind(this.client);
		this.client.track = (...t) => {
			let [n] = t;
			e({
				type: n.type,
				target: n.target,
				value: n.value,
				date: Date.now()
			}), this.updateIframeData(), i(...t);
		};
		let a = this.iframeMessageReceiver.bind(this);
		return window.addEventListener("message", a), () => {
			this.log("unsubscribing from events"), this.client.unsubscribe("configUpdated", t), this.client.unsubscribe("variableEvaluated:*", n), this.client.unsubscribe("variableUpdated:*", r), window.removeEventListener("message", a);
		};
	}
	createButtonIframe() {
		this.buttonIframe.id = "devcycle-debugger-button-iframe", this.buttonIframe.style.width = "80px", this.buttonIframe.style.height = "80px", this.buttonIframe.style.position = "fixed", this.buttonIframe.style.bottom = "25px", this.position === "left" ? this.buttonIframe.style.left = "25px" : this.buttonIframe.style.right = "25px", this.buttonIframe.style.zIndex = "100", this.buttonIframe.style.border = "none", this.buttonIframe.style.overflow = "hidden", this.buttonIframe.title = "Devcycle Debugger";
		let e = new URLSearchParams();
		e.set("parentOrigin", window.location.origin), e.set("position", this.position), this.buttonIframe.src = `${this.debuggerUrl}/button?${e.toString()}`, document.body.appendChild(this.buttonIframe);
	}
	createMainIframe() {
		this.mainIframe.id = "devcycle-debugger-iframe", this.synchronizeIframeUrl(), this.mainIframe.style.width = "0px", this.mainIframe.style.height = "0px", this.mainIframe.style.position = "fixed", this.mainIframe.style.bottom = "25px", this.position === "left" ? this.mainIframe.style.left = "25px" : this.mainIframe.style.right = "25px", this.mainIframe.style.border = "none", this.mainIframe.style.overflow = "hidden", this.mainIframe.title = "Devcycle Debugger", this.mainIframe.allow = "clipboard-read; clipboard-write", this.mainIframe.onload = () => {
			$.current.loadCount += 1;
		}, document.body.appendChild(this.mainIframe);
	}
	synchronizeIframeUrl() {
		let e = new URLSearchParams();
		e.set("parentOrigin", window.location.origin), e.set("position", this.position);
		let t = `${this.debuggerUrl}/${this.client.config.project.a0_organization}/${this.client.config.project._id}/${this.client.config.environment._id}?${e.toString()}`;
		t !== this.mainIframe.src && (this.mainIframe.src = t);
	}
	iframeMessageReceiver(e) {
		e.origin === this.debuggerUrl && (this.log("Message received from iframe: ", e.data), e.data.type === "DEVCYCLE_IDENTIFY_USER" && e.data.user ? "identifyUser" in this.client ? this.client.identifyUser(e.data.user).then(() => {
			this.updateIframeData();
		}) : this.log("Unable to change user identity from debugger in Next.js") : e.data.type === "DEVCYCLE_RESET_USER" ? "resetUser" in this.client ? this.client.resetUser().then(() => {
			this.updateIframeData();
		}) : this.log("Unable to change user identity from debugger in Next.js") : e.data.type === "DEVCYCLE_REFRESH" ? this.updateIframeData() : e.data.type === "DEVCYCLE_TOGGLE_OVERLAY" && ($.current.expanded = !$.current.expanded, this.mainIframe.style.width = $.current.expanded ? "500px" : "0px", this.mainIframe.style.height = $.current.expanded ? "700px" : "0px", setTimeout(() => this.updateIframeData(), 10)));
	}
	log(...e) {
		this.debugLogs && console.log(...e);
	}
}, bc = async (e, { shouldEnable: t, shouldEnableVariable: n }) => {
	if (t !== void 0) {
		if (!t || typeof t == "function" && !t()) return !1;
	} else if (typeof n == "string") {
		if (await e.onClientInitialized(), !e.variableValue(n, !1)) return !1;
	} else if (!vc()) return !1;
	return !0;
}, xc = async (e, { shouldEnable: t, shouldEnableVariable: n, ...r } = {}) => {
	if (!await bc(e, {
		shouldEnable: t,
		shouldEnableVariable: n
	})) return () => {};
	let i = new yc(e, r);
	document.readyState === "complete" || document.readyState === "interactive" ? i.createIframesWhenReady() : document.addEventListener("DOMContentLoaded", () => {
		i.createIframesWhenReady();
	});
	let a = i.setupSubscriptions();
	return () => {
		a(), document.body.contains(i.mainIframe) && document.body.removeChild(i.mainIframe), document.body.contains(i.buttonIframe) && document.body.removeChild(i.buttonIframe);
	};
}, Sc = {
	user_id: "anonymous",
	email: "anonymous@worktango.com"
}, Cc = ko.default.default, wc, Tc, Ec = !1;
function Dc({ children: e }) {
	return /* @__PURE__ */ o(_c, { children: e });
}
var Oc = async (e) => {
	if (Ec = e?.strictMode ?? !1, !e.sdkKey && Ec) throw Error("⚠️ Feature flag client SDK key is not set");
	if (!e.sdkKey) {
		console.warn("⚠️ Feature flag client SDK key is not set");
		return;
	}
	let t = { disableAutomaticEventLogging: !0 };
	try {
		wc = new Cc(e.sdkKey, {
			...t,
			...e.options ?? {}
		}), await jc(e.user || Sc), await Bs.setProviderAndWait(wc), Tc = wc.devcycleClient, Tc && e.shouldEnableDebugger && await xc(Tc, { shouldEnable: !0 });
	} catch (e) {
		if (Tc = null, Ec) throw console.error("⚠️ Error initializing feature flag provider", e), e;
		console.warn("⚠️ Error initializing feature flag provider", e);
	}
}, kc = Sc;
async function Ac(e) {
	await Bs.setContext(e);
}
var jc = async (e) => {
	kc = e;
	try {
		await Ac(e), kc !== e && await Ac(kc);
	} catch (t) {
		throw kc !== e && await Ac(kc), t;
	}
}, Mc = () => Bs.getClient();
function Nc(e = Mc()) {
	if (!e && !Ec) return console.warn("⚠️ Feature flag client is not initialized"), !1;
	if (!e && Ec) throw Error("⚠️ Feature flag client is not initialized");
	return !0;
}
function Pc(e, t) {
	return Nc() ? Mc().getBooleanValue(e, t) : t;
}
function Fc(e, t) {
	return Nc() ? Mc().getStringValue(e, t) : t;
}
function Ic(e, t, n) {
	return Nc() ? dc(e, t, n) : t;
}
function Lc(e, t, n) {
	return Nc() ? pc(e, t, n) : t;
}
//#endregion
export { Dc as OpenFeatureProvider, Pc as getBooleanFlagValue, Mc as getFeatureFlagClient, Fc as getStringFlagValue, Oc as initializeFeatureFlagProvider, jc as setFeatureFlagUser, Ic as useBooleanFlagValue, Lc as useStringFlagValue };

//# sourceMappingURL=index.es.js.map